﻿/*
⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛
⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛
⬛⬛ Hexazero : Exa Constructoratin 0.1.1                                
⬛⬛ Reference website :                                               
⬛⬛ Core Developer :                                             
⬛⬛ Ui designer :                                                                                      
⬛⬛ Modifiers designer :                                         
⬛⬛ Theme and skins  :                                           
⬛⬛ Debug and test :           
⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛
⬛⬛ ☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰
⬛⬛ ██╗  ██╗    ███████╗    ██╗  ██╗     █████╗     ███████╗███████╗██████╗  ██████╗ 
⬛⬛ ██║  ██║    ██╔════╝    ╚██╗██╔╝    ██╔══██╗    ╚══███╔╝██╔════╝██╔══██╗██╔═══██╗
⬛⬛ ███████║    █████╗       ╚███╔╝     ███████║      ███╔╝ █████╗  ██████╔╝██║   ██║
⬛⬛ ██╔══██║    ██╔══╝       ██╔██╗     ██╔══██║     ███╔╝  ██╔══╝  ██╔══██╗██║   ██║
⬛⬛ ██║  ██║    ███████╗    ██╔╝ ██╗    ██║  ██║    ███████╗███████╗██║  ██║╚██████╔╝
⬛⬛ ╚═╝  ╚═╝    ╚══════╝    ╚═╝  ╚═╝    ╚═╝  ╚═╝    ╚══════╝╚══════╝╚═╝  ╚═╝ ╚═════╝     
⬛⬛  
⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛
⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛                      
*/
/*◘◘◘◘◘◘◘◘◘ COMMANDS ▼ ◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘*/
/*

%page.width%
%page.height%
%screen.width%
%screen.height%
 ------------------------------------------------
 motion="true"
 duration="0.5s"
 style="background-color:#000;"
 ------------------------------------------------
 css="background-color:red;" 
 css:hover="background-color:#ffd800;"
 css:active="background-color:#333;"
 class="className"

 Width="0px" 
 Height="0px" 
 MinWidth="0px" 
 MinHeight="0px" 
 MaxWidth="0px" 
 MaxHeight="0px" 
 MarginLeft="0px"
 MarginRight="0px" 
 MarginTop="0px" 
 MarginBottom="0px" 
 Margin="0px,0px,0px,0px"   
 Padding="0px,0px,0px,0px" 


<TextView ... text="Text %p% (</br>)  %s%  ( Space ) | %br% (</br>) 
<Typewriter type="Sequence" speed="10" >  
       <start  Value="2C-Animated" ></start>
       <stop   Value="2BR-Animated" ></stop>
</Typewriter>

<disable> </disable> 
<enable> </enable> 
*/
/*   ( ▲ ▼ ▶ ◀ 🔺 🔻 🔲 🔳 ⚫ ⚪ 🔴 🔵 🔶 🔷🔸 🔹 ◢ ◣◥ ◤ ◌ ◯ ◍ ☢ ❂ ❏ ❐ ❑ ❒ ▀ ▁ ▂ ▃ ▄ ▅ ▆ ▇ ▉ ▊ ▋ █ ▌ ▍ ▁▂▃▅▆ ▆▅▃▂▁ ▏

░ ▒  ▓  ▔  ▞ ▚  ▢ ▣ ▤ ▥ ▦ ▧ ▨  ▩ ▪  ▫ ▬  ▭ ▮ ▯ ☰ ☲ ☱ ☴ ☵ ☶ ☳ ☷ ⌘ ⌑ ◾ ◼ ⬛ ◽ ◻ ⬜ ◉ ◎ ● ■ □  ╔═╗ 🆗 ✘  ✔  ☒ ❎ ☑ 💊 💥 💀 ♒ 

╱ ━ ┏ ┛ ┗ ┓ ┃ ┫ ╋ ┣ ︱ ┻ ┳ , ╭ ╮ ╰ ╯ ╱ and ═ ╔ ╝ ╚ ╗ ║ ╣ ╬ ╠ ─ ╩ ╦  ↑↑↑

⬅ ⏪ ➰ ➿ ⇏ 🔃  ➧ ➟ ➜ ➨ ➽ ➼ 🌟 ☄ ✹ ✦ 🌠 ✱ ✲ ★ ✪ ✺ ⛺ 👑 🔮 🅰🅳🅳 🅽🅴🆆  🆃🅴🆂🆃 🆃🅴🅼🅿 🆁🅴🅼🅾🆅🅴 🅳🅾🅽🅴  ➊ ➋ ➌ ☀💡 🚧  ✎ ◘ ⏩  

*/

/*◘◘◘◘◘◘◘◘◘ COMMANDS ▲ ◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘*/

/*↓↓↓↓↓ • Events • ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓*/
window.addEventListener("load", function () {
    ECloadInitializing();
});
function ECloadInitializing() {
    ECKeyEffects(true, "load");
    ECInitializing();
    ECRenderingPosition();
    ECRenderingAnimated();
    ECICodeExecuted();
    ECDecorator(true);
    ECDecorator(false);
    ECComponentsInitializing();
    ECInitializinCssData(false);
}
window.addEventListener("resize", function () {
    ECResizeInitializing();
});
function ECResizeInitializing() {
    ECKeyEffects(false, "resize");
    ECRenderingPosition();
    ECRenderingAnimated();
    ECDecorator(false);
    ECBoardViewRenderingPosition();
}
/*↑↑↑↑↑ • Events • ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑*/

/*╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱*/
/*◘◘◘◘◘◘◘◘◘ Initializing ▼ ◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘*/
/*⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛*/

function ECInitializingConfig() {
    try {

        var LandingElement = document.getElementsByTagName("head")[0];
        var CreateStartBoard = document.createElement("style");
        CreateStartBoard.setAttribute("type", "text/css");
        CreateStartBoard.setAttribute("id", "ecHideConstructTags");
        var ImportCssItems = "";
        ImportCssItems += " Timeline { visibility:hidden;position:fixed; }";
        CreateStartBoard.innerHTML = ImportCssItems;
        LandingElement.appendChild(CreateStartBoard);

    } catch (e) { alert(e.message); }
}
ECInitializingConfig();

var ECInitializingRegisterTags = ["grid", "TextView", "imageBox", "viewBox", "BoardView"];
var ECInitializingRegisterConfigTags = ["Timeline", "Decorator", "KeyEffects"];

var ECregisterDataKeys = ["ecComponentStyles", "ecComponentAnimateds", "ecAnimatedStyles", "ECConfigComponentClassStyle"];
var ECregisterAnimatedTags = ["LOCATION", "OPACITY", "BACKGROUND", "BORDER", "ROTATION", "SHADOW", "SIZE"];

var ECregisterAnimatedTimelineCommand = ["fixed", "stop", "pause", "clear", "return", "import", "jump"];

var ECCommandKeys = ["this.value", "this.event"];

var EcThisValueRegx = new RegExp(ECCommandKeys[0], "g");
var EcThisEventRegx = new RegExp(ECCommandKeys[1], "g");
function ECInitializinCssData(UseIn) {
    try {
        var getAsHead = document.getElementsByTagName("head")[0];
        var InCss = "";
        for (var r = 0; r < ECInitializingRegisterTags.length; r++) {
            var RTag = ECInitializingRegisterTags[r];
            InCss += ' ' + RTag + ' { visibility:hidden; } ';
        }
        if (UseIn == true) {
            var StyleOnload = document.createElement("style");
            StyleOnload.setAttribute("id", "EStyleOnloadSystem");
            StyleOnload.innerHTML = InCss;
            getAsHead.appendChild(StyleOnload);
        }
        if (UseIn == false) {
            var EStyleOnloadElc = document.getElementById("EStyleOnloadSystem");
            EStyleOnloadElc.parentNode.removeChild(EStyleOnloadElc);
        }


    } catch (e) { }
}
ECInitializinCssData(true);
function ECInitializing() {
    try {

        /*▁▂▃▅▆ 💡 View box ▆▅▃▂▁ ☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰ [ ▼ ]*/
        ECForeachElement("Tag", [ECInitializingRegisterTags[3]], function (Element, Value, Cc) {
            ECForeachByTargetElement(Element, ECInitializingRegisterTags, function (RElement, TElement, Ncc) {
                RElement.setAttribute("ec-VisualPort", "true");
            });
        });
        /*➰➰➰( 🔃 Inner tag expolorer  ▼ ▼ ▼ )➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰*/
        ECForeachElement("Tag", ECInitializingRegisterTags, function (Element, Value, Cc) {
            /*➽➽➽ View box 🌟 ▼ ▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦*/
            if (Value.toLowerCase() == ECInitializingRegisterTags[0].toLowerCase()) {
                ECGrid(Element, ECInitializingRegisterTags[0]);
            }
            /*➽➽➽ Text view 🌟 ▼ ▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦*/
            if (Value.toLowerCase() == ECInitializingRegisterTags[1].toLowerCase()) {
                ECTextView(Element, ECInitializingRegisterTags[1]);
            }
            /*➽➽➽ Image box 🌟 ▼ ▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦*/
            if (Value.toLowerCase() == ECInitializingRegisterTags[2].toLowerCase()) {
                ECImageBox(Element, ECInitializingRegisterTags[2]);
            }
            /*➽➽➽ Board view 🌟 ▼ ▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦*/
            if (Value.toLowerCase() == ECInitializingRegisterTags[4].toLowerCase()) {
                ECBoardView(Element, ECInitializingRegisterTags[4]);
            }

        });
        /*▁▂▃▅▆ ⛺ Inner view box ▆▅▃▂▁ ☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰ [ ▼ ]*/
        ECForeachElement("Tag", [ECInitializingRegisterTags[3]], function (Element, Value, Cc) {
            ECViewBox(Element, ECInitializingRegisterTags[3]);
            ECForeachByTargetElement(Element, ECInitializingRegisterTags, function (RElement, TElement, Ncc) {
                RElement.setAttribute("ec-VisualPort", "true");
            });
        });
        /*☴☴☴☴☴☴( 🔃 Config tags  ▼ ▼ ▼ )☴☴☴☴☴☴☴☴☴☴☴☴☴☴☴☴☴☴☴☴☴☴☴☴☴☴☴☴☴☴☴☴☴☴☴☴☴☴☴☴☴*/
        ECForeachElement("Tag", ECInitializingRegisterConfigTags, function (Element, Value, Cc) {
            if (Value.toLowerCase() == ECInitializingRegisterConfigTags[0].toLowerCase()) {
                ECTimeline(Element, null);
            }
        });


    } catch (e) { }
}
function ECICodeExecuted() {
    try {
        ECForeachElement("tag", ["style"], function (item, Value, Cc) {
            var getAnimated = item.getAttribute("Animated");
            var getDuration = 100;
            if (item.getAttribute("LoadTime") != null) {
                getDuration = parseInt(item.getAttribute("LoadTime"), 10);
            }
            if (getAnimated != null) {
                if (getAnimated.toLowerCase() == "destroy") {
                    setTimeout(function () {
                        item.innerHTML = '';
                    }, getDuration);

                }
            }

        });

    } catch (e) { }
}
function ECComponentsInitializing() {
    try {
        /*☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷*/
        /*➰➰➰➰➰➰{ 🌟🌟<BoardView>🌟🌟 INSTALL ENGINE   }➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰*/
        /*╭───────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────╮*/

        $('.ECTdContents').sortable({
            connectWith: '.ECTdContents',
            containment: '.ECTable',
            placeholder: 'PreviewHolder',
            over: function (event, ui) {
                /*
                try
                {
                   var placeholderElx = document.getElementById("TestPLS");
                   placeholderElx.innerHTML = '  .ECBoardView .STN-Contents  .PreviewHolder {width: 180px;height: 180px;float: left;background-color:#ffd800;} ';

                    var innerObject = ui.item[0];
                    var GetDimension = innerObject.getAttribute("dimension");
                    if (GetDimension.toLowerCase() == "STN".toLowerCase())
                    {
                      
                        placeholderElx.innerHTML = '  .ECBoardView .STN-Contents  .PreviewHolder {width: 180px;height: 180px;float: left;background-color:#ffd800;} ';
                    }
                    if (GetDimension.toLowerCase() == "VRD".toLowerCase())
                    {
                        
                        placeholderElx.innerHTML = '  .ECBoardView .STN-Contents  .PreviewHolder {width:360px;height: 180px;float: left;background-color:Red;} ';
                    }

                } catch (e) {}*/
            },
            out: function (event, ui) {

            },
            change: function (event, ui) {

            },
            start: function (event, ui) {

            },
            stop: function () {

            }

        });

        /*╰───────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────────╯*/
        /*➰➰➰➰➰➰{ 🌟🌟<BoardView>🌟🌟 INSTALL ENGINE   }➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰*/
        /*☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷*/



    } catch (e) { }
}
/*⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛*/
/*◘◘◘◘◘◘◘◘◘ Initializing ▲ ◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘*/
/*╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱*/

/*╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱*/
/*◘◘◘◘◘◘◘◘◘ Components ▼ ◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘*/
/*⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛*/
function ECViewBox(Element, ElementType) {
    try {

        var CreateIdx = "ec_" + ECRandomId();
        var Contents = ' ';
        ECForeachDocument([Element], ["Content"], function (inode, Filter, Cc) {
            Contents = '<div id="Content_' + CreateIdx + '" class="ecViewBoxContent"  >' + inode.innerHTML + '</div>';
        });
        /* ⬛⬛⬛ Animated Tags ⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛ */
        ECComponentReadAnimated(Element, CreateIdx);
        /****************************************************************/
        Element.innerHTML = '<div id="' + CreateIdx + '" class="ecViewBoxBody"  > <table class="ecViewBoxTable" width="100%" border="0" cellspacing="0" cellpadding="0"><tr><td class="ecViewBoxTd" >' + Contents + '</td></tr></table> </div>';


        ECComponentSyncRead(Element, CreateIdx, ElementType);

    } catch (e) { }
}
function ECGrid(Element, ElementType) {
    try {
        var CreateIdx = "ec_" + ECRandomId();
        var Contents = ' ';
        ECForeachDocument([Element], ["Content"], function (inode, Filter, Cc) {
            Contents = '<div id="Content_' + CreateIdx + '" class="ecGridContent"  >' + inode.innerHTML + '</div>';
        });
        /* ⬛⬛⬛ Animated Tags ⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛ */
        ECComponentReadAnimated(Element, CreateIdx);
        /****************************************************************/
        Element.innerHTML = '<div id="' + CreateIdx + '" class="ecGridBody"  > <table class="ecGridTable" width="100%" border="0" cellspacing="0" cellpadding="0"><tr><td class="ecGridTd"  >' + Contents + '</td></tr></table> </div>';

        ECComponentSyncRead(Element, CreateIdx, ElementType);

    } catch (e) { }
}
function ECTextView(Element, ElementType) {
    try {
        var CreateIdx = "ec_" + ECRandomId();
        var TextData = ' ';
        if (Element.getAttribute("text") != null) {
            TextData = Element.getAttribute("text");

            TextData = TextData.replace(/%br%/g, '</br>');
        }
        /* ⬛⬛⬛ Animated Tags ⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛ */
        ECComponentReadAnimated(Element, CreateIdx);
        /****************************************************************/
        /* ▧⬛▧ Typewriter Tags ⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧ 🔻 */
        //#GHN977874
        var TypewriterXmlData = ECReadDataTypewriter("TextViewTypewriters");
        ECForeachDocument([Element], ["Typewriter"], function (inode, Filter, Cc) {
            try {

                var TTypeStr = "null";
                if (inode.getAttribute("type") != null) {
                    TTypeStr = inode.getAttribute("type");
                }
                var TSpeedStr = "10";
                if (inode.getAttribute("speed") != null) {
                    TSpeedStr = inode.getAttribute("speed");
                }
                var AtterItem = ["['type','" + TTypeStr + "']", "['speed','" + TSpeedStr + "']"];
                var FindMotion = false;
                ECForeachDocument([inode], ["start", "stop"], function (InnerNode, InnerFilter, InnerCc) {

                    var InnerItemValue = "null";
                    if (InnerNode.getAttribute("value") != null) {
                        InnerItemValue = InnerNode.getAttribute("value");
                    }
                    AtterItem.push("['" + InnerFilter.toLowerCase() + "','" + InnerItemValue + "']");
                    FindMotion = true;
                });
                ECAddXmlDataItem(TypewriterXmlData, CreateIdx, "stp_" + CreateIdx, "span", AtterItem, "", false, null);
                if (FindMotion == true) {
                    TextData = "";
                }


            } catch (e) { }
        });
        /* ▧⬛▧ Typewriter Tags ⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧ 🔺 */
        Element.innerHTML = '<div id="' + CreateIdx + '" class="ecTextViewText"  >' + TextData + '</div>';
        ECComponentSyncRead(Element, CreateIdx, ElementType);
        /*-----[ Exclusive attributes ]-------------------------------------------------------------*/
        var AddCss = "";
        if (Element.getAttribute("FontSize") != null) {
            AddCss += " font-size:" + Element.getAttribute("FontSize") + ";";
        }
        if (Element.getAttribute("Foreground") != null) {
            AddCss += " color:" + Element.getAttribute("Foreground") + ";";
        }
        if (Element.getAttribute("fontFamily") != null) {
            AddCss += " font-family:" + Element.getAttribute("fontFamily") + ";";
        }
        if (Element.getAttribute("align") != null) {
            AddCss += " text-align:" + Element.getAttribute("align") + ";";
        }
        if (Element.getAttribute("fontWeight") != null) {
            AddCss += " font-Weight:" + Element.getAttribute("fontWeight") + ";";
        }
        ECAddComponentStyle(ECregisterDataKeys[0], Element, CreateIdx, "", AddCss);

    } catch (e) { }
}
function ECImageBox(Element, ElementType) {
    try {
        var CreateIdx = "ec_" + ECRandomId();
        /* ⬛⬛⬛ Animated Tags ⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛ */
        ECComponentReadAnimated(Element, CreateIdx);
        /****************************************************************/
        Element.innerHTML = '<div id="' + CreateIdx + '" class="ecImageBoxArea"  ></div>';
        ECComponentSyncRead(Element, CreateIdx, ElementType);
        /*-----[ Exclusive attributes ]-------------------------------------------------------------*/
        var AddCss = "";
        if (Element.getAttribute("src") != null && Element.getAttribute("src") != "") {
            AddCss += " background-image:url(" + Element.getAttribute("src") + ");";
        }
        var ImgSize = 'contain';
        if (Element.getAttribute("Stretch") != null) {
            var StretchStr = Element.getAttribute("Stretch").toLowerCase();
            if (StretchStr == "Uniform".toLowerCase()) {
                ImgSize = "contain";
            }
            if (StretchStr == "UniformFill".toLowerCase()) {
                ImgSize = "cover";
            }


        }
        var uniqueStyleKey = "Style_" + CreateIdx;
        if (Element.getAttribute("hover:src") != null && Element.getAttribute("hover:src") != "") {
            var AddOnsCss = " background-image:url(" + Element.getAttribute("hover:src") + ");";
            ECAddComponentStyle(uniqueStyleKey, Element, CreateIdx, ":hover", AddOnsCss);
        }
        if (Element.getAttribute("active:src") != null && Element.getAttribute("hover:src") != "") {
            var AddOnsCss = " background-image:url(" + Element.getAttribute("active:src") + ");";
            ECAddComponentStyle(uniqueStyleKey, Element, CreateIdx, ":active", AddOnsCss);
        }
        AddCss += "background-repeat:no-repeat;";
        AddCss += "background-position:center;";
        AddCss += "background-size:" + ImgSize + ";";

        ECAddComponentStyle(uniqueStyleKey, Element, CreateIdx, "", AddCss);

    } catch (e) { }
}
function ECBoardView(Element, ElementType) {
    try {



        var CreateIdx = "ec_" + ECRandomId();
        var MasterClassKey = "ecbv" + CreateIdx.replace(/_/g, '');
        MasterClassKey = MasterClassKey.toLowerCase();

        /* ⬛⬛⬛ Animated Tags ⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛ */
        ECComponentReadAnimated(Element, CreateIdx);
        /****************************************************************/

        Element.innerHTML = '<div id="' + CreateIdx + '"  class="ECBoardView"  ><div class="ECBody" id="body_' + CreateIdx + '" ><table id="table_' + CreateIdx + '" width="100%" border="0" cellspacing="0" cellpadding="0" class="ECTable" ><tr><td  id="items_' + CreateIdx + '" class="ECTableTd"  >' + Element.innerHTML + '</td></tr></table></div></div>';
        ECComponentSyncRead(Element, CreateIdx, ElementType);

        /*-----[ Exclusive attributes ]-------------------------------------------------------------*/
        var innerHTMLData = '';
        try {
            /*☰☰☰☰( 🌟🌟 Dimension=" 5,5 | Auto,Auto " )☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰ */
            var GetDimension = [10, 10];
            if (Element.getAttribute("Dimension") != null) {
                try {
                    var ExeDimension = Element.getAttribute("Dimension").split(',');
                    var GetX = 0;
                    if (ExeDimension[0].toLowerCase() != "auto".toLowerCase()) {
                        GetX = parseInt(ExeDimension[0], 10);
                    }
                    var GetY = 0;
                    if (ExeDimension[1].toLowerCase() != "auto".toLowerCase()) {
                        GetY = parseInt(ExeDimension[1], 10);
                    }
                    GetDimension = [GetX, GetY];
                } catch (e) {

                }
            }

            /*☰☰☰☰( 🌟🌟  ContextMenu=" false | true "  )☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰ */

            var ContextMenu = false;
            if (Element.getAttribute("ContextMenu") != null) {
                var GetContextMenu = Element.getAttribute("ContextMenu");
                ContextMenu = ECConvertToBoolean(GetContextMenu);
            }
            /*☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷*/

            var AddHolderNumber = GetDimension[0] * GetDimension[1];
            var innerElementItems = document.getElementById("items_" + CreateIdx);
            var InnerHtmlItems = '';
            var menuBaseItems = '';
            try {


                /*➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿*/
                /*↓↓↓↓↓ • Load items • ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓*/
                /*▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦*/
                for (var r = 0; r < AddHolderNumber; r++) {
                    var AddFillItem = '';
                    var ItemsRC = r + 1;
                    for (var Inr = 0; Inr < innerElementItems.childNodes.length; Inr++) {
                        var InnerNode = innerElementItems.childNodes[Inr];
                        if (InnerNode.nodeType == Node.ELEMENT_NODE && InnerNode.nodeName.toLowerCase() == "Boards".toLowerCase()) {

                            for (var TInr = 0; TInr < InnerNode.childNodes.length; TInr++) {
                                var BoardNode = InnerNode.childNodes[TInr];
                                if (BoardNode.nodeType == Node.ELEMENT_NODE && BoardNode.nodeName.toLowerCase() == "Board".toLowerCase()) {
                                    if (BoardNode.getAttribute("locationId") != null) {
                                        var GetlocationId = BoardNode.getAttribute("locationId");
                                        var locationId = parseInt(GetlocationId, 10);
                                        if (locationId == ItemsRC) {
                                            var ContentHtmlData = '';
                                            var SetOnClick = '';
                                            for (var CInr = 0; CInr < BoardNode.childNodes.length; CInr++) {
                                                var ContentNode = BoardNode.childNodes[CInr];
                                                if (ContentNode.nodeType == Node.ELEMENT_NODE && ContentNode.nodeName.toLowerCase() == "html".toLowerCase()) {

                                                }
                                                if (ContentNode.nodeType == Node.ELEMENT_NODE && ContentNode.nodeName.toLowerCase() == "icon".toLowerCase()) {
                                                    var AdonsMenuXml = "";
                                                    try {
                                                        for (var icnr = 0; icnr < ContentNode.childNodes.length; icnr++) {
                                                            var INIcoBoardNode = ContentNode.childNodes[icnr];
                                                            if (INIcoBoardNode.nodeType == Node.ELEMENT_NODE && INIcoBoardNode.nodeName.toLowerCase() == "icon.menu".toLowerCase()) {
                                                                AdonsMenuXml = INIcoBoardNode.innerHTML;
                                                            }
                                                        }
                                                    } catch (e) { }
                                                    try {

                                                        var GetIconSrc = '';
                                                        if (ContentNode.getAttribute("src") != null) { GetIconSrc = ContentNode.getAttribute("src"); }

                                                        var GetIconClick = '';
                                                        if (ContentNode.getAttribute("click") != null) { GetIconClick = ContentNode.getAttribute("click"); }

                                                        var GetIconText = '';
                                                        if (ContentNode.getAttribute("text") != null) { GetIconText = ContentNode.getAttribute("text"); }
                                                        var imgStl = '';
                                                        if (GetIconSrc.trim() != '') {
                                                            imgStl = 'background-image:url(' + GetIconSrc + ');';
                                                        }

                                                        var InnerHtmlICO = '';
                                                        InnerHtmlICO += ' <div class="BoardViewIconImage" style="' + imgStl + '" ></div> ';
                                                        InnerHtmlICO += ' <div class="BoardViewIconText">' + GetIconText + '</div> ';
                                                        ContentHtmlData = ' <div class="BoardViewIconBody"> ' + InnerHtmlICO + ' </div> ';
                                                        ContentHtmlData += ' <span xType="menu.adons" style="position:fixed;visibility:hidden;" > ' + AdonsMenuXml + ' </span> ';
                                                        if (GetIconClick != '') {
                                                            SetOnClick += ' ondblclick="' + GetIconClick + '" ';
                                                        }

                                                    } catch (e) {

                                                    }
                                                }
                                                if (ContentNode.nodeType == Node.ELEMENT_NODE && ContentNode.nodeName.toLowerCase() == "svg".toLowerCase()) {

                                                }
                                                if (ContentNode.nodeType == Node.ELEMENT_NODE && ContentNode.nodeName.toLowerCase() == "x.image".toLowerCase()) {

                                                }
                                            }
                                            /*🌠🌠🌠🌠🌠🌠🌠[ ★ ContextMenu HTML DATA ★ ]🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠 -▼- */
                                            if (ContextMenu == true) {
                                                var ItemRNDid = "ContextMenuItem_" + ECRandomId();

                                                SetOnClick += ' tabindex="1" oncontextmenu="ECBoardViewContextMenu(this,true)"  onblur="ECBoardViewContextMenu(this,false)" onclick="ECBoardViewContextMenu(this,false)" ';
                                            }
                                            /*🌠🌠🌠🌠🌠🌠🌠[ ★ ContextMenu HTML DATA ★ ]🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠 -▲- */
                                            AddFillItem = '<div id="' + ItemRNDid + '" isSelected="false" class="ECContent ' + MasterClassKey + '" dimension="VRD" ' + SetOnClick + ' xkey="' + CreateIdx + '" xType="icon" >' + ContentHtmlData + '</div>';
                                        }
                                    }

                                }
                            }

                        }

                    }
                    /*🌠🌠🌠🌠🌠🌠🌠[ ★ ContextMenu HTML DATA ★ ]🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠 -▼- */
                    var TileAttributes = "";
                    if (ContextMenu == true) {
                        TileAttributes += ' oncontextmenu="return false;" ';
                    }
                    /*🌠🌠🌠🌠🌠🌠🌠[ ★ ContextMenu HTML DATA ★ ]🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠 -▲- */
                    InnerHtmlItems += '<div class="ECTdContents ECContents" ' + TileAttributes + '   xkey="' + CreateIdx + '" >' + AddFillItem + '</div> ';
                }
                /*▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦*/
                /*↑↑↑↑↑ • Load items • ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑*/
                /*➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿*/


            } catch (e) {

            }
            /*✹✹✹✹( MENU LINK DATA )✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹*/
            var CContextMenuMasterClass = "ECBoardViewCM_" + ECRandomId();

            try {

                /*➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿*/
                /*↓↓↓↓↓ • Load Inner xml config • ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓*/
                /*✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹*/
                for (var Inr = 0; Inr < innerElementItems.childNodes.length; Inr++) {
                    var InnerNode = innerElementItems.childNodes[Inr];
                    if (InnerNode.nodeType == Node.ELEMENT_NODE && InnerNode.nodeName.toLowerCase() == "Board.menu".toLowerCase()) {
                        if (ContextMenu == true) {
                            /*✱✱✱✱✱✱✱[ ★ ADONS MENU ITEM DATA ★ ]✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱ -▼- */
                            try {
                                for (var TInr = 0; TInr < InnerNode.childNodes.length; TInr++) {
                                    var BoardNode = InnerNode.childNodes[TInr];
                                    if (BoardNode.nodeType == Node.ELEMENT_NODE && BoardNode.nodeName.toLowerCase() == "contents".toLowerCase()) {
                                        var targetAdons = "*";
                                        var HtmlItemsMenu = '';
                                        if (BoardNode.getAttribute("target") != null) {
                                            targetAdons = BoardNode.getAttribute("target");
                                        }
                                        var contexCount = 0;
                                        for (var CNInr = 0; CNInr < BoardNode.childNodes.length; CNInr++) {
                                            var ContexNode = BoardNode.childNodes[CNInr];
                                            if (ContexNode.nodeType == Node.ELEMENT_NODE && ContexNode.nodeName.toLowerCase() == "contex".toLowerCase())
                                            { contexCount += 1; }
                                        }

                                        HtmlItemsMenu += ECContextMenuXmlToHTMLItem(BoardNode, CContextMenuMasterClass, contexCount, 0, null);
                                        menuBaseItems += '<span target="' + targetAdons + '" >' + HtmlItemsMenu + '</span>';


                                    }
                                }

                            } catch (e) {

                            }
                            /*✱✱✱✱✱✱✱[ ★ ADONS MENU ITEM DATA ★ ]✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱✱ -▲- */
                        }
                    }
                }
                /*✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹✹*/
                /*↑↑↑↑↑ • Load Inner xml config • ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑*/
                /*➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿➿*/


            } catch (e) {

            }


            /*🌠🌠🌠🌠🌠🌠🌠[ ★ ContextMenu HTML DATA ★ ]🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠 -▼- */
            if (ContextMenu == true) {
                try {
                    /*➧➧➧➧➧➧[ ★ Context Menu In Table ★ ]➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧➧ -▼- */
                    try {
                        var TableElement = document.getElementById('table_' + CreateIdx);

                        TableElement.setAttribute("xkey", CreateIdx);
                        TableElement.setAttribute("xType", "area");
                        TableElement.setAttribute("tabindex", "1");
                        TableElement.setAttribute("oncontextmenu", "ECBoardViewContextMenu(this,true)");
                        TableElement.setAttribute("onblur", "ECBoardViewContextMenu(this,false)");
                        TableElement.setAttribute("onclick", "ECBoardViewContextMenu(this,false)");

                    } catch (e) {

                    }
                    /*➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰ -▲- */

                    var MenuStyle = '';
                    var UniqueUIUXMStyleKey = "BoardViewMUiUx_" + CreateIdx;
                    /*▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨*/
                    MenuStyle += ECCreateStyleProperty("z-index", "9999");
                    MenuStyle += ECCreateStyleProperty("position", "fixed");
                    MenuStyle += ECCreateStyleProperty("left", "10px");
                    MenuStyle += ECCreateStyleProperty("top", "10px");
                    MenuStyle += ECCreateStyleProperty("width", ECComponentStyleReader(innerElementItems, "menu", "width", "210px"));
                    MenuStyle += ECCreateStyleProperty("min-height", ECComponentStyleReader(innerElementItems, "menu", "minHeight", "50px"));
                    MenuStyle += ECCreateStyleProperty("background-color", ECComponentStyleReader(innerElementItems, "menu", "background", "#EEE"));
                    MenuStyle += ECCreateStyleProperty("border", ECComponentStyleReader(innerElementItems, "menu", "border", "1px solid #FFF"));
                    MenuStyle += ECCreateStyleProperty("box-shadow", ECComponentStyleReader(innerElementItems, "menu", "shadow", "0px 5px 6px rgba(0, 0, 0, 0.1)"));
                    /*════════════════════════════════════════════════════════════════════════════════════════════════════*/
                    ECComponentClassStyleReader(innerElementItems, "ECMenuStyle", function (xPropertyName, xPropertyValue) {
                        MenuStyle += ECCreateStyleProperty(xPropertyName, xPropertyValue);
                    });
                    /*▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔*/
                    /*☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷*/
                    /*▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨*/
                    var ContextMenuItem_Stl = '';
                    ContextMenuItem_Stl += ECCreateStyleProperty("border-bottom", ECComponentStyleReader(innerElementItems, "menu.item", "borderBottom", "1px solid #FFF"));
                    ContextMenuItem_Stl += ECCreateStyleProperty("border-top", ECComponentStyleReader(innerElementItems, "menu.item", "borderTop", "1px solid #CCC"));
                    /*☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷*/
                    /*▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨*/
                    var Table_Stl = '';
                    Table_Stl += ECCreateStyleProperty("border", "none");
                    Table_Stl += ECCreateStyleProperty("border-spacing", "0px");
                    Table_Stl += ECCreateStyleProperty("border-bottom", ECComponentStyleReader(innerElementItems, "menu.item", "borderTop", "1px solid #CCC"));
                    Table_Stl += ECCreateStyleProperty("border-top", ECComponentStyleReader(innerElementItems, "menu.item", "borderBottom", "1px solid #FFF"));
                    /*☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷*/
                    /*▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨*/
                    var TextLine_Stl = '';
                    TextLine_Stl += ECCreateStyleProperty("font-family", ECComponentStyleReader(innerElementItems, "menu.item", "fontFamily", "Calibri"));
                    TextLine_Stl += ECCreateStyleProperty("font-size", ECComponentStyleReader(innerElementItems, "menu.item", "fontSize", "14px"));
                    TextLine_Stl += ECCreateStyleProperty("padding", ECComponentStyleReader(innerElementItems, "menu.item", "padding", "4px"));
                    TextLine_Stl += ECCreateStyleProperty("padding-left", ECComponentStyleReader(innerElementItems, "menu.item", "paddingLeft", "6px"));
                    TextLine_Stl += ECCreateStyleProperty("padding-right", ECComponentStyleReader(innerElementItems, "menu.item", "paddingRight", "6px"));
                    TextLine_Stl += ECCreateStyleProperty("text-align", ECComponentStyleReader(innerElementItems, "menu.item", "TextAlign", "left"));
                    TextLine_Stl += ECCreateStyleProperty("color", ECComponentStyleReader(innerElementItems, "menu.item", "Foreground", "#000"));
                    /*☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷*/
                    /*▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨*/
                    var SubTextLine_Stl = '';
                    SubTextLine_Stl += ECCreateStyleProperty("font-family", ECComponentStyleReader(innerElementItems, "menu.sub.item", "fontFamily", "Calibri"));
                    SubTextLine_Stl += ECCreateStyleProperty("font-size", ECComponentStyleReader(innerElementItems, "menu.sub.item", "fontSize", "12px"));
                    SubTextLine_Stl += ECCreateStyleProperty("padding-left", ECComponentStyleReader(innerElementItems, "menu.sub.item", "paddingLeft", "4px"));
                    SubTextLine_Stl += ECCreateStyleProperty("padding-right", ECComponentStyleReader(innerElementItems, "menu.sub.item", "paddingRight", "4px"));
                    SubTextLine_Stl += ECCreateStyleProperty("text-align", ECComponentStyleReader(innerElementItems, "menu.sub.item", "TextAlign", "left"));
                    SubTextLine_Stl += ECCreateStyleProperty("color", ECComponentStyleReader(innerElementItems, "menu.sub.item", "Foreground", "#000"));
                    SubTextLine_Stl += ECCreateStyleProperty("opacity", ECComponentStyleReader(innerElementItems, "menu.sub.item", "Opacity", "0.7"));
                    /*☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷*/
                    /*▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨▨*/
                    var ContextMenuItem_Stl_HOVER = '';
                    ContextMenuItem_Stl_HOVER += ECCreateStyleProperty("background-color", ECComponentStyleReader(innerElementItems, "menu.item:hover", "Background", "#0072ff"));
                    ContextMenuItem_Stl_HOVER += ECCreateStyleProperty("cursor", "pointer");

                    var TextLine_Stl_HOVER = '';
                    TextLine_Stl_HOVER += ECCreateStyleProperty("color", ECComponentStyleReader(innerElementItems, "menu.item:hover", "Foreground", "#FFF"));

                    var SubTextLine_Stl_HOVER = '';
                    SubTextLine_Stl_HOVER += ECCreateStyleProperty("color", ECComponentStyleReader(innerElementItems, "menu.sub.item:hover", "Foreground", "#FFF"));

                    var TextHolder_Stl = '';
                    TextHolder_Stl += ECCreateStyleProperty("padding-top", ECComponentStyleReader(innerElementItems, "menu.item", "paddingTop", "5px"));
                    TextHolder_Stl += ECCreateStyleProperty("padding-bottom", ECComponentStyleReader(innerElementItems, "menu.item", "paddingBottom", "5px"));

                    var IconTD_Stl = '';
                    var PropertyIconWidth = 24;
                    var PropertyIconTDWidth = 34;
                    try {
                        var widthIconStr = ECComponentStyleReader(innerElementItems, "menu.item.icon", "width", "24px");;
                        var widthIconStrs = widthIconStr.replace(/px/g, '').replace(/Px/g, '').replace(/pX/g, '').replace(/PX/g, '');
                        PropertyIconWidth = parseInt(widthIconStrs, 10);
                        PropertyIconTDWidth = PropertyIconWidth + 2;

                    } catch (e) { }
                    IconTD_Stl += ECCreateStyleProperty("width", ECCreateStyleProperty("width", PropertyIconTDWidth + "px"));

                    var IconHolder_Stl = '';
                    IconHolder_Stl += ECCreateStyleProperty("width", ECCreateStyleProperty("width", PropertyIconTDWidth + "px"));
                    IconHolder_Stl += ECCreateStyleProperty("height", ECComponentStyleReader(innerElementItems, "menu.item.icon", "height", "24px"));
                    IconHolder_Stl += ECCreateStyleProperty("background-repeat", "no-repeat");
                    IconHolder_Stl += ECCreateStyleProperty("background-size", "contain");
                    IconHolder_Stl += ECCreateStyleProperty("background-position", "center");
                    IconHolder_Stl += ECCreateStyleProperty("margin", ECComponentStyleReader(innerElementItems, "menu.item.icon", "margin", "5px"));
                    IconHolder_Stl += ECCreateStyleProperty("padding", "0px");

                    var IconHolder_SVG = '';
                    IconHolder_SVG += ECCreateStyleProperty("fill", ECComponentStyleReader(innerElementItems, "menu.item/svg", "fill", "#111"));

                    var IconHolder_SVG_Hover = '';
                    IconHolder_SVG_Hover += ECCreateStyleProperty("fill", ECComponentStyleReader(innerElementItems, "menu.item:hover/svg", "fill", "#fff"));

                    InnerHtmlItems += ' <div id="ECBoardViewMenu_' + CreateIdx + '" xclass="' + CContextMenuMasterClass + '" xkey="' + CreateIdx + '" onmouseover="ECBoardViewContextMenuLock(this,true)" onmouseout="ECBoardViewContextMenuLock(this,false)" style="visibility:hidden;" class="ECMenuStyle" > <span id="ECBoardTMC_' + CreateIdx + '" target="t.adons" ></span> ' + menuBaseItems + ' <span id="ECBoardBMC_' + CreateIdx + '" target="b.adons"  ></span>   </div>';

                    ECAddComponentClassStyle(UniqueUIUXMStyleKey, Element, CreateIdx, [".ECMenuStyle ",
                       "." + CContextMenuMasterClass + " .ContextMenuItem",
                       "." + CContextMenuMasterClass + " .ContextMenuItem .Table",
                       "." + CContextMenuMasterClass + " .ContextMenuItem .TextLine",
                       "." + CContextMenuMasterClass + " .ContextMenuItem:hover",
                       "." + CContextMenuMasterClass + " .ContextMenuItem:hover .TextLine ",
                       "." + CContextMenuMasterClass + " .ContextMenuItem .SubText ",
                       "." + CContextMenuMasterClass + " .ContextMenuItem:hover .SubText ",
                       "." + CContextMenuMasterClass + " .ContextMenuItem .TextHolder ",
                       "." + CContextMenuMasterClass + " .ContextMenuItem .IconHolder ",
                       "." + CContextMenuMasterClass + " .ContextMenuItem .IconTD ",
                       "." + CContextMenuMasterClass + " .ContextMenuItem:hover  path ",
                       "." + CContextMenuMasterClass + " .ContextMenuItem path "], [MenuStyle,
                       ContextMenuItem_Stl,
                       Table_Stl,
                       TextLine_Stl,
                       ContextMenuItem_Stl_HOVER,
                       TextLine_Stl_HOVER,
                       SubTextLine_Stl,
                       SubTextLine_Stl_HOVER,
                       TextHolder_Stl,
                       IconHolder_Stl,
                       IconTD_Stl,
                       IconHolder_SVG_Hover,
                       IconHolder_SVG]);



                } catch (e)
                { }
            }
            /*🌠🌠🌠🌠🌠🌠🌠[ ★ ContextMenu HTML DATA ★ ]🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠🌠 -▲- */

            /*☰☰☰☰( 🌟🌟  TableMode=" Auto | limited "  )☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰ */

            var TableMode = "Auto";
            if (Element.getAttribute("TableMode") != null) {
                var GetTableMode = Element.getAttribute("TableMode");
                if (GetTableMode.toLowerCase() == "Auto".toLowerCase()) {
                    TableMode = "Auto";
                }
                if (GetTableMode.toLowerCase() == "limited".toLowerCase()) {
                    TableMode = "limited";
                }
                if (GetTableMode.toLowerCase() == "fit".toLowerCase()) {
                    TableMode = "fit";
                }
            }
            /*☰☰☰☰( 🌟🌟  TileScale=" None | Uniform  | Width  | Height"  )☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰ */

            var TileScale = "Fill";
            if (Element.getAttribute("TileScale") != null) {
                var GetTileScale = Element.getAttribute("TileScale");
                if (GetTileScale.toLowerCase() == "Uniform".toLowerCase()) {
                    TileScale = "Uniform";
                }
                if (GetTileScale.toLowerCase() == "Fill".toLowerCase()) {
                    TileScale = "Fill";
                }
                if (GetTileScale.toLowerCase() == "Width".toLowerCase()) {
                    TileScale = "Width";
                }
                if (GetTileScale.toLowerCase() == "Height".toLowerCase()) {
                    TileScale = "Height";
                }
            }
            /*☰☰☰☰( 🌟🌟  EnableBoards=" false | true "  )☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰ */
            var EnableBoards = false;
            if (Element.getAttribute("EnableBoards") != null) {
                var GetEnableBoards = Element.getAttribute("EnableBoards");
                if (GetEnableBoards.trim() != "") {
                    try {

                        EnableBoards = ECConvertToBoolean(GetEnableBoards);

                    } catch (e) { }
                }
            }
            /*☰☰☰☰( 🌟🌟  ItemPadding="4"  )☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰ */
            var ItemPadding = 4;
            if (Element.getAttribute("ItemPadding") != null) {
                var GetItemPadding = Element.getAttribute("ItemPadding");
                if (GetItemPadding.trim() != "") {
                    try {

                        ItemPadding = parseInt(GetItemPadding, 10);

                    } catch (e) { }
                }
            }
            /*☰☰☰☰( 🌟🌟  BoardSize="128,128"  )☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰ */
            var BoardSize = [128, 128];
            if (Element.getAttribute("BoardSize") != null) {
                var GetBoardSize = Element.getAttribute("BoardSize");
                if (GetBoardSize.trim() != "") {
                    try {
                        var SplitSize = GetBoardSize.split(',');
                        BoardSize = [parseInt(SplitSize[0], 10), parseInt(SplitSize[1], 10)];

                    } catch (e) { }
                }
            }
            /*☰☰☰☰( 🌟🌟  BaseFontSize="15"  )☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰ */
            var BaseFontSize = 15;
            if (Element.getAttribute("BaseFontSize") != null) {
                var GetBaseFontSize = Element.getAttribute("BaseFontSize");
                if (GetBaseFontSize.trim() != "") {
                    try {

                        BaseFontSize = parseInt(GetBaseFontSize, 10);

                    } catch (e) { }
                }
            }
            /*☷☷☷[ ⛺ Style options ⛺  /▼/ ]☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷ */
            var UniqueUIUXStyleKey = "BoardViewUiUx_" + CreateIdx;
            /*♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒*/
            var ContentStyleHoverAnimatedTime = "0.2s";
            var BodyStyle = '';
            var TableStyle = '';
            var ContentStyle = '';
            var TableTdStyle = '';
            var TdContentsStyle = '';
            var PreviewHolderStyle = '';

            var ContentItemIconBody = '';
            var ContentItemIconImage = '';
            var ContentItemIconText = '';
            var ContentStyleHover = '';
            var ContentStyleTextHover = '';
            var ContentStyleFocus = '';
            /*♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒*/
            if (TableMode.toLowerCase() == "limited".toLowerCase()) {
                try {
                    var RenderW = BoardSize[0] * GetDimension[0];
                    var RenderWidth = RenderW + GetDimension[0];
                    BodyStyle += ECCreateStyleProperty("width", RenderWidth + "px");

                } catch (e) {

                }

            }
            var ContentSize = [0, 0];
            try {
                var XItemPadding = ItemPadding * 2;
                ContentSize = [BoardSize[0] - XItemPadding, BoardSize[1] - XItemPadding];
            } catch (e) {

            }
            /*▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔*/
            BodyStyle += ECCreateStyleProperty("margin", "10px");
            BodyStyle += ECCreateStyleProperty("min-height", "300px");
            BodyStyle += ECCreateStyleProperty("float", "left");
            /*════════════════════════════════════════════════════════════════════════════════════════════════════════*/
            ECComponentClassStyleReader(innerElementItems, "ECBody", function (xPropertyName, xPropertyValue) {
                BodyStyle += ECCreateStyleProperty(xPropertyName, xPropertyValue);
            });
            /*▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔*/
            TableStyle += ECCreateStyleProperty("float", "left");
            TableStyle += ECCreateStyleProperty("width", "100%");
            TableStyle += ECCreateStyleProperty("outline", "0");
            /*════════════════════════════════════════════════════════════════════════════════════════════════════════*/
            ECComponentClassStyleReader(innerElementItems, "ECTable", function (xPropertyName, xPropertyValue) {
                TableStyle += ECCreateStyleProperty(xPropertyName, xPropertyValue);
            });
            /*▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔*/
            ContentStyle += ECCreateStyleProperty("width", ContentSize[0] + "px");
            ContentStyle += ECCreateStyleProperty("height", ContentSize[1] + "px");
            ContentStyle += ECCreateStyleProperty("float", "left");
            ContentStyle += ECCreateStyleProperty("border", ECComponentStyleReader(innerElementItems, "icon", "border", "1px solid transparent"));
            ContentStyle += ECCreateStyleProperty("border-radius", ECComponentStyleReader(innerElementItems, "icon", "borderRadius", "4px"));
            ContentStyle += ECCreateAnimatedStyleProperty(ContentStyleHoverAnimatedTime);
            ContentStyle += ECCreateStyleProperty("background-color", ECComponentStyleReader(innerElementItems, "icon", "Background", "rgba(255, 255, 255, 1)"));
            /*════════════════════════════════════════════════════════════════════════════════════════════════════════*/
            ECComponentClassStyleReader(innerElementItems, "ECContent", function (xPropertyName, xPropertyValue) {
                ContentStyle += ECCreateStyleProperty(xPropertyName, xPropertyValue);
            });
            /*▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔*/
            TdContentsStyle += ECCreateStyleProperty("width", ContentSize[0] + "px");
            TdContentsStyle += ECCreateStyleProperty("height", ContentSize[1] + "px");
            TdContentsStyle += ECCreateStyleProperty("float", "left");
            TdContentsStyle += ECCreateStyleProperty("padding", ItemPadding + "px");
            /*════════════════════════════════════════════════════════════════════════════════════════════════════════*/
            ECComponentClassStyleReader(innerElementItems, "ECTdContents", function (xPropertyName, xPropertyValue) {
                TdContentsStyle += ECCreateStyleProperty(xPropertyName, xPropertyValue);
            });
            /*▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔*/
            PreviewHolderStyle += ECCreateStyleProperty("width", ContentSize[0] + "px");
            PreviewHolderStyle += ECCreateStyleProperty("height", ContentSize[1] + "px");
            PreviewHolderStyle += ECCreateStyleProperty("float", "left");
            PreviewHolderStyle += ECCreateStyleProperty("border-radius", ECComponentStyleReader(innerElementItems, "preview", "borderRadius", "4px"));
            PreviewHolderStyle += ECCreateStyleProperty("border", ECComponentStyleReader(innerElementItems, "preview", "border", "1px solid transparent"));
            PreviewHolderStyle += ECCreateAnimatedStyleProperty(ContentStyleHoverAnimatedTime);
            PreviewHolderStyle += ECCreateStyleProperty("background-color", ECComponentStyleReader(innerElementItems, "preview", "background", "rgba(255, 216, 0, 0.5)"));
            /*════════════════════════════════════════════════════════════════════════════════════════════════════════*/
            ECComponentClassStyleReader(innerElementItems, "PreviewHolder", function (xPropertyName, xPropertyValue) {
                PreviewHolderStyle += ECCreateStyleProperty(xPropertyName, xPropertyValue);
            });
            /*▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔*/
            ContentItemIconBody += '';
            /*▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔*/
            try {
                var Nfs = BaseFontSize / 100 * BoardSize[0];
                var NfsInt = parseInt(Nfs, 10);
                if (NfsInt > 8) {
                    BaseFontSize = NfsInt;
                } else {
                    BaseFontSize = 8;
                }

            } catch (e) { }
            var ImageIconSize = [50, 30];
            try {
                var RBaseFontSize = BaseFontSize + 20;
                var ImageIconSizeH = ContentSize[1] - RBaseFontSize;
                ImageIconSize = [ContentSize[0], ImageIconSizeH];
            } catch (e) {

            }
            ContentItemIconImage += ECCreateStyleProperty("margin-top", "5px");
            ContentItemIconImage += ECCreateStyleProperty("background-position", "center");
            ContentItemIconImage += ECCreateStyleProperty("background-size", "contain");
            ContentItemIconImage += ECCreateStyleProperty("background-repeat", "no-repeat");
            ContentItemIconImage += ECCreateStyleProperty("width", ImageIconSize[0] + "px");
            ContentItemIconImage += ECCreateStyleProperty("height", ImageIconSize[1] + "px");
            /*════════════════════════════════════════════════════════════════════════════════════════════════════════*/
            ECComponentClassStyleReader(innerElementItems, "BoardViewIconImage", function (xPropertyName, xPropertyValue) {
                ContentItemIconImage += ECCreateStyleProperty(xPropertyName, xPropertyValue);
            });
            /*▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔*/
            ContentItemIconText += ECCreateStyleProperty("text-align", ECComponentStyleReader(innerElementItems, "icon", "TextAlign", "center"));
            ContentItemIconText += ECCreateStyleProperty("font-family", ECComponentStyleReader(innerElementItems, "icon", "FontFamily", "Calibri"));
            ContentItemIconText += ECCreateStyleProperty("font-weight", ECComponentStyleReader(innerElementItems, "icon", "fontWeight", "normal"));
            ContentItemIconText += ECCreateStyleProperty("font-size", BaseFontSize + "px");
            ContentItemIconText += ECCreateStyleProperty("padding", "5px");
            ContentItemIconText += ECCreateStyleProperty("color", ECComponentStyleReader(innerElementItems, "icon", "Foreground", "#000"));
            /*════════════════════════════════════════════════════════════════════════════════════════════════════════*/
            ECComponentClassStyleReader(innerElementItems, "BoardViewIconText", function (xPropertyName, xPropertyValue) {
                ContentItemIconText += ECCreateStyleProperty(xPropertyName, xPropertyValue);
            });
            /*▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔*/
            ContentStyleHover += ECCreateStyleProperty("background-color", ECComponentStyleReader(innerElementItems, "icon:hover", "Background", "#0094ff"));
            ContentStyleTextHover += ECCreateStyleProperty("color", ECComponentStyleReader(innerElementItems, "icon:hover", "Foreground", "#FFF"));
            ContentStyleHover += ECCreateStyleProperty("border", ECComponentStyleReader(innerElementItems, "icon:hover", "border", "1px solid transparent"));
            ContentStyleHover += ECCreateStyleProperty("border-radius", ECComponentStyleReader(innerElementItems, "icon:hover", "borderRadius", "4px"));
            ContentStyleHover += ECCreateStyleProperty("cursor", "pointer");
            ContentStyleHover += ECCreateAnimatedStyleProperty(ContentStyleHoverAnimatedTime);
            /*════════════════════════════════════════════════════════════════════════════════════════════════════════*/
            ECComponentClassStyleReader(innerElementItems, "ECContent:hover", function (xPropertyName, xPropertyValue) {
                ContentStyleHover += ECCreateStyleProperty(xPropertyName, xPropertyValue);
            });
            /*════════════════════════════════════════════════════════════════════════════════════════════════════════*/
            /*▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔*/
            ContentStyleFocus += ECCreateStyleProperty("outline", "0");
            ContentStyleFocus += ECCreateStyleProperty("border", ECComponentStyleReader(innerElementItems, "icon:focus", "border", "1px solid #0853ca"));
            ContentStyleFocus += ECCreateStyleProperty("background-color", ECComponentStyleReader(innerElementItems, "icon:focus", "background", "rgba(8, 83, 202, 0.2)"));
            /*════════════════════════════════════════════════════════════════════════════════════════════════════════*/
            ECComponentClassStyleReader(innerElementItems, "ECContent:focus", function (xPropertyName, xPropertyValue) {
                ContentStyleHover += ECCreateStyleProperty(xPropertyName, xPropertyValue);
            });
            /*════════════════════════════════════════════════════════════════════════════════════════════════════════*/
            /*♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒*/
            if (EnableBoards == true) {
                BodyStyle += ECCreateStyleProperty("border", ECComponentStyleReader(innerElementItems, "body", "border", "1px dashed Red"));

                TdContentsStyle += ECCreateStyleProperty("border-left", ECComponentStyleReader(innerElementItems, "Tile", "border", "1px dashed #555"));
                TdContentsStyle += ECCreateStyleProperty("border-top", ECComponentStyleReader(innerElementItems, "Tile", "border", "1px dashed #555"));
            }

            /*♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒♒*/
            ECAddComponentClassStyle(UniqueUIUXStyleKey, Element, CreateIdx,
                 [".ECBody ",
                     ".ECTable ",
                     ".ECContent ",
                     ".ECTableTd ",
                     ".ECTdContents ",
                     ".PreviewHolder ",
                     " .BoardViewIconBody ",
                     " .BoardViewIconImage ",
                     " .BoardViewIconText ",
                     ".ECContent:hover ",
                     ".ECContent:hover .BoardViewIconText ",
                     ".ECContent:focus"],
                [BodyStyle,
                    TableStyle,
                    ContentStyle,
                    TableTdStyle,
                    TdContentsStyle,
                    PreviewHolderStyle,
                    ContentItemIconBody,
                    ContentItemIconImage,
                    ContentItemIconText,
                    ContentStyleHover,
                    ContentStyleTextHover,
                    ContentStyleFocus]);

            /*☷☷☷[ ⛺ Style options ⛺  /▲/ ]☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷ */
            innerElementItems.innerHTML = InnerHtmlItems;
            ECBoardViewRenderingPosition();

        } catch (e) {

        }
    } catch (e) { }
}
/*▣▧▣▧▣▧▣ ⛺ Timeline ▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧ 🔻 */

/*░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░*/
/*╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱*/
/*➽➽➽🌟🌟🌟 Config system graphics 🌟🌟🌟 ▼ ▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦*/
var ECCPUFloatRange = 4;
var ECGPUFloatRange = 2;
var ECTimelineCreated = false;
var ECTimelineTimer = null;
var ECGTimelineTimer = null;
var ECTimelineEndClock = 0;
var ECTimelineStopClock = 0;
var ECTimelinePauseClock = 0;
var ECTimelineJumpClock = 0;
var ECTimelineCurrentClock = 0;
var ECCpuUpdateTimeline = false;
/*➽➽➽🌟🌟🌟 Config system graphics 🌟🌟🌟 ▲ ▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦*/
function ECTimeline(Element, ElementType) {
    try {


        /*🔻🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔻*/
        /*➰➰➰➰➰➰( Standard Attribute Value )➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰ */
        var DurationStr = "60";
        if (Element.getAttribute("duration") != null && Element.getAttribute("duration") != "") {
            DurationStr = Element.getAttribute("duration");
        }
        var ValueStr = "0";
        if (Element.getAttribute("value") != null && Element.getAttribute("value") != "") {
            ValueStr = Element.getAttribute("value");
        }
        var StreamingStr = "cpu";
        if (Element.getAttribute("streaming") != null && Element.getAttribute("streaming") != "") {
            StreamingStr = Element.getAttribute("streaming");
        }
        var SpeedStr = "1";
        if (Element.getAttribute("speed") != null && Element.getAttribute("speed") != "") {
            SpeedStr = Element.getAttribute("speed");
        }
        var StatusStr = "play";
        if (Element.getAttribute("status") != null && Element.getAttribute("status") != "") {
            StatusStr = Element.getAttribute("status");
        }
        var ControlPanelStr = "false";
        if (Element.getAttribute("ControlPanel") != null && Element.getAttribute("ControlPanel") != "") {
            ControlPanelStr = Element.getAttribute("ControlPanel");
        }
        var KeyEffectStr = "*";
        if (Element.getAttribute("Execute") != null && Element.getAttribute("Execute") != "") {
            KeyEffectStr = Element.getAttribute("Execute");
        }

        var Duration = parseInt(DurationStr, 10);
        var MiliDuration = Duration * 100;
        var Value = parseInt(ValueStr, 10);
        var Streaming = "cpu"; if (StreamingStr.toLowerCase() == 'gpu') { Streaming = "gpu"; }
        var Speed = parseInt(SpeedStr, 10);
        var Status = "play";

        if (StatusStr.toLowerCase() == 'stop') { Status = "stop"; }
        if (StatusStr.toLowerCase() == 'pause') { Status = "pause"; }
        if (StatusStr.toLowerCase() == 'sync') { Status = "sync"; }

        var ControlPanel = ECConvertToBoolean(ControlPanelStr);

        /*➰➰➰➰➰➰( Standard Attribute Value )➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰ */
        /*🔺🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔧🔺*/
        /*🔻☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷🔻*/
        /*➦➦➦➦➦➦➦ Run ◉LOAD◉ timeline  ➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽ */

        // alert(Streaming);

        var AnimatedStyles = ECReadMotionControlStyle(ECregisterDataKeys[2]);
        if (ECTimelineCreated == false && ElementType == null) {
            /*********************************************************************************************************************/
            /*╭━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━╮*/
            if (Element.getAttribute("id") == null || Element.getAttribute("id").trim() == "") {
                var NewTimeLineId = 'EcTimeLine_' + ECRandomId();
                Element.setAttribute("id", NewTimeLineId);
            }
            /*--------------------------------------------------------------------------------------------------------------------------------------------------*/
            try {

                /*---------------------------------------------------*/
                if (Status == "play" || Status == "sync") {
                    if (Streaming == "cpu") {
                        /*▭▭▭[ CPU & TIMER RENDER *JS ]▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭ 🔻 */
                        try {
                            var Cct = Value;
                            ECTimelineTimer = setInterval(function () {
                                //  Cct += 1;
                                //  /*---------------------------------------------------*/
                                //  var ConstructAnimated = ConstructAnimatedTagToCss(Element, Cct, Duration, 'live',"*","#", ECCPUFloatRange);//#CTMHN741101
                                //  var StopRender = false;
                                //  //#TMHN977874
                                ////  document.getElementById("GGHSSGSGSG").innerHTML = Cct;
                                //  /*/////////////////////// ⬛ Stop ///////////////////////////////////////////////*/
                                //  if (ConstructAnimated[1] == true)
                                //  {
                                //      StopRender = true;
                                //      Cct = 0;
                                //      clearInterval(ECTimelineTimer);
                                //      ECTimelineStopClock = Cct;
                                //      Element.setAttribute("status", "stop");
                                //  }
                                //  /*/////////////////////// || Pause ///////////////////////////////////////////////*/
                                //  if (ConstructAnimated[2] == true)
                                //  {
                                //      StopRender = true;
                                //      clearInterval(ECTimelineTimer);
                                //      ECTimelinePauseClock = Cct;
                                //      Element.setAttribute("status", "pause");


                                //  }
                                //  /*---------------------------------------------------*/
                                //  if (Cct == Duration)
                                //  {
                                //      StopRender = true;
                                //      clearInterval(ECTimelineTimer);
                                //      ECTimelineEndClock = Cct;
                                //      Element.setAttribute("status", "end");
                                //  }
                                //  /*---------------------------------------------------*/
                                //  if (StopRender == false)
                                //  {
                                //      var ConstructAnimatedData = ConstructAnimated[0];
                                //      AnimatedStyles.innerHTML = ConstructAnimatedData;
                                //      ECTimelineCurrentClock = Cct;

                                //  }

                            }, Speed, true);
                        } catch (e) {

                        }
                        /*▭▭▭[ CPU & TIMER RENDER *JS ]▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭ 🔺 */
                    }
                    if (Streaming == "gpu") {
                        /*▭▭▭[ GPU + TIMER RENDER *CSS ]▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭ 🔻 */
                        try {
                            var getElementRenderId = Element.getAttribute("id");
                            if (ConstructAnimatedGPUTimerRunKey == true) {


                            }
                            if (ConstructAnimatedGPUTimerRunKey == false) {
                                //**56075
                                //**XX56075
                                ECForeachDocument([Element], ECregisterAnimatedTimelineCommand, function (InElementNode, InNodeName, InNCc) {
                                    if (InNodeName.toLowerCase() == "import".toLowerCase()) {
                                        ConstructAnimatedImportTag(InElementNode, InNodeName, InNCc);
                                    }
                                });
                                ConstructAnimatedGPUTimerCreateArray(Element, Value, "normal");


                                ECTimelineTimer = setInterval(function () {
                                    //TTTTTTTTTTTT50***
                                    //var AnimatedStartlength = 0;
                                    ECTimelineCurrentClock = Value;
                                    var ConstructStartAnimatedGpu = ConstructAnimatedTagToCss(Element, ECTimelineCurrentClock, Duration, 'live', "*", "#", ECGPUFloatRange, KeyEffectStr); //#CTMHN741101
                                    AnimatedStyles.innerHTML = ConstructStartAnimatedGpu[0];

                                    // ECTimelineCurrentClock = AnimatedStartlength;
                                    ECGTimelineTimer = setInterval(function () {
                                        //###GGFSF10 
                                        //##SGW9010


                                        // ConstructAnimatedCallParallelEngine(true, getElementRenderId, ConstructAnimatedGPUTimePosition[0], ConstructAnimatedGPUTimePosition[1], Speed, Value);
                                        //##SGW9010
                                        //##QSGW9010
                                        var IsSyncPlay = false;
                                        if (Status == "sync") {
                                            IsSyncPlay = true;
                                        }

                                        ConstructAnimatedGPUTimerTick(Element, getElementRenderId, Duration, Speed, Value, false, KeyEffectStr, IsSyncPlay);

                                        clearInterval(ECGTimelineTimer);

                                        ConstructAnimatedGPUTimerRunKey = true;




                                    }, 30, true);

                                    clearInterval(ECTimelineTimer);
                                }, 5, true);
                            }


                        } catch (e) { }
                        /*▭▭▭[ GPU + TIMER RENDER *CSS ]▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭ 🔺 */
                    }
                }
               
                /*---------------------------------------------------*/
            } catch (e) { }
            /*╰────────────────────────────────────────────────────────────────────────────────────────────────────────────────╯*/
            /*********************************************************************************************************************/
            ECTimelineCreated = true;
            /*➥➥➥➥➥➥ Run ◉LOAD◉ timeline  ➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽ */
            /*🔺☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷🔺*/

        } else {
            if (ElementType != null) {
                try {
                    var GetTypeKey = ElementType[0];
                    if (GetTypeKey.toLowerCase() == 'ClockType'.toLowerCase()) {
                        var GetTypeValue = ElementType[1];
                        /*🔻☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶🔻*/
                        /*➦➦➦➦➦➦➦ Run ◉RESIZE◉ timeline  ➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽ */
                        if (GetTypeValue.toLowerCase() == 'Resize'.toLowerCase()) {

                            if (Status.toLowerCase() == 'pause'.toLowerCase() || Status.toLowerCase() == 'stop'.toLowerCase() || Status.toLowerCase() == 'end'.toLowerCase()) {
                                var StaticClockValue = 0;
                                if (Status.toLowerCase() == 'pause'.toLowerCase()) {
                                    StaticClockValue = ECTimelinePauseClock;
                                }

                                if (Status.toLowerCase() == 'stop'.toLowerCase()) {
                                    StaticClockValue = ECTimelineStopClock;
                                }
                                if (Status.toLowerCase() == 'end'.toLowerCase()) {
                                    StaticClockValue = ECTimelineEndClock;
                                }
                                if (StaticClockValue != 0) {
                                    var ConstructAnimated = ConstructAnimatedTagToCss(Element, StaticClockValue, null, 'static', "*", "#", ECCPUFloatRange, KeyEffectStr); //#CTMHN741101
                                    var ConstructAnimatedData = ConstructAnimated[0];
                                    AnimatedStyles.innerHTML = ConstructAnimatedData;

                                    //if (ConstructAnimatedData.trim() != "")
                                    //{
                                    //    if (ECcheckByHashData("ECComparisonStyleAnimated", ConstructAnimatedData) == false)
                                    //    {
                                    //        AnimatedStyles.innerHTML = ConstructAnimatedData;
                                    //    }
                                    //}

                                }
                            }
                            if (Streaming == "cpu") {

                            }
                            if (Streaming == "gpu") {

                            }
                        }
                        /*➥➥➥➥➥➥ Run ◉RESIZE◉ timeline  ➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽➽ */
                        /*🔺☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶🔺*/

                    }
                } catch (e) {

                }
            }

        }


    } catch (e) { }
}
/*╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱*/

/*░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░*/
/*▣▧▣▧▣▧▣ ⛺ Timeline ▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧ ▲ */

/*⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛*/
/*◘◘◘◘◘◘◘◘◘ Components ▲ ◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘*/
/*╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱*/
/*██████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████*/
/*◘◘◘◘◘◘◘◘◘ Components Options & Events ▼ ◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘*/
/*╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱*/
function ECBoardViewRenderingPosition() {
    try {
        ECForeachElement("Tag", [ECInitializingRegisterTags[4]], function (Element, Value, Cc) {
            try {

                var GetECkey = Element.getAttribute("ec-key");

                var TableMode = "Auto";
                if (Element.getAttribute("TableMode") != null) {
                    var GetTableMode = Element.getAttribute("TableMode");
                    if (GetTableMode.toLowerCase() == "Auto".toLowerCase()) {
                        TableMode = "Auto";
                    }
                    if (GetTableMode.toLowerCase() == "limited".toLowerCase()) {
                        TableMode = "limited";

                    }
                    if (GetTableMode.toLowerCase() == "fit".toLowerCase()) {
                        TableMode = "fit";
                    }

                }
                if (TableMode.toLowerCase() == "fit".toLowerCase()) {
                    try {
                        /*☰☰☰☰( 🌟🌟  TileScale=" None | Uniform  | Width  | Height"  )☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰ */

                        var TileScale = "Fill";
                        if (Element.getAttribute("TileScale") != null) {
                            var GetTileScale = Element.getAttribute("TileScale");
                            if (GetTileScale.toLowerCase() == "Uniform".toLowerCase()) {
                                TileScale = "Uniform";
                            }
                            if (GetTileScale.toLowerCase() == "Fill".toLowerCase()) {
                                TileScale = "Fill";
                            }
                            if (GetTileScale.toLowerCase() == "Width".toLowerCase()) {
                                TileScale = "Width";
                            }
                            if (GetTileScale.toLowerCase() == "Height".toLowerCase()) {
                                TileScale = "Height";
                            }
                        }


                        var GetTableElement = document.getElementById("table_" + GetECkey);
                        var GetBodyElement = document.getElementById("body_" + GetECkey);

                        var BodyRenderSize = ECElementRenderSize(GetBodyElement);
                        var BodyRenderSizeWidth = BodyRenderSize[0] + BodyRenderSize[2] + 30;
                        var BodyRenderSizeHeight = BodyRenderSize[1] + BodyRenderSize[3] + 30;

                        /*☰☰☰☰( 🌟🌟  Dimension 🌟🌟  )☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰ */
                        var GetDimension = [10, 10];
                        if (Element.getAttribute("Dimension") != null) {
                            try {
                                var ExeDimension = Element.getAttribute("Dimension").split(',');
                                var GetX = 0;
                                if (ExeDimension[0].toLowerCase() != "auto".toLowerCase()) {
                                    GetX = parseInt(ExeDimension[0], 10);
                                }
                                var GetY = 0;
                                if (ExeDimension[1].toLowerCase() != "auto".toLowerCase()) {
                                    GetY = parseInt(ExeDimension[1], 10);
                                }
                                GetDimension = [GetX, GetY];
                            } catch (e) {

                            }
                        }
                        /*☰☰☰☰( 🌟🌟  BoardSize 🌟🌟  )☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰ */
                        var BoardSize = [128, 128];
                        if (Element.getAttribute("BoardSize") != null) {
                            var GetBoardSize = Element.getAttribute("BoardSize");
                            if (GetBoardSize.trim() != "") {
                                try {
                                    var SplitSize = GetBoardSize.split(',');
                                    BoardSize = [parseInt(SplitSize[0], 10), parseInt(SplitSize[1], 10)];

                                } catch (e) { }
                            }
                        }
                        /*☰☰☰☰( 🌟🌟  BaseFontSize 🌟🌟  )☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰ */
                        var BaseFontSize = 15;
                        if (Element.getAttribute("BaseFontSize") != null) {
                            var GetBaseFontSize = Element.getAttribute("BaseFontSize");
                            if (GetBaseFontSize.trim() != "") {
                                try {

                                    BaseFontSize = parseInt(GetBaseFontSize, 10);

                                } catch (e) { }
                            }
                        }
                        /*☰☰☰☰( 🌟🌟  DoubleLineText 🌟🌟  )☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰ */
                        var DoubleLineText = false;
                        if (Element.getAttribute("DoubleLineText") != null) {
                            var GetDoubleLineText = Element.getAttribute("DoubleLineText");
                            if (GetDoubleLineText.trim() != "") {
                                try {

                                    DoubleLineText = ECConvertToBoolean(GetDoubleLineText);

                                } catch (e) { }
                            }
                        }
                        /*☰☰☰☰( 🌟🌟  ItemPadding="4"  )☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰☰ */
                        var ItemPadding = 4;
                        if (Element.getAttribute("ItemPadding") != null) {
                            var GetItemPadding = Element.getAttribute("ItemPadding");
                            if (GetItemPadding.trim() != "") {
                                try {

                                    ItemPadding = parseInt(GetItemPadding, 10);

                                } catch (e) { }
                            }
                        }
                        var FixdSize = [50, 50];
                        if (Element.getAttribute("FixdSize") != null) {
                            var GetFixdSize = Element.getAttribute("FixdSize");
                            if (GetFixdSize.trim() != "") {
                                try {
                                    var SplitSize = GetFixdSize.split(',');
                                    FixdSize = [parseInt(SplitSize[0], 10), parseInt(SplitSize[1], 10)];

                                } catch (e) { }
                            }
                        }
        
                        var GetAreaElement = document.getElementById(GetECkey);
                        var GetElementRenderSize = ECElementRenderSize(GetAreaElement);
                        var AreaWidth = GetElementRenderSize[0] + FixdSize[0];/*ECWindowWidth()*/
                        var AreaHeight = ECWindowHeight() + FixdSize[1];/*ECWindowHeight() GetElementRenderSize[1] - 10 */

                        var TTY = GetDimension[0] + 1;
                        var CVB = AreaWidth / TTY;

                        var NTY = GetDimension[1] + 1;
                        var NVB = AreaHeight / NTY;

                        var WSR = parseInt(CVB, 10);
                        var HSR = parseInt(NVB, 10);

                        if (GetTileScale.toLowerCase() == "Fill".toLowerCase()) {
                            BoardSize = [WSR, parseInt(NVB, 10)];

                        }
                        if (GetTileScale.toLowerCase() == "Uniform".toLowerCase() ||
                            GetTileScale.toLowerCase() == "Width".toLowerCase() ||
                            GetTileScale.toLowerCase() == "Height".toLowerCase())
                        {
                            var preWidth = WSR / BoardSize[0] * 100;
                            var UniformWidth = BoardSize[0] / 100 * preWidth;

                            var preHeight = HSR / BoardSize[1] * 100;
                            var UniformHeight = BoardSize[1] / 100 * preHeight;
                             
                            BoardSize = [UniformWidth, UniformWidth];

                            if (GetTileScale.toLowerCase() == "Width".toLowerCase())
                            {
                                BoardSize = [UniformWidth, UniformWidth];
                            }
                            if (GetTileScale.toLowerCase() == "Height".toLowerCase()) {
                                BoardSize = [UniformHeight, UniformHeight];
                            }


                        }

                        var RenderW = BoardSize[0] * GetDimension[0];
                        var RenderWidth = RenderW + GetDimension[0];

                        var ContentSize = [0, 0];
                        try {
                            var XItemPadding = ItemPadding * 2;
                            ContentSize = [BoardSize[0] - XItemPadding, BoardSize[1] - XItemPadding];
                        } catch (e) {

                        }




                        var UniqueUIUXStyleKey = "BoardViewUiUx_" + GetECkey;
                        ECUpdateComponentStyleByProperty(UniqueUIUXStyleKey, ".ECBody", ["width"], [RenderWidth + "px", ], false);
                        ECUpdateComponentStyleByProperty(UniqueUIUXStyleKey, ".ECContent", ["width", "height"], [ContentSize[0] + "px", ContentSize[1] + "px"], false);
                        ECUpdateComponentStyleByProperty(UniqueUIUXStyleKey, ".ECTdContents", ["width", "height"], [ContentSize[0] + "px", ContentSize[1] + "px"], false);
                        /*▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔*/
                        try {

                            var Nfs = BaseFontSize / 100 * BoardSize[0];
                            var NfsInt = parseInt(Nfs, 10);
                            if (NfsInt > 8)
                            {
                                BaseFontSize = NfsInt;
                            } else
                            {
                                BaseFontSize = 8;
                            }


                        } catch (e) { }
                      
                         
                        var ImageIconSize = [50, 30];
                        try {
                            var RBaseFontSize = BaseFontSize + 20;
                            var ImageIconSizeH = ContentSize[1] - RBaseFontSize;
                            var ImageIconSizeHF = ContentSize[0];
                            if (DoubleLineText == true) {
                                ImageIconSizeH = ImageIconSizeH - BaseFontSize;
                            }
                            ImageIconSize = [ImageIconSizeHF, ImageIconSizeH];
                        } catch (e) {

                        }
                        ECUpdateComponentStyleByProperty(UniqueUIUXStyleKey, ".BoardViewIconImage", ["width", "height"], [ImageIconSize[0] + "px", ImageIconSize[1] + "px"], false);
                        /*▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔▔*/

                        ECUpdateComponentStyleByProperty(UniqueUIUXStyleKey, ".BoardViewIconText", ["font-size"], [BaseFontSize + "px"], false);
                        ECUpdateComponentStyleByProperty(UniqueUIUXStyleKey, ".PreviewHolder", ["width", "height"], [ContentSize[0] + "px", ContentSize[1] + "px"], true);

                        if (ECWindowWidth() < BodyRenderSizeWidth)
                        {
                            /* 👑 New Render Size (ON) ▬▬▬▬▬▬▬▬▬▬▬▬▬▬▬▬▬▬▬▬▬▬▬▬▬▬▬▬▬▬▬▬▬▬▬▬▬▬▬▬▬▬ */
                            try {


                            } catch (e) { }

                        } else
                        {
                            /* 👑 New Render Size (OFF) ▬▬▬▬▬▬▬▬▬▬▬▬▬▬▬▬▬▬▬▬▬▬▬▬▬▬▬▬▬▬▬▬▬▬▬▬▬▬▬▬▬ */

                        }
                    } catch (e)
                    {}
                }

            } catch (e) { }
        });


    } catch (e) { }
}
var ECBoardViewContextMenuLockId = "";
var ECBoardViewContextMenuLockKey = false;
function ECBoardViewContextMenuLock(Element, IsLock) {
    try {
        if (ECBoardViewContextMenuLockId.trim() != "") {
            //  document.getElementById("TextTest").value = IsLock + " / " + ECBoardViewContextMenuLockId;
            ECBoardViewContextMenuLockKey = IsLock;
        }


    } catch (e) { }
}
function ECBoardViewContextKillMenu() {
    try {
        if (ECBoardViewContextMenuLockId.trim() != "") {
            var GetAsElement = document.getElementById(ECBoardViewContextMenuLockId);
            ECBoardViewContextMenuLockKey = false;
            ECBoardViewContextMenu(GetAsElement, false);
            ECBoardViewContextMenuLockId = "";
        }

    } catch (e) { }
}
function ECBoardViewContextMenuGroupToView(Element, RqType, AdOnsElement) {
    try {


        var MenuXKey = Element.getAttribute("xkey");
        var MenuXClass = Element.getAttribute("xclass");

        var FindTarget = false;
        for (var r = 0; r < Element.childNodes.length; r++) {
            var inode = Element.childNodes[r];
            if (inode.nodeType == Node.ELEMENT_NODE && inode.nodeName.toLowerCase() == "span".toLowerCase()) {
                inode.setAttribute("style", "visibility:hidden;position:fixed;");
            }
        }
        for (var r = 0; r < Element.childNodes.length; r++) {
            var inode = Element.childNodes[r];
            if (inode.nodeType == Node.ELEMENT_NODE && inode.nodeName.toLowerCase() == "span".toLowerCase()) {
                var Target = inode.getAttribute("target");

                if (RqType.toLowerCase() == "area".toLowerCase()) {
                    FindTarget = true;

                    if (Target.toLowerCase() == "area".toLowerCase()) {
                        inode.removeAttribute("style");
                    }
                }
                if (RqType.toLowerCase() == "icon".toLowerCase()) {
                    FindTarget = true;

                    if (Target.toLowerCase() == "icon".toLowerCase()) {
                        inode.removeAttribute("style");

                        try {
                            var TopMenuAdons = document.getElementById("ECBoardTMC_" + MenuXKey);
                            var BottomMenuAdons = document.getElementById("ECBoardBMC_" + MenuXKey);

                            for (var xir = 0; xir < AdOnsElement.childNodes.length; xir++) {
                                var XInode = AdOnsElement.childNodes[xir];
                                if (XInode.nodeType == Node.ELEMENT_NODE && XInode.nodeName.toLowerCase() == "span".toLowerCase()) {
                                    var XType = XInode.getAttribute("xtype");
                                    if (XType.toLowerCase() == "menu.adons".toLowerCase()) {

                                        var AccT = 0;
                                        var AccB = 0;
                                        for (var Axir = 0; Axir < XInode.childNodes.length; Axir++) {
                                            var XAInode = XInode.childNodes[Axir];
                                            if (XAInode.nodeType == Node.ELEMENT_NODE && XAInode.nodeName.toLowerCase() == "adons".toLowerCase()) {
                                                if (XAInode.getAttribute("location") != null) {

                                                    if (XAInode.getAttribute("location").toLowerCase() == "bottom".toLowerCase() ||
                                                        XAInode.getAttribute("location").toLowerCase() == "B".toLowerCase()) {

                                                        for (var ACxir = 0; ACxir < XAInode.childNodes.length; ACxir++) {
                                                            var CXInode = XAInode.childNodes[ACxir];
                                                            if (CXInode.nodeType == Node.ELEMENT_NODE && CXInode.nodeName.toLowerCase() == "contex".toLowerCase())
                                                            { AccB += 1; }
                                                        }
                                                    }
                                                    if (XAInode.getAttribute("location").toLowerCase() == "top".toLowerCase() ||
                                                        XAInode.getAttribute("location").toLowerCase() == "T".toLowerCase()) {
                                                        for (var ACxir = 0; ACxir < XAInode.childNodes.length; ACxir++) {
                                                            var CXInode = XAInode.childNodes[ACxir];
                                                            if (CXInode.nodeType == Node.ELEMENT_NODE && CXInode.nodeName.toLowerCase() == "contex".toLowerCase())
                                                            { AccT += 1; }
                                                        }
                                                    }

                                                }
                                            }
                                        }
                                        for (var Axir = 0; Axir < XInode.childNodes.length; Axir++) {
                                            var XAInode = XInode.childNodes[Axir];
                                            if (XAInode.nodeType == Node.ELEMENT_NODE && XAInode.nodeName.toLowerCase() == "adons".toLowerCase()) {
                                                var BorderSetter = 0;
                                                var AdonsLocation = "B";
                                                if (XAInode.getAttribute("location") != null) {
                                                    if (XAInode.getAttribute("location").toLowerCase() == "bottom".toLowerCase() ||
                                                        XAInode.getAttribute("location").toLowerCase() == "B".toLowerCase()) {
                                                        AdonsLocation = "B";
                                                        BorderSetter = 3;
                                                    }
                                                    if (XAInode.getAttribute("location").toLowerCase() == "top".toLowerCase() ||
                                                        XAInode.getAttribute("location").toLowerCase() == "T".toLowerCase()) {
                                                        AdonsLocation = "T";
                                                        BorderSetter = 1;
                                                    }
                                                }
                                                var GetInnerType = "*";
                                                if (XAInode.getAttribute("innerType") != null) {
                                                    GetInnerType = XAInode.getAttribute("innerType");
                                                }
                                                if (GetInnerType.toLowerCase() == "Clear".toLowerCase()) {
                                                    BorderSetter = 0;
                                                    for (var r = 0; r < Element.childNodes.length; r++) {
                                                        var inode = Element.childNodes[r];
                                                        if (inode.nodeType == Node.ELEMENT_NODE && inode.nodeName.toLowerCase() == "span".toLowerCase()) {
                                                            inode.setAttribute("style", "visibility:hidden;position:fixed;");
                                                        }
                                                    }
                                                }

                                                if (AdonsLocation == "B") {
                                                    var ItemRnder = ECContextMenuXmlToHTMLItem(XAInode, MenuXClass, AccB, BorderSetter, null);

                                                    var AdOnsId = AdOnsElement.getAttribute("id");
                                                    BottomMenuAdons.removeAttribute("style");

                                                    if (BottomMenuAdons.getAttribute("IsLoad") == null) {
                                                        BottomMenuAdons.setAttribute("IsLoad", "false");
                                                    }
                                                    if (BottomMenuAdons.getAttribute("LockId") == null) {
                                                        BottomMenuAdons.setAttribute("LockId", AdOnsId);
                                                    }
                                                    var AddNewHtmlItems = false;
                                                    if (ECConvertToBoolean(BottomMenuAdons.getAttribute("IsLoad")) == false) {
                                                        AddNewHtmlItems = true;

                                                    } else {
                                                        if (AdOnsId != BottomMenuAdons.getAttribute("LockId")) {
                                                            AddNewHtmlItems = true;
                                                        }
                                                    }
                                                    if (AddNewHtmlItems == true) {
                                                        BottomMenuAdons.innerHTML = ItemRnder;
                                                        BottomMenuAdons.setAttribute("IsLoad", "true");
                                                        BottomMenuAdons.setAttribute("LockId", AdOnsId);
                                                    }

                                                }
                                                if (AdonsLocation == "T") {
                                                    var ItemRnder = ECContextMenuXmlToHTMLItem(XAInode, MenuXClass, AccT, BorderSetter, null);
                                                    var AdOnsId = AdOnsElement.getAttribute("id");
                                                    TopMenuAdons.removeAttribute("style");
                                                    if (TopMenuAdons.getAttribute("IsLoad") == null) {
                                                        TopMenuAdons.setAttribute("IsLoad", "false");
                                                    }
                                                    if (TopMenuAdons.getAttribute("LockId") == null) {
                                                        TopMenuAdons.setAttribute("LockId", AdOnsId);
                                                    }
                                                    var AddNewHtmlItems = false;
                                                    if (ECConvertToBoolean(TopMenuAdons.getAttribute("IsLoad")) == false) {
                                                        AddNewHtmlItems = true;

                                                    } else {
                                                        if (AdOnsId != TopMenuAdons.getAttribute("LockId")) {
                                                            AddNewHtmlItems = true;
                                                        }
                                                    }
                                                    if (AddNewHtmlItems == true) {
                                                        TopMenuAdons.innerHTML = ItemRnder;
                                                        TopMenuAdons.setAttribute("IsLoad", "true");
                                                        TopMenuAdons.setAttribute("LockId", AdOnsId);
                                                    }

                                                }


                                            }
                                        }

                                    }


                                }
                            }
                        } catch (e) { }


                    }
                }
            }
        }



    } catch (e) { }
}
var ECBoardViewContextMenuInLayer = false;
function ECBoardViewContextMenu(Element, IsOpen) {
    try {
        var GetEventClient = ECEventClient();
        var GetEventElement = ECEventElement(Element);
        var getXType = Element.getAttribute("xType").toLowerCase();
        var getXkey = Element.getAttribute("xkey");
        var MenuElemnt = document.getElementById("ECBoardViewMenu_" + getXkey);
        var GetEventMenuElemnt = ECEventElement(MenuElemnt);
        if (getXType == "icon") {
            ECBoardViewContextMenuGroupToView(MenuElemnt, getXType, Element);
            ECBoardViewContextMenuInLayer = true;
            if (IsOpen == true) {

                var SetNW = GetEventElement.Width / 2;
                var SetNH = GetEventElement.Height / 2;

                var SetNT = GetEventElement.top + SetNH;
                var SetNL = GetEventElement.left + SetNW;

                var RenderWM = GetEventMenuElemnt.Width + SetNL;
                var RenderHM = GetEventMenuElemnt.Height + SetNT;

                if (RenderWM > ECWindowWidth()) {
                    var RNWL = ECWindowWidth() - GetEventMenuElemnt.Width;
                    var TNWL = RNWL - 24;
                    SetNL = TNWL;
                }
                if (RenderHM > ECWindowHeight()) {
                    var RNHL = ECWindowHeight() - GetEventMenuElemnt.Height;
                    var TNHL = RNHL - 24;
                    SetNT = TNHL;
                }

                MenuElemnt.style.visibility = 'visible';
                MenuElemnt.style.top = SetNT + 'px';
                MenuElemnt.style.left = SetNL + 'px';
                ECBoardViewContextMenuLockId = Element.getAttribute("id");

                Element.focus();
                ECBoardViewContextMenuUnSelector(getXkey, Element);

            }
            if (IsOpen == false) {
                if (ECBoardViewContextMenuLockKey == false) {
                    ECBoardViewContextMenuInLayer = false;
                    MenuElemnt.style.visibility = 'hidden';
                } else {
                    Element.focus();
                    ECBoardViewContextMenuUnSelector(getXkey, Element);
                }
            }
        }
        if (getXType == "area" && ECBoardViewContextMenuInLayer == false) {
            ECBoardViewContextMenuGroupToView(MenuElemnt, getXType, Element);
            if (IsOpen == true) {
                var SetNT = GetEventClient.top;
                var SetNL = GetEventClient.left;

                var RenderWM = GetEventMenuElemnt.Width + SetNL;
                var RenderHM = GetEventMenuElemnt.Height + SetNT;

                if (RenderWM > ECWindowWidth()) {
                    var RNWL = ECWindowWidth() - GetEventMenuElemnt.Width;
                    var TNWL = RNWL - 24;
                    SetNL = TNWL;
                }
                if (RenderHM > ECWindowHeight()) {
                    var RNHL = ECWindowHeight() - GetEventMenuElemnt.Height;
                    var TNHL = RNHL - 24;
                    SetNT = TNHL;
                }

                MenuElemnt.style.visibility = 'visible';
                MenuElemnt.style.top = SetNT + 'px';
                MenuElemnt.style.left = SetNL + 'px';
                ECBoardViewContextMenuLockId = Element.getAttribute("id");
                Element.focus();
                ECBoardViewContextMenuUnSelector(getXkey, Element);
            }
            if (IsOpen == false) {
                if (ECBoardViewContextMenuLockKey == false) {
                    ECBoardViewContextMenuInLayer = false;
                    MenuElemnt.style.visibility = 'hidden';
                } else {
                    Element.focus();
                    ECBoardViewContextMenuUnSelector(getXkey, Element);
                }
            }
        }


    } catch (e) { }
}
function ECBoardViewContextMenuUnSelector(XkeyStr, Element) {
    /*⌘⌘⌘⌘[+Clear class SELECTED ▼]⌘⌘⌘⌘⌘⌘⌘⌘⌘⌘⌘⌘⌘⌘⌘⌘⌘⌘⌘⌘⌘⌘⌘⌘⌘⌘*/
    try {
        var MasterClassKey = "ecbv" + XkeyStr.replace(/_/g, '');
        MasterClassKey = MasterClassKey.toLowerCase();
        var CLElements = document.getElementsByClassName(MasterClassKey);
        for (var xci = 0; xci < CLElements.length; ++xci) {
            var ClassItem = CLElements[xci];
            ClassItem.setAttribute("isSelected", "false");
        }
        Element.setAttribute("isSelected", "true");

    } catch (e) {

    }
    /*⌘⌘⌘⌘[+Clear class SELECTED ▲]⌘⌘⌘⌘⌘⌘⌘⌘⌘⌘⌘⌘⌘⌘⌘⌘⌘⌘⌘⌘⌘⌘⌘⌘⌘⌘*/
}
function ECContextMenuMouseCtrl(Element, OverType) {
    try {
        var GetAsXid = Element.getAttribute("xid");
        var GetAsXico = Element.getAttribute("xico");

        if (GetAsXico.trim() != "") {
            var XICO = GetAsXico.split(",");
            if (XICO[0].trim() != '' && XICO[0].trim().toLowerCase() != 'null'.toLowerCase() &&
                XICO[1].trim() != '' && XICO[1].trim().toLowerCase() != 'null'.toLowerCase()) {
                var IconElement = document.getElementById("ICON_" + GetAsXid);
                IconElement.setAttribute("style", "background-image:url(" + XICO[OverType] + ");");
            }
        }



    } catch (e) { }
}
function ECContextMenuHTMLItem(Text, SubText, Icon, IsLine, HtmlAttributes, HtmlKeys, ClassName, ContexHtml, SvgDataIcon, BGcolor) {
    var outers = "";
    try {
        var BaseIdx = "ECMItem_" + ECRandomId();
        var TextHtml = '';
        var IconHtml = '';
        var SubTextHtml = '';
        var UseInTextHolder = false;
        if (Text.trim() != '' && Text.trim().toLowerCase() != 'null'.toLowerCase()) {
            UseInTextHolder = true;
            TextHtml = '<div  class="TextLine" >' + Text + '</div>';
        }
        if (Icon[0].trim() != '' && Icon[0].trim().toLowerCase() != 'null'.toLowerCase())
        {
            IconHtml = '<td class="IconTD"  ><div class="IconHolder" id="ICON_' + BaseIdx + '" style="background-image:url(' + Icon[0] + ');" ></div></td>';
        }
        if (SvgDataIcon.trim() != '' && SvgDataIcon.trim().toLowerCase() != 'null'.toLowerCase()) {
            IconHtml = '<td class="IconTD"  ><div class="IconHolder" id="ICON_' + BaseIdx + '"  >' + SvgDataIcon + '</div></td>';
        }
        if (SubText.trim() != '' && SubText.trim().toLowerCase() != 'null'.toLowerCase()) {
            UseInTextHolder = true;
            SubTextHtml = '<div  class="SubText" >' + SubText + '</div>';
        }

        var TextHolder = [' ', ' '];
        if (UseInTextHolder == true) {
            TextHolder = ['<div  class="TextHolder" >', '</div>'];
        }
        var lineStl = '';
        if (IsLine == "*") {
            lineStl = 'border-top:none;';
        }
        if (IsLine == "TB") {
            lineStl = 'border-top:none;border-bottom:none;';
        }
        if (IsLine == "B") {
            lineStl = 'border-bottom:none;';
        }
        if (IsLine == "T") {
            lineStl = 'border-top:none;';
        }
        if (IsLine == "A") {
            lineStl = ' ';
        }
        var BGCS = '';
        if (BGcolor.trim() != "") {
            BGCS = 'background-color:' + BGcolor + ';';
        }

        outers = '<div id="' + BaseIdx + '" style="' + BGCS + '" class="' + ClassName + '" ' + HtmlKeys + ' > <div xid="' + BaseIdx + '" xIco="' + Icon[0] + ',' + Icon[1] + '" onmouseover="ECContextMenuMouseCtrl(this,1)"  onmouseout="ECContextMenuMouseCtrl(this,0)" style="' + lineStl + '" class="ContextMenuItem" ' + HtmlAttributes + '  ><table  style="' + lineStl + '" border="0" class="Table" width="100%" ><tr> ' + IconHtml + ' <td>  ' + TextHolder[0] + TextHtml + SubTextHtml + TextHolder[1] + ContexHtml + ' </td> </tr></table></div> </div>';

    } catch (e) {

    }
    return outers;
}
function ECContextMenuXmlToHTMLItem(BaseElement, MasterClass, AllCount, BorderSetter, CallBackEvent) {
    var outers = "";
    try {

        var CXcc = 0;
        for (var CNInr = 0; CNInr < BaseElement.childNodes.length; CNInr++) {
            var ContexNode = BaseElement.childNodes[CNInr];
            if (ContexNode.nodeType == Node.ELEMENT_NODE && ContexNode.nodeName.toLowerCase() == "contex".toLowerCase()) {
                CXcc += 1;
                var HtmlInnerData = "";
                var SvgInnerIcon = "";
                for (var INCNInr = 0; INCNInr < ContexNode.childNodes.length; INCNInr++) {
                    var INNERContexNode = ContexNode.childNodes[INCNInr];
                    if (INNERContexNode.nodeType == Node.ELEMENT_NODE && INNERContexNode.nodeName.toLowerCase() == "contex.html".toLowerCase()) {
                        HtmlInnerData = INNERContexNode.innerHTML;
                    }
                    if (INNERContexNode.nodeType == Node.ELEMENT_NODE && INNERContexNode.nodeName.toLowerCase() == "icon.svg".toLowerCase()) {
                        SvgInnerIcon = INNERContexNode.innerHTML;
                    }
                }
                var contexText = "";
                if (ContexNode.getAttribute("text") != null) {
                    contexText = ContexNode.getAttribute("text");
                }
                var contexIcon = "";
                if (ContexNode.getAttribute("icon") != null)
                {
                    contexIcon = ContexNode.getAttribute("icon");
                }
                var contexIconHover = "";
                if (ContexNode.getAttribute("iconHover") != null)
                {
                    contexIconHover = ContexNode.getAttribute("iconHover");
                }
                var contexClick = "";
                if (ContexNode.getAttribute("click") != null) {
                    contexClick = ContexNode.getAttribute("click");

                }
                var contexTitle = "";
                if (ContexNode.getAttribute("title") != null) {
                    contexTitle = ContexNode.getAttribute("title");
                }
                var contexBGcolor = "";
                if (ContexNode.getAttribute("BGcolor") != null) {
                    contexBGcolor = ContexNode.getAttribute("BGcolor");
                }
                var UseBottomBorder = "*";
                if (BorderSetter == 0) {
                    if (CXcc == AllCount) {
                        UseBottomBorder = "TB";
                    }
                }
                if (BorderSetter == 1) {
                    if (CXcc == AllCount) {
                        UseBottomBorder = "T";
                    }
                }
                if (BorderSetter == 2) {
                    if (CXcc == AllCount) {
                        UseBottomBorder = "B";
                    }
                }
                if (BorderSetter == 3) {
                    if (CXcc == 1) {
                        UseBottomBorder = "A";
                    }
                    if (CXcc == AllCount) {
                        UseBottomBorder = "TB";
                    }
                }
                outers += ECContextMenuHTMLItem(contexText, contexTitle, [contexIcon, contexIconHover], UseBottomBorder, ' onclick="ECBoardViewContextKillMenu();' + contexClick + '" ', "", MasterClass, HtmlInnerData, SvgInnerIcon, contexBGcolor);
            }
        }

    } catch (e) {


    }
    return outers;
}
function ECBoardViewCreateHtmlBoard(BaseId, xKey, TextTitle, IconSrc, xType, BaseStyle, Dimension, XmlAddons) {
    var outers = "";
    try {
        var MasterClassKey = "ecbv" + xKey.replace(/_/g, '');
        MasterClassKey = MasterClassKey.toLowerCase();
        var RootItemAttributes = "";
        RootItemAttributes += ' id="' + BaseId + '" ';/* ContextMenuItem_sr3dnvTPtYVu */
        RootItemAttributes += ' isselected="false" ';
        RootItemAttributes += ' class="ECContent ' + MasterClassKey + ' ui-sortable-handle" '; /*ECContent ecbvec8v6hzeclhagm ui-sortable-handle */
        RootItemAttributes += ' dimension="' + Dimension + '" '; /* VRD */
        RootItemAttributes += ' tabindex="1" ';
        RootItemAttributes += ' oncontextmenu="ECBoardViewContextMenu(this,true)" ';
        RootItemAttributes += ' onblur="ECBoardViewContextMenu(this,false)" ';
        RootItemAttributes += ' onclick="ECBoardViewContextMenu(this,false)" ';
        RootItemAttributes += ' xkey="' + xKey + '" '; /* ec_8v6hZEcLhaGM */
        RootItemAttributes += ' xtype="' + xType + '" '; /* icon */
        RootItemAttributes += ' style="' + BaseStyle + '" ';
        var BodyItems = '';
        BodyItems += ' <div class="BoardViewIconImage" style="background-image:url(' + IconSrc + ');" ></div> ';
        BodyItems += ' <div class="BoardViewIconText" >' + TextTitle + '</div> ';
        var BodyRender = '<div class="BoardViewIconBody" > ' + BodyItems + ' </div>';
        var XmlConfigs = '<span xtype="menu.adons" style="position:fixed;visibility:hidden;" >' + XmlAddons + '</span>';
        var outputRender = '<div ' + RootItemAttributes + ' >' + BodyRender + XmlConfigs + '</div>';
        outers = outputRender;
    } catch (e) { }
    return outers;
}
function ECBoardViewAddItemBoard(RootId, TableIndex, HtmlBoard) {
    try {
        var xCc = 0;
        var ListItemElc = document.getElementById("items_" + RootId);
        for (var r = 0; r < ListItemElc.childNodes.length; r++) {
            var inode = ListItemElc.childNodes[r];
            if (inode.nodeType == Node.ELEMENT_NODE && inode.nodeName.toLowerCase() == "DIV".toLowerCase()) {
                var getasXkey = inode.getAttribute("xkey");
                if (getasXkey == RootId) {
                    xCc += 1;
                    if (xCc == TableIndex) {
                        inode.innerHTML += HtmlBoard;
                    }
                }
            }
        }


    } catch (e) { }
}
function ECBoardViewEmptyItemBoardIndex(RootId, FindLast) {
    var outers = 0;
    try {
        var xCc = 0;
        var isFind = false;
        var ListItemElc = document.getElementById("items_" + RootId);
        for (var r = 0; r < ListItemElc.childNodes.length; r++) {
            var inode = ListItemElc.childNodes[r];
            if (inode.nodeType == Node.ELEMENT_NODE && inode.nodeName.toLowerCase() == "DIV".toLowerCase()) {
                var getasXkey = inode.getAttribute("xkey");
                if (getasXkey == RootId) {
                    xCc += 1;
                    if (inode.innerHTML.trim() == "") {
                        if (FindLast == false) {
                            if (isFind == false) {
                                outers = xCc;
                                isFind = true;
                            }
                        } else {
                            outers = xCc;
                        }
                    }
                }
            }
        }
    } catch (e) { }
    return outers;
}
/*╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱*/
/*◘◘◘◘◘◘◘◘◘ Components Options & Events ▲ ◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘*/
/*██████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████*/
/*╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱*/
/*◘◘◘◘◘◘◘◘◘ References ▼ ◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘*/
/*⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛*/
function ECTimelineSeek() {
    try {

    } catch (e) { }
}
function ECRenderingPosition() {
    try {
        var ComponentsStyle = ECReadMotionControlStyle("Components");
        var CollectCssData = '';
        ECForeachElement("Tag", ECInitializingRegisterTags, function (Element, Value, Cc) {
            CollectCssData += ECCalculatingPosition(Element);
            if (Value.toLowerCase() == ECInitializingRegisterTags[3].toLowerCase()) {
                ECForeachByTargetElement(Element, ECInitializingRegisterTags, function (RElement, TElement, Ncc) {

                    CollectCssData += ECCalculatingPositionByViewPort(Element, RElement, TElement);
                });
            }
        });
        ComponentsStyle.innerHTML = CollectCssData;

    } catch (e) { }
}
function ECStandardDataPosition(Element) {
    var outers = ["", false, false, false, "0.0s", ""];
    try {
        var EcKey = "";
        var IsRender = false;
        var VisualPort = false;
        var IsMotion = false;
        var EcDuration = "0.0s";
        for (var cvi = 0, atts = Element.attributes, ncv = atts.length, arr = []; cvi < ncv; cvi++) {
            var GetName = atts[cvi].nodeName.toLowerCase();
            var GetValue = Element.getAttribute(GetName);
            /*---[[ ec-key ]]---*/
            if (GetName == "ec-key") {
                EcKey = GetValue;
            }
            /*---[[ ec-render ]]---*/
            if (GetName == "ec-render") {
                IsRender = ECConvertToBoolean(GetValue);
            }
            /*---[[ ec-motion ]]---*/
            if (GetName == "ec-motion") {
                IsMotion = ECConvertToBoolean(GetValue);
            }
            /*---[[ ec-duration ]]---*/
            if (GetName == "ec-duration") {
                EcDuration = GetValue;
            }
            /*---[[ ec-VisualPort ]]---*/
            if (GetName == "ec-visualport") {
                VisualPort = ECConvertToBoolean(GetValue);
            }
        }
        outers = [EcKey, IsRender, VisualPort, IsMotion, EcDuration, Element.nodeName];

    } catch (e) { }
    return outers;
}
function ECCalculatingPosition(Element) {
    var outers = "";
    try {
        var GetStandardData = ECStandardDataPosition(Element);
        var EcKey = GetStandardData[0];
        var IsRender = GetStandardData[1];
        var VisualPort = GetStandardData[2];
        var IsMotion = GetStandardData[3];
        var EcDuration = GetStandardData[4];

        if (IsRender == true) {

            var RenderElement = document.getElementById(EcKey);
            var CssData = "";
            var CssHoverData = "";
            var CssActiveData = "";
            var RenderingCode = "";
            for (var cvi = 0, atts = Element.attributes, ncv = atts.length, arr = []; cvi < ncv; cvi++) {
                var GetName = atts[cvi].nodeName.toLowerCase();
                var GetValue = Element.getAttribute(GetName);
                if (GetValue.trim() != "") {
                    if (VisualPort == false) {
                        /*---[[ margin ]]---*/
                        if (GetName == "margin") {
                            var AsValue = ECConvertToCssValue(GetValue);
                            RenderingCode += "ma:" + AsValue + ";";
                            CssData += "margin:" + AsValue + ";";
                        }
                        /*---[[ padding ]]---*/
                        if (GetName == "padding") {
                            CssData += "padding:" + ECConvertToCssValue(GetValue) + ";";
                        }
                    }
                    /*---[[ CSS data ]]---*/
                    if (GetName == "css") {
                        CssData += GetValue;
                    }
                    /*---[[ CSS hover data ]]---*/
                    if (GetName == "css:hover") {
                        CssHoverData = GetValue;
                    }
                    /*---[[ CSS active data ]]---*/
                    if (GetName == "css:active") {
                        CssActiveData = GetValue;
                    }
                }
            }
            for (var cvi = 0, atts = Element.attributes, ncv = atts.length, arr = []; cvi < ncv; cvi++) {
                var GetName = atts[cvi].nodeName.toLowerCase();
                var GetValue = Element.getAttribute(GetName);
                if (GetValue.trim() != "") {
                    if (VisualPort == false) {
                        /*---[[ width ]]---*/
                        if (GetName == "width") {
                            var AsValue = ECConvertToCssValue(GetValue);
                            RenderingCode += "w:" + AsValue + ";";
                            CssData += "width:" + AsValue + ";";
                        }
                        /*---[[ height ]]---*/
                        if (GetName == "height") {
                            var AsValue = ECConvertToCssValue(GetValue);
                            RenderingCode += "h:" + AsValue + ";";
                            CssData += "height:" + AsValue + ";";
                        }
                    }
                    /*---[[ Min width ]]---*/
                    if (GetName == "minwidth") {
                        CssData += "min-width:" + ECConvertToCssValue(GetValue) + ";";
                    }
                    /*---[[ max width ]]---*/
                    if (GetName == "maxwidth") {
                        CssData += "max-width:" + ECConvertToCssValue(GetValue) + ";";
                    }

                    /*---[[ Min height ]]---*/
                    if (GetName == "minheight") {
                        CssData += "min-height:" + ECConvertToCssValue(GetValue) + ";";
                    }
                    /*---[[ max height ]]---*/
                    if (GetName == "maxheight") {
                        CssData += "max-height:" + ECConvertToCssValue(GetValue) + ";";
                    }
                    if (VisualPort == false) {
                        /*---[[ margin top ]]---*/
                        if (GetName == "margintop") {
                            var AsValue = ECConvertToCssValue(GetValue);
                            RenderingCode += "mt:" + AsValue + ";";
                            CssData += "margin-top:" + AsValue + ";";
                        }
                        /*---[[ margin Left ]]---*/
                        if (GetName == "marginleft") {
                            var AsValue = ECConvertToCssValue(GetValue);
                            RenderingCode += "ml:" + AsValue + ";";
                            CssData += "margin-left:" + AsValue + ";";
                        }
                        /*---[[ margin right ]]---*/
                        if (GetName == "marginright") {
                            var AsValue = ECConvertToCssValue(GetValue);
                            RenderingCode += "mr:" + AsValue + ";";
                            CssData += "margin-right:" + AsValue + ";";
                        }
                        /*---[[ margin Bottom ]]---*/
                        if (GetName == "marginbottom") {
                            var AsValue = ECConvertToCssValue(GetValue);
                            RenderingCode += "mb:" + AsValue + ";";
                            CssData += "margin-bottom:" + AsValue + ";";
                        }
                        /*---[[ padding top ]]---*/
                        if (GetName == "paddingtop") {
                            CssData += "padding-top:" + ECConvertToCssValue(GetValue) + ";";
                        }
                        /*---[[ padding left ]]---*/
                        if (GetName == "paddingleft") {
                            CssData += "padding-left:" + ECConvertToCssValue(GetValue) + ";";
                        }
                        /*---[[ padding right ]]---*/
                        if (GetName == "paddingright") {
                            CssData += "padding-right:" + ECConvertToCssValue(GetValue) + ";";
                        }
                        /*---[[ padding bottom ]]---*/
                        if (GetName == "paddingbottom") {
                            CssData += "padding-bottom:" + ECConvertToCssValue(GetValue) + ";";
                        }
                    }
                }
            }
            var MotionCssData = "";
            if (IsMotion == true) {
                MotionCssData += ECAnimatedCss(EcDuration);
            }
            outers = " #" + EcKey + "{" + CssData + MotionCssData + "} ";
            if (CssHoverData.trim() != "") {
                outers += " #" + EcKey + ":hover{" + CssHoverData + MotionCssData + "} ";
            }
            if (CssActiveData.trim() != "") {
                outers += " #" + EcKey + ":active{" + CssActiveData + MotionCssData + "} ";
            }
            Element.setAttribute("ec-rendering", RenderingCode);

        }
    } catch (e) { }
    return outers;
}
function ECScaleSizeCalculator(defaultSize, StretchTarget, NewSize) {
    var outers = [0, 0];
    try {
        if (StretchTarget == "width") {
            var getPrs = NewSize / defaultSize[0] * 100;
            var setHv = defaultSize[1] / 100 * getPrs;
            outers = [NewSize, parseInt(setHv, 10)];
        }
        if (StretchTarget == "height") {
            var getPrs = NewSize / defaultSize[1] * 100;
            var setHv = defaultSize[0] / 100 * getPrs;
            outers = [parseInt(setHv, 10), NewSize];
        }

    } catch (e) { }
    return outers;
}
function ECCalculatingPositionByViewPort(ViewPortElement, InnerElement, TElement) {
    var outers = "";
    try {
        var GetViewPort = [800, 600];
        if (ViewPortElement.getAttribute("viewPort") != null) {
            var getStrviewPort = ViewPortElement.getAttribute("viewPort").split(",");
            GetViewPort = [parseInt(ECConvertToCssValue(getStrviewPort[0]), 10), parseInt(ECConvertToCssValue(getStrviewPort[1]), 10)];

        }
        var ViewBoxRenderLive = [0, 0];
        if (ViewPortElement.getAttribute("ec-rendering") != null) {
            var ExeRendering = ViewPortElement.getAttribute("ec-rendering").replace(/px/g, '').split(";");
            var Wstr = '0';
            var Hstr = '0';
            for (var rt = 0; rt < ExeRendering.length; rt++) {
                var RdObject = ExeRendering[rt];
                if (RdObject.trim() != "") {
                    var getExeObj = RdObject.split(":");
                    var getObjKey = getExeObj[0];
                    var getObjValue = getExeObj[1];
                    if (getObjKey == 'w') { Wstr = getObjValue; }
                    if (getObjKey == 'h') { Hstr = getObjValue; }
                }
            }
            ViewBoxRenderLive = [parseInt(Wstr, 10), parseInt(Hstr, 10)];
        }
        /*---------------------------------------------------------------------------------*/
        var StretchWidth = ECScaleSizeCalculator(GetViewPort, "width", ViewBoxRenderLive[0]);
        var StretchHeight = ECScaleSizeCalculator(GetViewPort, "height", ViewBoxRenderLive[1]);
        var StretchSize = ViewBoxRenderLive;
        var StretchFill = false;
        if (ViewPortElement.getAttribute("Stretch") != null) {
            if (ViewPortElement.getAttribute("Stretch").toLowerCase() == "Fill".toLowerCase()) {
                StretchFill = true;
            }
        }
        if (StretchFill == false) {
            if (StretchHeight[0] > ViewBoxRenderLive[0]) {
                StretchSize = StretchWidth;
            }
            if (StretchWidth[1] > ViewBoxRenderLive[1]) {
                StretchSize = StretchHeight;
            }
        }
        if (ViewPortElement.getAttribute("ec-key") != null) {
            try {
                var ContentElemnet = document.getElementById("Content_" + ViewPortElement.getAttribute("ec-key"));
                ContentElemnet.style.width = StretchSize[0] + 'px';
                ContentElemnet.style.height = StretchSize[1] + 'px';
                var XAlign = "center";
                var YAlign = "none";
                if (ViewPortElement.getAttribute("ViewAlign") != null) {
                    var getViewAlign = ViewPortElement.getAttribute("ViewAlign").split(",");
                    XAlign = getViewAlign[0].toLowerCase();
                    YAlign = getViewAlign[1].toLowerCase();
                }
                if (XAlign == "center") {
                    ContentElemnet.style.margin = "0 auto";
                }
                if (XAlign == "left") {
                    ContentElemnet.style.cssFloat = "left";
                }
                if (XAlign == "right") {
                    ContentElemnet.style.cssFloat = "right";
                }
                if (YAlign == "top") {

                }
                if (YAlign == "bottom" || YAlign == "center") {
                    try {
                        var TopSpace = ViewBoxRenderLive[1] - StretchSize[1];
                        var TopSetter = TopSpace;
                        if (YAlign == "center") {
                            TopSetter = TopSpace / 2;
                        }
                        ContentElemnet.style.marginTop = TopSetter + "px";
                    } catch (e) { }
                }

            } catch (e) { }
        }
        /*---------------------------------------------------------------------------------*/
        var WPercentage = StretchSize[0] * 100 / GetViewPort[0];
        var HPercentage = StretchSize[1] * 100 / GetViewPort[1];
        /*---------------------------------------------------------------------------------*/
        var WidthPercentage = parseInt(WPercentage, 10);
        var HeightPercentage = parseInt(HPercentage, 10);
        /*---------------------------------------------------------------------------------*/
        var IsNoneWidth = false;
        var InnerElementWidth = 0;
        if (InnerElement.getAttribute("width") != null) {
            IsNoneWidth = true;
            InnerElementWidth = parseInt(InnerElement.getAttribute("width"), 10);
        }
        var IsNoneHeight = false;
        var InnerElementHeight = 0;
        if (InnerElement.getAttribute("height") != null) {
            IsNoneHeight = true;
            InnerElementHeight = parseInt(InnerElement.getAttribute("height"), 10);
        }
        var Location = [0, 0];
        if (InnerElement.getAttribute("Location") != null) {
            var LocationStr = InnerElement.getAttribute("Location").split(",");
            Location = [parseInt(LocationStr[0], 10), parseInt(LocationStr[1], 10)];
        }
        var WEPercentage = InnerElementWidth * WidthPercentage / 100;
        var HEPercentage = InnerElementHeight * HeightPercentage / 100;
        var XEPercentage = Location[0] * WidthPercentage / 100;
        var YEPercentage = Location[1] * HeightPercentage / 100;

        /*#####[ AnimatedUnRead ]###############################################################################*/
        ECSyncAnimatedUnRead(InnerElement, WidthPercentage, HeightPercentage);
        /*######################################################################################################*/

        var CssData = "";
        if (InnerElement.getAttribute("HorizontalAlignment") != null) {
            var HorizontalAlignmentStr = InnerElement.getAttribute("HorizontalAlignment").toLowerCase();
            if (HorizontalAlignmentStr == "center") {
                var AreaWidthCenter = StretchSize[0] / 2;
                var WidthCenter = WEPercentage / 2;
                var WidthSizeCenter = AreaWidthCenter - WidthCenter;
                var CenterLocation = WidthSizeCenter + XEPercentage;
                XEPercentage = CenterLocation;
                if (Location[0] == 0) {
                    CssData += "margin-left:" + XEPercentage + "px;";
                }
            }
            if (HorizontalAlignmentStr == "right") {
                var AreaWidthRight = StretchSize[0] - WEPercentage;
                var FitToLeft = XEPercentage + AreaWidthRight;
                XEPercentage = FitToLeft;
                if (Location[0] == 0) {
                    CssData += "margin-left:" + XEPercentage + "px;";
                }
            }

        }
        if (InnerElement.getAttribute("VerticalAlignment") != null) {
            var VerticalAlignmentStr = InnerElement.getAttribute("VerticalAlignment").toLowerCase();
            if (VerticalAlignmentStr == "center") {
                var AreaHeightCenter = StretchSize[1] / 2;
                var HeightCenter = HEPercentage / 2;
                var HeightSizeCenter = AreaHeightCenter - HeightCenter;
                var CenterLocation = HeightSizeCenter + YEPercentage;
                YEPercentage = CenterLocation;
                if (Location[1] == 0) {
                    CssData += "margin-top:" + YEPercentage + "px;";
                }
            }
            if (VerticalAlignmentStr == "bottom") {
                var AreaHeightTop = StretchSize[1] - HEPercentage;
                var FitToTop = YEPercentage + AreaHeightTop;

                YEPercentage = FitToTop;
                if (Location[1] == 0) {
                    CssData += "margin-top:" + FitToTop + "px;";
                }
            }
        }
        if (IsNoneWidth == true) { CssData += "width:" + WEPercentage + "px;"; }
        if (IsNoneHeight == true) { CssData += "height:" + HEPercentage + "px;"; }


        if (Location[0] != 0) {

            CssData += "margin-left:" + XEPercentage + "px;";
        }
        if (Location[1] != 0) {
            CssData += "margin-top:" + YEPercentage + "px;";
        }


        var GetStandardData = ECStandardDataPosition(InnerElement);
        var EcKey = GetStandardData[0];
        var IsRender = GetStandardData[1];
        var VisualPort = GetStandardData[2];
        var IsMotion = GetStandardData[3];
        var EcDuration = GetStandardData[4];
        /*|||||||[ GRID ▼ ]||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||*/
        if (TElement.toLowerCase() == ECInitializingRegisterTags[0].toLowerCase()) {
            CssData += "position:absolute;";

        }
        /*|||||||[ TEXTVIEW ▼ ]||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||*/
        if (TElement.toLowerCase() == ECInitializingRegisterTags[1].toLowerCase()) {
            CssData += "position:absolute;";

            if (InnerElement.getAttribute("FontSize") != null) {
                try {
                    var FontSize = parseInt(InnerElement.getAttribute("FontSize").replace(/p/g, '').replace(/x/g, '').replace(/P/g, '').replace(/X/g, ''), 10);
                    var PercentageFontSize = HeightPercentage + WidthPercentage;
                    var FontSizeRender = FontSize * PercentageFontSize / 100;

                    CssData += "font-size:" + FontSizeRender + "px;";

                } catch (e) { }
            }
        }
        /*|||||||[ IMAGE ▼ ]||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||*/
        if (TElement.toLowerCase() == ECInitializingRegisterTags[2].toLowerCase()) {
            CssData += "position:absolute;";
        }

        var MotionCssData = "";
        if (IsMotion == true) {
            MotionCssData += ECAnimatedCss(EcDuration);
        }
        outers = " #" + EcKey + "{" + CssData + MotionCssData + "} ";
        // document.getElementById("inputTest").value = WEPercentage + " | " + HEPercentage;
    } catch (e) { alert(e.message); }
    return outers;
}
function ECRenderingAnimated() {
    try {
        var HolderElc = ECReadDataAnimated(ECregisterDataKeys[1]);
        ECForeachDocument([HolderElc], ["span"], function (inode, Filter, Cc) {
            var getSpKey = inode.getAttribute("key");
            var GetTragetElement = ECConvertIdToElement(getSpKey);
            if (GetTragetElement != null) {
                var GetOption = ECStandardDataPosition(ECConvertRootElementToBase(getSpKey));
                var Visualport = GetOption[2];
                ECForeachDocument([inode], ["sync"], function (syncinode, syncFilter, syncCc) {
                    var GetSyncKey = syncinode.getAttribute("key");
                    var FromCss = "";
                    var ToCss = "";
                    ECForeachDocument([syncinode], ["animated"], function (AnimatedNode, AnimatedFilter, AnimatedCc) {
                        ECForeachDocument([AnimatedNode], ECregisterAnimatedTags, function (ItemNode, ItemFilter, ItemCc) {
                            if (ItemNode.getAttribute("from") != null) {
                                FromCss += ECParseAnimatedCodeToCss(ItemNode.getAttribute("from"), ItemFilter, 'NEV');
                            }
                            if (ItemNode.getAttribute("to") != null) {
                                ToCss += ECParseAnimatedCodeToCss(ItemNode.getAttribute("to"), ItemFilter, 'NEV');
                            }
                        });
                    });
                    var FindFrom = false;
                    ECForeachDocument([syncinode], ["From"], function (FromNode, FromFilter, FromCc) {
                        FindFrom = true;
                        FromNode.innerHTML = FromCss;
                    });
                    var FindTo = false;
                    ECForeachDocument([syncinode], ["To"], function (ToNode, ToFilter, ToCc) {
                        FindTo = true;
                        ToNode.innerHTML = ToCss;
                    });
                    if (FindFrom == false) {
                        syncinode.innerHTML += '<From>' + FromCss + '</From>';
                    }
                    if (FindTo == false) {
                        syncinode.innerHTML += '<To>' + ToCss + '</To>';
                    }
                });
            }

        });



    } catch (e) { }
    try {

        /*╱╱╱ Render resize by Clock ╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱*/
        ECForeachElement("Tag", ECInitializingRegisterConfigTags, function (Element, Value, Cc) {
            if (Value.toLowerCase() == ECInitializingRegisterConfigTags[0].toLowerCase()) {
                ECTimeline(Element, ['ClockType', 'Resize']);
            }
        });

    } catch (e) { }
}
//#GBMHN741101
function ConstructAnimatedTagToFiltersFixed(xValue) {
    var outers = "";
    try {


    } catch (e) { }
    return outers;
}
function ConstructAnimatedTagToCss(Element, Cct, Duration, OutputType, Filters, ExeXName, FloatRange, KeyEffect) {
    //#GBMHN741101
    var outers = ["", "", 0, 0, ""];
    try {
        var Collector = "";
        var CollectorNames = "";
        var OnTimelength = 0;
        var OnRootMap = 0;
        var FeedCommand = "";
        //###FSFAADSF10
        //#C70S1101


        if (OutputType.toLowerCase() == "remove.static".toLowerCase()) {
            //#C7sfsfsSW01
            // document.getElementById("GGHSSGSGSG").innerHTML += ExeXName + " </br> " + Filters;
            //ECReadCssIdAnimatedDataBaseBySequence(ExeXName, function (TargetIdx)
            //{

            //});


            //OutputType = "static";
        }

        //###FSFSF10
        //149774
        ConstructAnimatedLines(Duration, Element, Element, Cct, Cct, OutputType, FloatRange, Filters, KeyEffect, function (CssBack, Timelength, inode, xmlAname, xMetaCommand) {
            //****#80
            // CollectorNames += "#" + xmlAname;
            OnTimelength += Timelength;
            OnRootMap = 1;

            if (xMetaCommand.trim() != "") {
                var ReadxCommand = xMetaCommand.toLowerCase();
                if (ReadxCommand == "clear".toLowerCase()) {
                    // Collector = "";
                    // CollectorNames = xmlAname;
                    //  FeedCommand = ReadxCommand;
                }
            }
            Collector += CssBack;
            if (Cct > Timelength) {

                var NewCct = Cct - Timelength;

                ConstructAnimatedLines(Duration, inode, Element, Cct, NewCct, OutputType, FloatRange, Filters, KeyEffect, function (InCssBack, InTimelength, Ininode, xmlBname, xBMetaCommand) {

                    //****#80
                    OnTimelength += InTimelength;
                    // CollectorNames += "#" + xmlBname;
                    OnRootMap = 2;


                    if (xBMetaCommand.trim() != "") {
                        var ReadxCommand = xBMetaCommand.toLowerCase();
                        if (ReadxCommand == "clear".toLowerCase()) {
                            Collector = "";
                            CollectorNames = xmlAname;
                            FeedCommand = ReadxCommand;

                        }
                    }
                    Collector += InCssBack;
                    if (NewCct > InTimelength) {

                        /*▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅*/

                        var NewX2Cct = NewCct - InTimelength;

                        ConstructAnimatedLines(Duration, Ininode, Element, Cct, NewX2Cct, OutputType, FloatRange, Filters, KeyEffect, function (InX2CssBack, InX2Timelength, InX2inode, xml2name, x2MetaCommand) {

                            // CollectorNames += "#" + xml2name;
                            if (x2MetaCommand.trim() != "") {
                                var ReadxCommand = x2MetaCommand.toLowerCase();
                                if (ReadxCommand == "clear".toLowerCase()) {
                                    Collector = "";
                                    CollectorNames = xmlBname;
                                    FeedCommand = ReadxCommand;

                                }
                            }
                            Collector += InX2CssBack;
                            if (NewX2Cct > InX2Timelength) {
                                //****#80
                                OnTimelength += InX2Timelength;

                                OnRootMap = 3;


                                /*╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋*/

                                var NewX3Cct = NewX2Cct - InX2Timelength;
                                ConstructAnimatedLines(Duration, InX2inode, Element, Cct, NewX3Cct, OutputType, FloatRange, Filters, KeyEffect, function (InX3CssBack, InX3Timelength, InX3inode, xml3name, x3MetaCommand) {

                                    //****#80
                                    OnTimelength += InX3Timelength;
                                    //  CollectorNames += "#" + xml3name;

                                    OnRootMap = 4;


                                    if (x3MetaCommand.trim() != "") {
                                        var ReadxCommand = x3MetaCommand.toLowerCase();
                                        if (ReadxCommand == "clear".toLowerCase()) {
                                            Collector = "";
                                            CollectorNames = xml2name;
                                            //C1500
                                            FeedCommand = ReadxCommand;

                                        }
                                    }
                                    Collector += InX3CssBack;
                                    if (NewX3Cct > InX3Timelength) {


                                        /*╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋*/

                                        var NewX4Cct = NewX3Cct - InX3Timelength;

                                        ConstructAnimatedLines(Duration, InX3inode, Element, Cct, NewX4Cct, OutputType, FloatRange, Filters, KeyEffect, function (InX4CssBack, InX4Timelength, InX4inode, xml4name, x4MetaCommand) {
                                            //****#80
                                            OnTimelength += InX4Timelength;
                                            // CollectorNames += "#" + xml4name;

                                            OnRootMap = 5;

                                            //C1500

                                            if (x4MetaCommand.trim() != "") {
                                                var ReadxCommand = x4MetaCommand.toLowerCase();
                                                if (ReadxCommand == "clear".toLowerCase()) {
                                                    Collector = "";
                                                    CollectorNames = xml3name;
                                                    FeedCommand = ReadxCommand;


                                                }
                                            }
                                            Collector += InX4CssBack;
                                            if (NewX4Cct > InX4Timelength) {

                                                /*╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋*/

                                                var NewX5Cct = NewX4Cct - InX4Timelength;

                                                ConstructAnimatedLines(Duration, InX4inode, Element, Cct, NewX5Cct, OutputType, FloatRange, Filters, KeyEffect, function (InX5CssBack, InX5Timelength, InX5inode, xml5name, x5MetaCommand) {
                                                    //  CollectorNames += "#" + xml5name;
                                                    //****#80
                                                    OnTimelength += InX5Timelength;
                                                    OnRootMap = 6;


                                                    if (x4MetaCommand.trim() != "") {
                                                        var ReadxCommand = x5MetaCommand.toLowerCase();
                                                        if (ReadxCommand == "clear".toLowerCase()) {
                                                            Collector = "";
                                                            CollectorNames = xml4name;
                                                            FeedCommand = ReadxCommand;


                                                        }
                                                    }
                                                    Collector += InX5CssBack;
                                                    if (NewX5Cct > InX5Timelength) {


                                                        /*╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋*/

                                                        var NewX6Cct = NewX5Cct - InX5Timelength;

                                                        ConstructAnimatedLines(Duration, InX5inode, Element, Cct, NewX6Cct, OutputType, FloatRange, Filters, KeyEffect, function (InX6CssBack, InX6Timelength, InX6inode, xml6name, x6MetaCommand) {
                                                            //  CollectorNames += "#" + xml6name;
                                                            //****#80
                                                            OnTimelength += InX6Timelength;

                                                            OnRootMap = 7;
                                                            if (x6MetaCommand.trim() != "") {
                                                                var ReadxCommand = x6MetaCommand.toLowerCase();
                                                                if (ReadxCommand == "clear".toLowerCase()) {
                                                                    Collector = "";
                                                                    CollectorNames = xml5name;
                                                                    FeedCommand = ReadxCommand;

                                                                }
                                                            }
                                                            Collector += InX6CssBack;

                                                            if (NewX6Cct > InX6Timelength) {

                                                                /*╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋*/

                                                                var NewX7Cct = NewX6Cct - InX6Timelength;

                                                                ConstructAnimatedLines(Duration, InX6inode, Element, Cct, NewX7Cct, OutputType, FloatRange, Filters, KeyEffect, function (InX7CssBack, InX7Timelength, InX7inode, xml7name, x7MetaCommand) {

                                                                    //****#80
                                                                    OnTimelength += InX7Timelength;
                                                                    //  CollectorNames += "#" + xml7name;

                                                                    OnRootMap = 8;
                                                                    if (x7MetaCommand.trim() != "") {
                                                                        var ReadxCommand = x7MetaCommand.toLowerCase();
                                                                        if (ReadxCommand == "clear".toLowerCase()) {
                                                                            Collector = "";
                                                                            CollectorNames = xml6name;
                                                                            FeedCommand = ReadxCommand;

                                                                        }
                                                                    }
                                                                    Collector += InX7CssBack;

                                                                    if (NewX7Cct > InX7Timelength) {


                                                                        /*╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋*/

                                                                        var NewX8Cct = NewX7Cct - InX7Timelength;

                                                                        ConstructAnimatedLines(Duration, InX7inode, Element, Cct, NewX8Cct, OutputType, FloatRange, Filters, KeyEffect, function (InX8CssBack, InX8Timelength, InX8inode, xml8name, x8MetaCommand) {
                                                                            //****#80
                                                                            OnTimelength += InX8Timelength;
                                                                            //  CollectorNames += "#" + xml8name;

                                                                            OnRootMap = 9;
                                                                            if (x8MetaCommand.trim() != "") {
                                                                                var ReadxCommand = x8MetaCommand.toLowerCase();
                                                                                if (ReadxCommand == "clear".toLowerCase()) {
                                                                                    Collector = "";
                                                                                    CollectorNames = xml7name;
                                                                                    FeedCommand = ReadxCommand;

                                                                                }
                                                                            }
                                                                            Collector += InX8CssBack;

                                                                            if (NewX8Cct > InX8Timelength) {


                                                                                /*╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋*/

                                                                                var NewX9Cct = NewX8Cct - InX8Timelength;

                                                                                ConstructAnimatedLines(Duration, InX8inode, Element, Cct, NewX9Cct, OutputType, FloatRange, Filters, KeyEffect, function (InX9CssBack, InX9Timelength, InX9inode, xml9name, x9MetaCommand) {
                                                                                    //****#80
                                                                                    OnTimelength += InX9Timelength;
                                                                                    //  CollectorNames += "#" + xml9name;
                                                                                    OnRootMap = 10;
                                                                                    if (x9MetaCommand.trim() != "") {
                                                                                        var ReadxCommand = x9MetaCommand.toLowerCase();
                                                                                        if (ReadxCommand == "clear".toLowerCase()) {
                                                                                            Collector = "";
                                                                                            CollectorNames = xml8name;
                                                                                            FeedCommand = ReadxCommand;
                                                                                        }
                                                                                    }
                                                                                    Collector += InX9CssBack;

                                                                                    if (NewX9Cct > InX9Timelength) {
                                                                                        /*╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋*/

                                                                                        var NewX10Cct = NewX9Cct - InX9Timelength;

                                                                                        ConstructAnimatedLines(Duration, InX9inode, Element, Cct, NewX10Cct, OutputType, FloatRange, Filters, KeyEffect, function (InX10CssBack, InX10Timelength, InX10inode, xml10name, x10MetaCommand) {
                                                                                            //****#80
                                                                                            OnTimelength += InX10Timelength;
                                                                                            //  CollectorNames += "#" + xml10name;

                                                                                            OnRootMap = 11;


                                                                                            if (x10MetaCommand.trim() != "") {
                                                                                                var ReadxCommand = x10MetaCommand.toLowerCase();
                                                                                                if (ReadxCommand == "clear".toLowerCase()) {
                                                                                                    Collector = "";
                                                                                                    CollectorNames = xml9name;
                                                                                                    FeedCommand = ReadxCommand;
                                                                                                }
                                                                                            }
                                                                                            Collector += InX10CssBack;
                                                                                            if (NewX10Cct > InX10Timelength) {
                                                                                                /*╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋*/

                                                                                                var NewX11Cct = NewX10Cct - InX10Timelength;
                                                                                                ConstructAnimatedLines(Duration, InX10inode, Element, Cct, NewX11Cct, OutputType, Filters, FloatRange, KeyEffect, function (InX11CssBack, InX11Timelength, InX11inode, xml11name, x11MetaCommand) {
                                                                                                    //****#80
                                                                                                    OnTimelength += InX11Timelength;
                                                                                                    // CollectorNames += "#" + xml11name;
                                                                                                    OnRootMap = 12;


                                                                                                    if (x11MetaCommand.trim() != "") {
                                                                                                        var ReadxCommand = x11MetaCommand.toLowerCase();
                                                                                                        if (ReadxCommand == "clear".toLowerCase()) {
                                                                                                            Collector = "";
                                                                                                            CollectorNames = xml10name;
                                                                                                            FeedCommand = ReadxCommand;
                                                                                                        }
                                                                                                    }
                                                                                                    Collector += InX11CssBack;
                                                                                                    if (NewX11Cct > InX11Timelength) {

                                                                                                        /*╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋*/

                                                                                                        var NewX12Cct = NewX11Cct - InX11Timelength;
                                                                                                        ConstructAnimatedLines(Duration, InX11inode, Element, Cct, NewX12Cct, OutputType, Filters, FloatRange, KeyEffect, function (InX12CssBack, InX12Timelength, InX12inode, xml12name, x12MetaCommand) {
                                                                                                            //****#80
                                                                                                            OnTimelength += InX12Timelength;
                                                                                                            // CollectorNames += "#" + xml12name;
                                                                                                            OnRootMap = 13;
                                                                                                            if (x12MetaCommand.trim() != "") {
                                                                                                                var ReadxCommand = x12MetaCommand.toLowerCase();
                                                                                                                if (ReadxCommand == "clear".toLowerCase()) {
                                                                                                                    Collector = "";
                                                                                                                    CollectorNames = xml11name;
                                                                                                                    FeedCommand = ReadxCommand;
                                                                                                                }
                                                                                                            }
                                                                                                            Collector += InX12CssBack;

                                                                                                            if (NewX12Cct > InX12Timelength) {
                                                                                                                /*╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋*/

                                                                                                                var NewX13Cct = NewX12Cct - InX12Timelength;
                                                                                                                ConstructAnimatedLines(Duration, InX12inode, Element, Cct, NewX13Cct, OutputType, Filters, FloatRange, KeyEffect, function (InX13CssBack, InX13Timelength, InX13inode, xml13name, x13MetaCommand) {
                                                                                                                    //****#80
                                                                                                                    OnTimelength += InX13Timelength;
                                                                                                                    // CollectorNames += "#" + xml13name;
                                                                                                                    OnRootMap = 14;
                                                                                                                    if (x13MetaCommand.trim() != "") {
                                                                                                                        var ReadxCommand = x13MetaCommand.toLowerCase();
                                                                                                                        if (ReadxCommand == "clear".toLowerCase()) {
                                                                                                                            Collector = "";
                                                                                                                            CollectorNames = xml12name;
                                                                                                                            FeedCommand = ReadxCommand;
                                                                                                                        }
                                                                                                                    }
                                                                                                                    Collector += InX13CssBack;



                                                                                                                    if (NewX13Cct > InX13Timelength) {
                                                                                                                        /*╋╋ NEXT HERE > ╋╋╋╋╋*/
                                                                                                                    }
                                                                                                                });
                                                                                                                /*╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋*/
                                                                                                            }
                                                                                                        });
                                                                                                        /*╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋*/

                                                                                                    }
                                                                                                });
                                                                                                /*╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋*/
                                                                                            }
                                                                                        });
                                                                                        /*╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋*/
                                                                                    }
                                                                                });
                                                                                /*╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋*/


                                                                            }
                                                                        });
                                                                        /*╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋*/


                                                                    }
                                                                });
                                                                /*╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋*/

                                                            }
                                                        });
                                                        /*╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋*/

                                                    }
                                                });
                                                /*╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋*/

                                            }
                                        });
                                        /*╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋*/

                                    }
                                });
                                /*╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋*/

                            }
                        });
                        /*▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅▅*/
                    }


                });

            }

        });



        outers = [Collector, CollectorNames, OnTimelength, OnRootMap, FeedCommand];

    } catch (e) { }
    return outers;
}
function ConstructAnimatedCallParallelEngine(IsReverse, ElementRenderId, ColumnId, ItemId, Speed, TimerCurrentValue, AnimatedType, Filters, KeyEffect, CallBack) {
    try {
        // alert("C: " + ElementRenderId + " | " + ColumnId + " | " + ItemId + " | " + Speed + " | " + NextTimelength);
        //##SGW9010
        // alert(ColumnId + " | " + ItemId);

        var Element = document.getElementById(ElementRenderId);
        // ConstructAnimatedSequenceSelect


        var CCFV = "";
        var EngineCc = 0;
        var CalculateAnimatedData = ["", "", 0, 0, "", null, "", 0];
        var SetCallBack = false;
        // 
        ConstructAnimatedSequenceExplorer(IsReverse, Element, ColumnId, ItemId, false, false, function (ExMap, Timelength, ExName, ExCc, ExInnerElement, CurrentValue, CssDuration) {
            //###13GTTYF10 
            try {
                // var IsNoConflict = ConstructAnimatedGPUTimeStreamTrack(Element, ExInnerElement);
                // if (IsNoConflict == true)
                {
                    var IsAdd = ConstructAnimatedGPUTimeStreamTrack(Element, ExInnerElement);
                    // document.getElementById("GGHSSGSGSG").innerHTML += " " + IsAdd + " , " + ExName + " / " + CurrentValue + " :: " + Timelength + "</br>";

                    if (IsAdd == true) {
                        //  document.getElementById("GGHSSGSGSG").innerHTML += "</br>";

                        SetCallBack = true;
                        EngineCc += 1;

                        var ExTimelength = Timelength + TimerCurrentValue;
                        if (IsReverse == false) {
                            ExTimelength = TimerCurrentValue;
                        }

                        var Animatedlength = ExTimelength + 0;
                        var _AnimatedSec = ExTimelength / 100;
                        var AnimatedSec = _AnimatedSec / 4;

                        var TimelengthHelfSec = Timelength / 2;
                        var TimelengthSec = TimelengthHelfSec / 100;
                        var TimelengthSecStr = "0.5s";
                        //  document.getElementById("GGHSSGSGSG").innerHTML += ExName + " , " + Timelength + " | ";
                        //#TMHN741101  auto
                        if (CssDuration.toLowerCase() == "auto".toLowerCase()) {
                            TimelengthSecStr = TimelengthSec + 's';
                        } else {
                            TimelengthSecStr = CssDuration;
                        }
                        var CalculateAnimated = ConstructAnimatedTagToCss(Element, ExTimelength, TimelengthSecStr, AnimatedType, Filters, ExName, ECGPUFloatRange, KeyEffect);

                        if (ExTimelength == CurrentValue) {

                            CalculateAnimatedData = [CalculateAnimated[0], CalculateAnimated[1], CalculateAnimated[2], CalculateAnimated[3], CalculateAnimated[4], Element, ExName, CurrentValue];

                        }

                    } else {
                        SetCallBack = false;
                        //   document.getElementById("GGHSSGSGSG").innerHTML += "*******FAILD CALL******* </br>";
                        //   CalculateAnimatedData = ["", "", 0, 0, "", null, "", 0];
                    }

                }



            } catch (e) { }
        });

        CallBack(CalculateAnimatedData, EngineCc, SetCallBack);

        ConstructAnimatedXmlTypewriter(CalculateAnimatedData[5], CalculateAnimatedData[6], CalculateAnimatedData[7]);



        //  alert(CCFN + " > " +CCFV);

    } catch (e) { }
}
var ConstructAnimatedGPUTimerKey = false;
var ConstructAnimatedGPUTimerRunKey = false;
var ConstructAnimatedGPUTimer = null;
var ConstructAnimatedGPUTimeTick = 0;
var ConstructAnimatedGPUTimeLastTick = 0;
var ConstructAnimatedGPUTimerArray = "";
function ConstructAnimatedGPUTimerCreateArray(Element, Value, xType) {
    try {
        ConstructAnimatedGPUTimerArray = ConstructAnimatedGenerateParallelTimerArry(Element, Value, xType);
    } catch (e) { }
}
/* ▣🔄▧ Animated Typewriter ▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧ 🔻 */
function ConstructAnimatedXmlTypewriter(Element, ExName, CurrentValue) {
    try {
        //#JNE977874
        // alert(ExName + " | " + CurrentValue);
        var TypewriterXmlData = ECReadDataTypewriter("TextViewTypewriters");
        ECForeachDocument([TypewriterXmlData], ["span"], function (inode, Filter, Cc) {
            try {
                var typeSrt = "";
                if (inode.getAttribute("type") != null && inode.getAttribute("type").toLowerCase() != "null") {
                    typeSrt = inode.getAttribute("type");
                }
                if (typeSrt.toLowerCase() == "Sequence".toLowerCase()) {
                    try {
                        var xNameSrt = "";
                        if (inode.getAttribute("xname") != null && inode.getAttribute("xname") != "") {
                            xNameSrt = inode.getAttribute("xname");
                        }
                        var startSrt = "";
                        if (inode.getAttribute("start") != null && inode.getAttribute("start").toLowerCase() != "null") {
                            startSrt = inode.getAttribute("start");
                        }
                        var stopSrt = "";
                        if (inode.getAttribute("stop") != null && inode.getAttribute("stop").toLowerCase() != "null") {
                            stopSrt = inode.getAttribute("stop");
                        }
                        var SpeedSrt = "1";
                        if (inode.getAttribute("speed") != null && inode.getAttribute("speed") != "") {
                            SpeedSrt = inode.getAttribute("speed");
                        }
                        var IsRunStr = "false";
                        if (inode.getAttribute("isRun") != null && inode.getAttribute("isRun") != "") {
                            IsRunStr = inode.getAttribute("isRun");
                        }
                        var IsRun = ECConvertToBoolean(IsRunStr);

                        var xSpeed = 10;
                        xSpeed = parseInt(SpeedSrt, 10);
                        var TypewriterSingle = null;
                        if (startSrt.toLowerCase() == ExName.toLowerCase()) {
                            if (IsRun == false) {
                                inode.setAttribute("isRun", "true");
                                try {

                                    if (xNameSrt.trim() != "") {
                                        var TextElement = ECGetElementByEcKey("textview", xNameSrt);
                                        var RenderText = "";
                                        if (TextElement.getAttribute("text") != null && TextElement.getAttribute("text") != "") {
                                            RenderText = TextElement.getAttribute("text");
                                        }
                                        //#THN977874
                                        if (RenderText.trim() != "") {
                                            var DivElement = document.getElementById(xNameSrt);
                                            DivElement.innerHTML = "";
                                            var Tccx = 0;
                                            TypewriterSingle = setInterval(function () {
                                                Tccx += 1;
                                                var rTccx = Tccx - 1;
                                                var getAsStr = RenderText;
                                                var PrcStr = getAsStr[rTccx];
                                                var Tlength = RenderText.length;
                                                var Tlr = Tlength - 3;
                                                var NPP1 = rTccx + 1;
                                                var NPP2 = rTccx + 2;
                                                var NPP3 = rTccx + 3;
                                                var Get3Code = "*";
                                                if (Tlr != 0) {
                                                    if (Tlr > NPP3) {
                                                        Get3Code = getAsStr[NPP1] + getAsStr[NPP2] + getAsStr[NPP3];

                                                    } else {
                                                        Get3Code = "*";
                                                    }
                                                }
                                                if (Get3Code == "%p%") {
                                                    DivElement.innerHTML += PrcStr;
                                                    DivElement.innerHTML += "</br>";
                                                    Tccx += 3;
                                                } else {
                                                    if (Get3Code == "%s%") {
                                                        DivElement.innerHTML += PrcStr;
                                                        DivElement.innerHTML += "&nbsp;";
                                                        Tccx += 3;

                                                    } else {
                                                        DivElement.innerHTML += PrcStr;
                                                    }
                                                }
                                                if (Tlength == Tccx) {
                                                    inode.setAttribute("isRun", "false");
                                                    clearInterval(TypewriterSingle);

                                                }

                                            }, xSpeed, true);
                                        }
                                    }
                                } catch (e) {

                                }
                            }

                        }
                        if (stopSrt.toLowerCase() == ExName.toLowerCase()) {
                            try {
                                inode.setAttribute("isRun", "false");
                                var DivElement = document.getElementById(xNameSrt);
                                DivElement.innerHTML = "";
                            } catch (e) { }
                        }


                    } catch (e) { }
                }


            } catch (e) {

            }
        });


    } catch (e) { }
}
/* ▣🔄▧ Animated Typewriter ▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧ 🔺 */
//var ConstructAnimatedGPUTimerTickListArray = [0];
function ConstructAnimatedGPUTimerTick(Element, ElementRenderId, Duration, Speed, TickValue, FastSpeed, KeyEffect,GetIsSync) {
    try {


        //alert(TickValue);
        //##XSGW970
        //##SGW9010
        //#plkmnsf710
        //##QSGW9010
        // alert("TT: " + ConstructAnimatedGPUTimerArray);
        var OnLiveSrt = "";
        if (Element.getAttribute("OnLive") != null && Element.getAttribute("OnLive") != "") {
            OnLiveSrt = Element.getAttribute("OnLive");
        }
        var OnChangedSrt = "";
        if (Element.getAttribute("OnChanged") != null && Element.getAttribute("OnChanged") != "") {
            OnChangedSrt = Element.getAttribute("OnChanged");
        }
        var OnSeekStr = "";
        if (Element.getAttribute("OnSeek") != null && Element.getAttribute("OnSeek") != "") {
            OnSeekStr = Element.getAttribute("OnSeek");
        }

        if (ConstructAnimatedGPUTimer != null) {
            clearInterval(ConstructAnimatedGPUTimer);
        }
        ConstructAnimatedGPUTimeTick = TickValue;
      
        if (FastSpeed == true) {
            if (TickValue != 0) {
                // ConstructAnimatedGPUTimeTick -= 1;
            }
            //ConstructAnimatedGPUTimeStream(TickValue, ElementRenderId, Duration, Speed, function (status, Timelength)
            //{ });

        }
       
        try {
            if (OnChangedSrt.trim() != "") {
                // this.value,this.event
                var TimeTickStandard = ConstructAnimatedGPUTimeTick;
                if (ConstructAnimatedGPUTimeTick != 0) {
                    TimeTickStandard = ConstructAnimatedGPUTimeTick - 1;
                }
                var ExeVal = OnChangedSrt.replace(EcThisValueRegx, TimeTickStandard).replace(EcThisEventRegx, "'start'");
                eval(ExeVal);
            }
        } catch (e) { }


        // alert(ConstructAnimatedGPUTimeTick);
        var AnimatedStyles = ECReadMotionControlStyle(ECregisterDataKeys[2]);

        var CASaveGPUTimeTick = 0;
        ConstructAnimatedGPUTimer = setInterval(function () {
            ConstructAnimatedGPUTimeTick += 1;
            if (GetIsSync == true) {
                //ConstructAnimatedGPUTimeTick = 50;
                //  document.title = ConstructAnimatedGPUTimeTick + ":T";
            }
            try {
                if (OnLiveSrt.trim() != "") {  
                    var ExeVal = OnLiveSrt.replace(EcThisValueRegx, ConstructAnimatedGPUTimeTick).replace(EcThisEventRegx);
                    eval(ExeVal);
                }
            } catch (e) { }

            var LastEvent = "run";
            ConstructAnimatedGPUTimeStream(Element, ConstructAnimatedGPUTimeTick, ElementRenderId, Duration, Speed, KeyEffect, function (status, Timelength, CurrentValue, xmlTimeLineMap, CssRenderData, GetTrack, CallOptions, SubElement, overCall) {


                //  Column, ItemId
                try {
                    if (SubElement != null) {
                        // var GetElementXml = SubElement;// document.getElementById(ElementRenderId);

                        // alert(NodeInner.getAttribute("t.enable") + " / " + NodeInner.getAttribute("t.key") + " / " + NodeInner.getAttribute("name"));
                        //   var SSTR = "( " + ConstructAnimatedGPUTimeTick + " ) TE : " + SubElement.getAttribute("t.enable") + " TK :" + SubElement.getAttribute("t.key") + " NA :" + SubElement.getAttribute("name");

                        // document.getElementById("GGHSSGSGSG").innerHTML += " <p> " + SubElement.getAttribute("name") + " </p> ";
                    }


                } catch (e) {

                }
                var AddRenderTime = true;

                if (status.toLowerCase() == "ripel".toLowerCase()) {
                    // AddRenderTime = false;
                    // ConstructAnimatedGPUTimeTick -= Timelength;
                    //document.getElementById("GGHSSGSGSG").innerHTML = "ripel : " + ConstructAnimatedGPUTimeTick;
                }
                var SubElementUse = false;
                var GGName = "Null";
                if (SubElement != null) {
                    if (SubElement.getAttribute("name") != null) {
                        GGName = SubElement.getAttribute("name");
                    }
                    SubElementUse = true;
                }
                if (SubElementUse == false) {
                    AddRenderTime = false;

                    // CASaveGPUTimeTick = ConstructAnimatedGPUTimeTick;

                } else {
                    //   ConstructAnimatedGPUTimeTick = 0;
                    //  ConstructAnimatedGPUTimeTick += 1;

                    //   ConstructAnimatedGPUTimerTick(Element, ElementRenderId, Duration, Speed, CASaveGPUTimeTick, FastSpeed);
                    //  clearInterval(ConstructAnimatedGPUTimer);
                    // ConstructAnimatedGPUTimeTick += 1;
                }



                //   document.getElementById("GGHSSGSGSG").innerHTML += " " + overCall + " / "  + AddRenderTime + " , " + GGName + " / " + ConstructAnimatedGPUTimeTick + " :: " + Timelength + "</br>";

                if (status.toLowerCase() == "conflict".toLowerCase()) {

                }

                if (status.toLowerCase() == "data".toLowerCase()) {
                    if (AddRenderTime == true) {
                        //   if (CssRenderData.trim() != "") { AnimatedStyles.innerHTML = CssRenderData; }
                        AnimatedStyles.innerHTML = CssRenderData;
                        // NEWAnimatedStyles.innerHTML = CssRenderData;

                    }

                }
                LastEvent = "run";
                if (status.toLowerCase() == "pause".toLowerCase()) {
                    if (AddRenderTime == true) {
                        //   if (CssRenderData.trim() != "") { AnimatedStyles.innerHTML = CssRenderData; }
                        AnimatedStyles.innerHTML = CssRenderData;
                        // NEWAnimatedStyles.innerHTML = CssRenderData;
                        //dhdhsfaf
                        LastEvent = "pause";
                        clearInterval(ConstructAnimatedGPUTimer);
                        ECTimelinePauseClock = CurrentValue;
                        Element.setAttribute("status", "pause");
                        if (OnChangedSrt.trim() != "") {
                            var ExeVal = OnChangedSrt.replace(EcThisValueRegx, CurrentValue).replace(EcThisEventRegx, "'pause'");
                            eval(ExeVal);
                        }

                    }


                    // alert(CurrentValue);
                }
                if (status.toLowerCase() == "stop".toLowerCase()) {
                    if (AddRenderTime == true) {
                        //   if (CssRenderData.trim() != "") { AnimatedStyles.innerHTML = CssRenderData; }
                        AnimatedStyles.innerHTML = CssRenderData;
                        // NEWAnimatedStyles.innerHTML = CssRenderData;

                        LastEvent = "stop";
                        clearInterval(ConstructAnimatedGPUTimer);
                        ECTimelineStopClock = 0;
                        Element.setAttribute("status", "stop");
                        if (OnChangedSrt.trim() != "") {
                            var ExeVal = OnChangedSrt.replace(EcThisValueRegx, CurrentValue).replace(EcThisEventRegx, "'stop'");
                            eval(ExeVal);
                        }

                    }


                }
                if (status.toLowerCase() == "clear".toLowerCase()) {
                    if (AddRenderTime == true) {
                        //   if (CssRenderData.trim() != "") { AnimatedStyles.innerHTML = CssRenderData; }
                        AnimatedStyles.innerHTML = CssRenderData;
                        //   NEWAnimatedStyles.innerHTML = CssRenderData;

                    }
                }
                if (status.toLowerCase() == "fixed".toLowerCase()) {
                    if (AddRenderTime == true) {
                        //   if (CssRenderData.trim() != "") { AnimatedStyles.innerHTML = CssRenderData; }
                        AnimatedStyles.innerHTML = CssRenderData;
                        // NEWAnimatedStyles.innerHTML = CssRenderData;

                    }

                }
                if (status.toLowerCase() == "jump".toLowerCase()) {
                    if (AddRenderTime == true) {
                        //  ECTimelineJumpClock = CurrentValue;
                        AnimatedStyles.innerHTML = CssRenderData;

                        LastEvent = "jump";
                        clearInterval(ConstructAnimatedGPUTimer);
                        ECTimelineJumpClock = CurrentValue;
                        Element.setAttribute("status", "jump");

                        ECSetTracksTimeLine(Element, CallOptions[1])
                        ECPlayTimeLine("gpu", Element, Duration, Speed, CallOptions[0]);

                    }


                    //  alert(CallOptions);

                }
                if (status.toLowerCase() == "return".toLowerCase()) {
                    if (AddRenderTime == true) {
                        //   if (CssRenderData.trim() != "") { AnimatedStyles.innerHTML = CssRenderData; }
                        AnimatedStyles.innerHTML = CssRenderData;

                    }
                }

                //if (GGName.toLowerCase() == "3E-Animated".toLowerCase())
                //{
                //    document.getElementById("GGHSSGSGSG").innerHTML += "<p>" + CssRenderData + "</p>";
                //}

            }); 
            try {
                if (OnSeekStr.trim() != "") {
                    if (ConstructAnimatedGPUTimeTick == Duration) {
                        LastEvent = "end";
                    }
                    var ExeVal = OnSeekStr.replace(EcThisValueRegx, ConstructAnimatedGPUTimeTick).replace(EcThisEventRegx, "'" + LastEvent + "'");
                    eval(ExeVal);
                }
            } catch (e) { } 
            if (ConstructAnimatedGPUTimeTick == Duration) {

                //#T977874
                clearInterval(ConstructAnimatedGPUTimer);
                ECTimelineEndClock = Duration;
                Element.setAttribute("status", "end");
                if (OnChangedSrt.trim() != "") {

                    var ExeVal = OnChangedSrt.replace(EcThisValueRegx, Duration).replace(EcThisEventRegx, "'end'");
                    eval(ExeVal);
                }

            }

        }, Speed, true);


    } catch (e) { }
}
var ConstructAnimatedGPUTimeStreamClearCssData = " position:fixed; visibility:hidden; Opacity:0; ";
//var ConstructAnimatedGPUTimeStreamFilters = "";
//var ConstructAnimatedGPUTimeStreamStyles = "";
function ConstructAnimatedGPUTimeStreamTrack(BaseElement, GetElementXml) {
    var outers = true;
    try {
        var GetAsTEnable = true;
        var GetAsTkey = "";


        if (GetElementXml.getAttribute("T.Enable") != null) {
            GetAsTEnable = ECConvertToBoolean(GetElementXml.getAttribute("T.Enable"));
        }
        if (GetElementXml.getAttribute("t.key") != null) {
            GetAsTkey = GetElementXml.getAttribute("t.key");
        }

        var GetAsTracks = "*";
        if (BaseElement.getAttribute("tracks") != null) {
            GetAsTracks = BaseElement.getAttribute("tracks");
        }

        if (GetAsTEnable == false) {

            ECForeachComArray(GetAsTracks, function (xTValue, xTCc) {
                if (GetAsTkey.trim() != "") {

                    if (GetAsTkey.toLowerCase() == xTValue.toLowerCase()) {
                        GetAsTEnable = true;
                    }
                }

            });

        }
        outers = GetAsTEnable;

    } catch (e) { }
    return outers;
}
function ConstructAnimatedGPUTimeStream(BaseElement, TimeTick, ElementRenderId, Duration, Speed, KeyEffect, Callback) {
    try {
        var GetCurrentValue = 0;
        var CCMp = 0;



        ECConvertToTimeStream(BaseElement, TimeTick, ConstructAnimatedGPUTimerArray, function (RemoveId, Timelength, Tick, Column, ItemId, CurrentValue, getXmlIdx, CssDuration, SetTrack, PartBack) {
            CCMp += 1;
            if (CCMp == 1) {

                GetCurrentValue = CurrentValue;

                //  alert(getXmlIdx); s4f44fssf1s5f
                var GetElementXml = null;
                var TagEnable = false;
                var ElementUse = false;
                if (document.getElementById(getXmlIdx) != null) {
                    GetElementXml = document.getElementById(getXmlIdx);
                    TagEnable = ConstructAnimatedGPUTimeStreamTrack(BaseElement, GetElementXml);
                    ElementUse = true;
                }

                //  document.getElementById("GGHSSGSGSG").innerHTML += " " + " - " + ElementUse;//+ " / " + Tick;

                /*▭▭▭[ REMOVE CURRENT ARRAY ]▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭ 🔻 */
                try {

                    if (TagEnable == true) {
                        if (ConstructAnimatedGPUTimerArray.trim() != "") {
                            if (SetTrack == true) {
                                var UpdateGPUTimerArray = "";
                                var UpdateGPUTimerArrayCc = 0;
                                var ArrayValueSplit = ConstructAnimatedGPUTimerArray.split(",");
                                for (var r = 0; r < ArrayValueSplit.length; r++) {
                                    var GetPart = ArrayValueSplit[r];
                                    if (GetPart.toLowerCase() != PartBack.toLowerCase()) {
                                        UpdateGPUTimerArrayCc += 1;
                                        if (UpdateGPUTimerArrayCc == 1) {
                                            UpdateGPUTimerArray += GetPart;
                                        } else {
                                            UpdateGPUTimerArray += "," + GetPart;
                                        }
                                    }
                                }
                                ConstructAnimatedGPUTimerArray = UpdateGPUTimerArray;
                            }
                        }
                    }


                } catch (e) { }

                /*▭▭▭[ REMOVE CURRENT ARRAY ]▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭▭ 🔺 */

                ConstructAnimatedGPUTimeLastTick = CurrentValue;

                var RenderDataOptions = null;
                var ReadCssRenderData = "";
                var ParallelEngineFilters = "*";
                var ParallelEngineClassRemoveId = "";
                var ParallelEngineClassRemoveCc = 0;
                var ParallelEngineType = "static";
                var getAsClearData = false;


                if (TagEnable == true) {

                    try {
                        //  var GetElementXml = document.getElementById(getXmlIdx);
                        //  SetCallBack = ConstructAnimatedGPUTimeStreamTrack(BaseElement, GetElementXml);
                        // alert(NodeInner.getAttribute("t.enable") + " / " + NodeInner.getAttribute("t.key") + " / " + NodeInner.getAttribute("name"));
                        //  var SSTR = "( " + GetCurrentValue + " ) TE : " + GetElementXml.getAttribute("t.enable") + " TK :" + GetElementXml.getAttribute("t.key") + " NA :" + GetElementXml.getAttribute("name");
                        //  document.getElementById("GGHSSGSGSG").innerHTML += "<p>" + SSTR + "</p>";


                        //  alert();

                    } catch (e) {

                    }

                    var overCall = true;
                    ConstructAnimatedCallParallelEngine(false, ElementRenderId, Column, ItemId, Speed, CurrentValue, ParallelEngineType, ParallelEngineFilters, KeyEffect, function (ObjectRenderData, EngineCc, InAdd) {

                        //  CCNp += 1;
                        if (getAsClearData == true) {
                            //  ReadCssRenderData += ConstructAnimatedGPUTimeStreamStyles;
                            // document.getElementById("GGHSSGSGSG").innerHTML = ConstructAnimatedGPUTimeStreamStyles;
                            // document.getElementById("GGHSSGSGSG").innerHTML =  ParallelEngineClassRemoveId + " { " + ConstructAnimatedGPUTimeStreamClearCssData + " }";// " FTL : " + ConstructAnimatedGPUTimeStreamFilters
                        }
                        //   document.getElementById("GGHSSGSGSG").innerHTML = " OBJ :   " + ObjectRenderData[1];
                        try {
                            ////#C7sfsfsfffsSW01


                            //ConstructAnimatedGPUTimeStreamStyles += ParallelEngineClassRemoveId + " { " + ConstructAnimatedGPUTimeStreamClearCssData + " }";


                        } catch (e) { }

                        // document.getElementById("GGHSSGSGSG").innerHTML += InAdd + " / " + CurrentValue + " :: " + Timelength + "</br>";

                        //  overCall = InAdd;
                        if (InAdd == true)
                        { }
                        ReadCssRenderData = ObjectRenderData[0];
                        var GetRenderCommand = ObjectRenderData[4];
                        if (GetRenderCommand.trim() != "") {
                            if (GetRenderCommand.toLowerCase() == "clear".toLowerCase()) {
                                try {
                                    var ECssNameArrayStr = ObjectRenderData[1];
                                    if (ECssNameArrayStr.trim() != "") {
                                        var Ccssn = 0;
                                        var CreateCssNames = "";
                                        var ECssNameArray = ECssNameArrayStr.split("#");
                                        for (var ECar = 0; ECar < ECssNameArray.length; ECar++) {
                                            var Eck = ECssNameArray[ECar];
                                            if (Eck.trim() != "") {
                                                Ccssn += 1;
                                                // document.getElementById("GGHSSGSGSG").innerHTML += Eck + " | ";
                                                if (Ccssn == 1) {
                                                    CreateCssNames += "#" + Eck;
                                                } else {
                                                    CreateCssNames += ", #" + Eck;
                                                }
                                            }
                                        }
                                        // ## T3000
                                        //  document.getElementById("GGHSSGSGSG").innerHTML = CreateCssNames;
                                        ReadCssRenderData += CreateCssNames + " { " + ConstructAnimatedGPUTimeStreamClearCssData + " }";
                                        //alert("D");
                                    }
                                    //    document.getElementById("GGHSSGSGSG").innerHTML = ECssNameArrayStr;
                                    // ConstructAnimatedGPUTimeStreamClearCssData
                                } catch (e) {

                                }


                            }
                        }






                        // CssDataList
                        //36045
                        //  document.getElementById("GGHSSGSGSG").innerHTML = "( " + ReadCssRenderData.length + " )";// </br> " + ReadCssRenderData;

                    });



                    var FindCallBack = false;
                    try {

                        if (getXmlIdx.trim() != "") {
                            try {


                                var RootXmlElement = document.getElementById(getXmlIdx);


                                ECForeachDocument([RootXmlElement], ECregisterAnimatedTimelineCommand, function (ElementNode, NodeName, NCc) {
                                    var SubTagEnable = ConstructAnimatedGPUTimeStreamTrack(BaseElement, ElementNode);
                                    if (SubTagEnable == true) {

                                        if (NodeName.toLowerCase() == "import".toLowerCase()) {
                                            //**XX56075
                                            ConstructAnimatedImportTag(ElementNode, NodeName, NCc);


                                        }
                                        if (NodeName.toLowerCase() == "fixed".toLowerCase()) {
                                            FindCallBack = true;
                                            Callback("fixed", Timelength, CurrentValue, [Column, ItemId], ReadCssRenderData, SetTrack, RenderDataOptions, GetElementXml, overCall);
                                        }
                                        if (NodeName.toLowerCase() == "clear".toLowerCase()) {
                                            //#5E0AEQEGS1101
                                            FindCallBack = true;
                                            Callback("clear", Timelength, CurrentValue, [Column, ItemId], ReadCssRenderData, SetTrack, RenderDataOptions, GetElementXml, overCall);

                                        }
                                        if (NodeName.toLowerCase() == "jump".toLowerCase()) {

                                            // # 770

                                            FindCallBack = true;
                                            try {

                                                var JValueStr = "0";
                                                if (ElementNode.getAttribute("value") != null && ElementNode.getAttribute("value") != "") {
                                                    JValueStr = ElementNode.getAttribute("value");
                                                }
                                                var TimeLineTracksStr = "*";
                                                if (ElementNode.getAttribute("TimeLine.tracks") != null && ElementNode.getAttribute("TimeLine.tracks") != "") {
                                                    TimeLineTracksStr = ElementNode.getAttribute("TimeLine.tracks");
                                                }
                                                var JValue = parseInt(JValueStr, 10);
                                                RenderDataOptions = [JValue, TimeLineTracksStr];

                                            } catch (e) { }
                                            Callback("jump", Timelength, CurrentValue, [Column, ItemId], ReadCssRenderData, SetTrack, RenderDataOptions, GetElementXml, overCall);


                                        }
                                        if (NodeName.toLowerCase() == "return".toLowerCase()) {
                                            FindCallBack = true;
                                            Callback("return", Timelength, CurrentValue, [Column, ItemId], ReadCssRenderData, SetTrack, RenderDataOptions, GetElementXml, overCall);
                                        }
                                        if (NodeName.toLowerCase() == "pause".toLowerCase()) {
                                            var GetResumeStr = "0";
                                            var SetResume = false;
                                            if (ElementNode.getAttribute("resume") != null) {
                                                GetResumeStr = ElementNode.getAttribute("resume");
                                                SetResume = true;
                                            }
                                            var resumeInt = parseInt(GetResumeStr, 0);
                                            RenderDataOptions = [resumeInt, SetResume];


                                            FindCallBack = true;
                                            Callback("pause", Timelength, CurrentValue, [Column, ItemId], ReadCssRenderData, SetTrack, RenderDataOptions, GetElementXml, overCall);
                                            //#500GBMHN741101
                                            //  document.getElementById("GGHSSGSGSG").innerHTML = "<p>" + CurrentValue + "</p>" + xHoldeConstructAnimatedLines;

                                            //#TMHN977874
                                            if (ElementNode.getAttribute("Event") != null) {
                                                var GetCallEvent = ElementNode.getAttribute("Event").replace(EcThisValueRegx, CurrentValue);
                                                eval(GetCallEvent);
                                            }
                                        }
                                        if (NodeName.toLowerCase() == "stop".toLowerCase()) {
                                            FindCallBack = true;
                                            Callback("stop", Timelength, CurrentValue, [Column, ItemId], ReadCssRenderData, SetTrack, RenderDataOptions, GetElementXml, overCall);
                                        }
                                    }
                                });

                            } catch (e) { }
                        }


                    } catch (e) { }
                    if (FindCallBack == false) {
                        Callback("data", Timelength, CurrentValue, [Column, ItemId], ReadCssRenderData, SetTrack, RenderDataOptions, GetElementXml, overCall);
                    }




                } else {
                    Callback("conflict", Timelength, CurrentValue, [Column, ItemId], ReadCssRenderData, SetTrack, RenderDataOptions, null, false);
                }
            } else {
                Callback("ripel", 0, 0, [0, 0], "", null, null, null, false);
            }

        });



    } catch (e) { }
}
function ConstructAnimatedGenerateParallelTimerArry(Element, tValue, xType) {

    var outers = "";
    try {

        ConstructAnimatedSequenceExplorer(false, Element, tValue, "*", false, true, function (DataValue) {
            outers = DataValue;

        });



    } catch (e) {
        alert(e.message);
    }
    return outers;
}
function ConstructAnimatedSequenceReadTrack(Element, eType, xCc, BaseElement, Tracks) {
    try {
        var GetAsId = "";
        if (Element.getAttribute("id") != null) {
            GetAsId = Element.getAttribute("id");
        }
        if (GetAsId.trim() == "") {
            var CreateTid = "ect_" + ECRandomId();
            Element.setAttribute("id", CreateTid);
            GetAsId = CreateTid;
        }
        var GetAsTEnable = true;
        if (Element.getAttribute("T.Enable") != null) {
            GetAsTEnable = ECConvertToBoolean(Element.getAttribute("T.Enable"));
        }
        if (GetAsTEnable == true) {
            Element.setAttribute("T.Enable", "false");
        }
        var GetAsTkey = "";
        if (Element.getAttribute("T.Key") != null) {
            GetAsTkey = Element.getAttribute("T.Key");
        }
        if (GetAsTkey.trim() == "") {
            Element.setAttribute("T.Key", Tracks);
        }


    } catch (e) { }
}
function ConstructAnimatedSequenceReadTracks(Element, Tracks) {
    var outers = ["", false];
    try {
        var ECregisterAnimatedTimelineCommandWithSequence = ECregisterAnimatedTimelineCommand;
        ECregisterAnimatedTimelineCommandWithSequence.push("Sequence");

        ConstructAnimatedSequenceReadTrack(Element, "Sequence", 0, Element, Tracks);

        ECForeachReverseDocument(false, [Element], ECregisterAnimatedTimelineCommandWithSequence, function (x1inode, x1Value, x1Cc) {
            ConstructAnimatedSequenceReadTrack(x1inode, x1Value, x1Cc, Element, Tracks);
            ECForeachReverseDocument(false, [x1inode], ECregisterAnimatedTimelineCommandWithSequence, function (x2inode, x2Value, x2Cc) {
                ConstructAnimatedSequenceReadTrack(x2inode, x2Value, x2Cc, Element, Tracks);
                ECForeachReverseDocument(false, [x2inode], ECregisterAnimatedTimelineCommandWithSequence, function (x3inode, x3Value, x3Cc) {
                    ConstructAnimatedSequenceReadTrack(x3inode, x3Value, x3Cc, Element, Tracks);
                    ECForeachReverseDocument(false, [x3inode], ECregisterAnimatedTimelineCommandWithSequence, function (x4inode, x4Value, x4Cc) {

                        ConstructAnimatedSequenceReadTrack(x4inode, x4Value, x4Cc, Element, Tracks);
                        ECForeachReverseDocument(false, [x4inode], ECregisterAnimatedTimelineCommandWithSequence, function (x5inode, x5Value, x5Cc) {
                            ConstructAnimatedSequenceReadTrack(x5inode, x5Value, x5Cc, Element, Tracks);
                            ECForeachReverseDocument(false, [x5inode], ECregisterAnimatedTimelineCommandWithSequence, function (x6inode, x6Value, x6Cc) {
                                ConstructAnimatedSequenceReadTrack(x6inode, x6Value, x6Cc, Element, Tracks);
                                ECForeachReverseDocument(false, [x6inode], ECregisterAnimatedTimelineCommandWithSequence, function (x7inode, x7Value, x7Cc) {
                                    ConstructAnimatedSequenceReadTrack(x7inode, x7Value, x7Cc, Element, Tracks);
                                    ECForeachReverseDocument(false, [x7inode], ECregisterAnimatedTimelineCommandWithSequence, function (x8inode, x8Value, x8Cc) {
                                        ConstructAnimatedSequenceReadTrack(x8inode, x8Value, x8Cc, Element, Tracks);
                                        ECForeachReverseDocument(false, [x8inode], ECregisterAnimatedTimelineCommandWithSequence, function (x9inode, x9Value, x9Cc) {
                                            ConstructAnimatedSequenceReadTrack(x9inode, x9Value, x9Cc, Element, Tracks);

                                            ECForeachReverseDocument(false, [x9inode], ECregisterAnimatedTimelineCommandWithSequence, function (x10inode, x10Value, x10Cc) {
                                                ConstructAnimatedSequenceReadTrack(x10inode, x10Value, x10Cc, Element, Tracks);

                                                ECForeachReverseDocument(false, [x10inode], ECregisterAnimatedTimelineCommandWithSequence, function (x11inode, x11Value, x11Cc) {
                                                    ConstructAnimatedSequenceReadTrack(x11inode, x11Value, x11Cc, Element, Tracks);

                                                    ECForeachReverseDocument(false, [x11inode], ECregisterAnimatedTimelineCommandWithSequence, function (x12inode, x12Value, x12Cc) {
                                                        ConstructAnimatedSequenceReadTrack(x12inode, x12Value, x12Cc, Element, Tracks);

                                                        ECForeachReverseDocument(false, [x12inode], ECregisterAnimatedTimelineCommandWithSequence, function (x13inode, x13Value, x13Cc) {
                                                            ConstructAnimatedSequenceReadTrack(x13inode, x13Value, x13Cc, Element, Tracks);

                                                            ECForeachReverseDocument(false, [x13inode], ECregisterAnimatedTimelineCommandWithSequence, function (x14inode, x14Value, x14Cc) {
                                                                ConstructAnimatedSequenceReadTrack(x14inode, x14Value, x14Cc, Element, Tracks);
                                                                // alert(x4Value);
                                                            });
                                                        });
                                                    });
                                                });
                                            });
                                        });
                                    });
                                });
                            });
                        });
                    });
                });
            });

        });



    } catch (e) { }
    return outers;
}
function ConstructAnimatedSequenceTrackCheck(Element, BaseElement, ReadAllArray) {
    var outers = true;
    try {
        if (ReadAllArray == false) {
            var GetAsTEnable = true;
            if (Element.getAttribute("T.Enable") != null) {
                GetAsTEnable = ECConvertToBoolean(Element.getAttribute("T.Enable"));
            }
            if (GetAsTEnable == true) {
                var Tracks = "*";
                if (Element.getAttribute("tracks") != null) {
                    Tracks = Element.getAttribute("tracks");
                }
                if (Tracks != "*") {
                    try {
                        ConstructAnimatedSequenceReadTracks(Element, Tracks);

                    } catch (e) {

                    }
                }
            } else {
                //  outers = ConstructAnimatedGPUTimeStreamTrack(BaseElement, Element);

                //  alert(xCheck + " / " + Element.getAttribute("name") + " T : " + Element.getAttribute("T.Key"));
                // outers = false;
            }

        } else {

        }


    } catch (e) { }
    return outers;
}
function ConstructAnimatedSequenceExplorer(IsReverse, Element, ColumnId, ItemId, SetMapTxt, ReadAllArray, Callback) {
    //###GGFSF10
    try {


        var ColumnTxt = "c.";
        var ItemTxt = "i.";
        if (SetMapTxt == false) {
            ColumnTxt = "";
            ItemTxt = "";
        }
        var CurrentValue = 0;
        var x2Citem = 0;
        var x3Citem = 0;
        var x4Citem = 0;
        var x5Citem = 0;
        var x6Citem = 0;
        var x7Citem = 0;
        var x8Citem = 0;
        var x9Citem = 0;
        var x10Citem = 0;
        var x11Citem = 0;
        var x12Citem = 0;

        var ReadAllArrayValue = [1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13];


        var GetStringArray = "";
        var TACc = 0;

        ECForeachReverseDocument(IsReverse, [Element], ["Sequence"], function (x1inode, x1Value, x1Cc) {

            var x1Getlength = x1inode.getAttribute("length");
            var x1SqDuration = "auto";
            if (x1inode.getAttribute("duration") != null) {
                x1SqDuration = x1inode.getAttribute("duration");
            }
            var x1ItemTagId = "";
            if (x1inode.getAttribute("id") != null) {
                x1ItemTagId = x1inode.getAttribute("id");
            } else {
                var x1Gnid = "sq_" + ECRandomId();
                x1ItemTagId = x1Gnid;
                x1inode.setAttribute("id", x1ItemTagId);
            }
            var x1Timelength = parseInt(x1Getlength, 10);

            var x1GetName = x1inode.getAttribute("name");
            var x1TrackCheck = ConstructAnimatedSequenceTrackCheck(x1inode, Element, ReadAllArray);
            if (x1TrackCheck == true) {
                /*🔻◉◉◉◉◉◉◉◉◉◉( Sequence columns 1 )◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉ 🔻*/
                if (ColumnId == ReadAllArrayValue[0] || ReadAllArray == true) {
                    if (ReadAllArray == true) { ColumnId = ReadAllArrayValue[0]; }
                    var x1CreateMapPath = ColumnTxt + ColumnId + '/' + ItemTxt + x1Cc;
                    var x1Selector = false;
                    if (ItemId == "*") {
                        x1Selector = true;
                    } else {
                        if (parseInt(ItemId, 10) == x1Cc) {
                            x1Selector = true;
                        }
                    }
                    if (x1Selector == true) {
                        CurrentValue = x1Timelength;
                        if (ReadAllArray == false) {
                            Callback(x1CreateMapPath, x1Timelength, x1GetName, x1Cc, x1inode, CurrentValue, x1SqDuration);
                        } else {
                            TACc += 1;
                            if (TACc == 1) {
                                GetStringArray += x1Timelength + ";" + x1CreateMapPath + ";" + CurrentValue + ";" + x1ItemTagId + ";" + x1SqDuration + ";" + x1TrackCheck + ";" + x1TrackCheck;
                            } else {
                                GetStringArray += "," + x1Timelength + ";" + x1CreateMapPath + ";" + CurrentValue + ";" + x1ItemTagId + ";" + x1SqDuration + ";" + x1TrackCheck + ";" + x1TrackCheck;
                            }
                            //***SFSQFSSFQQFQF77575
                        }
                    }


                }
                /*🔺➰➰➰➰➰( Sequence columns 1 )➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰ 🔺*/
                /*🔻◉◉◉◉◉◉◉◉◉◉( Sequence columns 2 )◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉ 🔻*/
                if (ColumnId > ReadAllArrayValue[1] || ReadAllArray == true) {
                    ECForeachReverseDocument(IsReverse, [x1inode], ["Sequence"], function (x2inode, x2Value, x2Cc) {
                        var x2TrackCheck = ConstructAnimatedSequenceTrackCheck(x2inode, Element, ReadAllArray);
                        if (x2TrackCheck == true) {
                            var x2Getlength = x2inode.getAttribute("length");
                            var x2SqDuration = "auto";
                            if (x2inode.getAttribute("duration") != null) {
                                x2SqDuration = x2inode.getAttribute("duration");
                            }
                            var x2ItemTagId = "";
                            if (x2inode.getAttribute("id") != null) {
                                x2ItemTagId = x2inode.getAttribute("id");
                            } else {
                                var x2Gnid = "sq_" + ECRandomId();
                                x2ItemTagId = x2Gnid;
                                x2inode.setAttribute("id", x2ItemTagId);
                            }
                            var x2Timelength = parseInt(x2Getlength, 10);
                            var x2GetName = x2inode.getAttribute("name");
                            x2Citem += 1;
                            if (ColumnId == ReadAllArrayValue[2] || ReadAllArray == true) {
                                if (ReadAllArray == true) { ColumnId = ReadAllArrayValue[2]; }
                                CurrentValue = x1Timelength + x2Timelength;
                                var x2CreateMapPath = ColumnTxt + ColumnId + '/' + ItemTxt + x2Citem;
                                if (ReadAllArray == false) {
                                    Callback(x2CreateMapPath, x2Timelength, x2GetName, x2Cc, x2inode, CurrentValue, x2SqDuration);
                                } else {
                                    TACc += 1;
                                    if (TACc == 1) {
                                        GetStringArray += x2Timelength + ";" + x2CreateMapPath + ";" + CurrentValue + ";" + x2ItemTagId + ";" + x2SqDuration + ";" + x2TrackCheck;
                                    } else {
                                        GetStringArray += "," + x2Timelength + ";" + x2CreateMapPath + ";" + CurrentValue + ";" + x2ItemTagId + ";" + x2SqDuration + ";" + x2TrackCheck;
                                    }
                                    //***SFSQFSSFQQFQF77575
                                }
                            }
                            /*🔻◉◉◉◉◉◉◉◉◉◉( Sequence columns 3 )◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉ 🔻*/
                            if (ColumnId > ReadAllArrayValue[3] || ReadAllArray == true) {
                                ECForeachReverseDocument(IsReverse, [x2inode], ["Sequence"], function (x3inode, x3Value, x3Cc) {
                                    var x3TrackCheck = ConstructAnimatedSequenceTrackCheck(x3inode, Element, ReadAllArray);
                                    if (x3TrackCheck == true) {
                                        var x3Getlength = x3inode.getAttribute("length");
                                        var x3SqDuration = "auto";
                                        if (x3inode.getAttribute("duration") != null) {
                                            x3SqDuration = x3inode.getAttribute("duration");
                                        }
                                        var x3ItemTagId = "";
                                        if (x3inode.getAttribute("id") != null) {
                                            x3ItemTagId = x3inode.getAttribute("id");
                                        } else {
                                            var x3Gnid = "sq_" + ECRandomId();
                                            x3ItemTagId = x3Gnid;
                                            x3inode.setAttribute("id", x3ItemTagId);
                                        }
                                        var x3Timelength = parseInt(x3Getlength, 10);
                                        var x3GetName = x3inode.getAttribute("name");
                                        x3Citem += 1;
                                        if (ColumnId == ReadAllArrayValue[4] || ReadAllArray == true) {
                                            if (ReadAllArray == true) { ColumnId = ReadAllArrayValue[4]; }
                                            CurrentValue = x1Timelength + x2Timelength + x3Timelength;
                                            var x3CreateMapPath = ColumnTxt + ColumnId + '/' + ItemTxt + x3Citem;
                                            if (ReadAllArray == false) {
                                                Callback(x3CreateMapPath, x3Timelength, x3GetName, x3Cc, x3inode, CurrentValue, x3SqDuration);
                                            } else {
                                                TACc += 1;
                                                if (TACc == 1) {
                                                    GetStringArray += x3Timelength + ";" + x3CreateMapPath + ";" + CurrentValue + ";" + x3ItemTagId + ";" + x3SqDuration + ";" + x3TrackCheck;
                                                } else {
                                                    GetStringArray += "," + x3Timelength + ";" + x3CreateMapPath + ";" + CurrentValue + ";" + x3ItemTagId + ";" + x3SqDuration + ";" + x3TrackCheck;
                                                }
                                                //***SFSQFSSFQQFQF77575
                                            }
                                        }
                                        /*🔻◉◉◉◉◉◉◉◉◉◉( Sequence columns 4 )◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉ 🔻*/
                                        if (ColumnId > ReadAllArrayValue[5] || ReadAllArray == true) {

                                            ECForeachReverseDocument(IsReverse, [x3inode], ["Sequence"], function (x4inode, x4Value, x4Cc) {
                                                var x4TrackCheck = ConstructAnimatedSequenceTrackCheck(x4inode, Element, ReadAllArray);
                                                if (x4TrackCheck == true) {
                                                    var x4Getlength = x4inode.getAttribute("length");
                                                    var x4SqDuration = "auto";
                                                    if (x4inode.getAttribute("duration") != null) {
                                                        x4SqDuration = x4inode.getAttribute("duration");
                                                    }
                                                    var x4ItemTagId = "";
                                                    if (x4inode.getAttribute("id") != null) {
                                                        x4ItemTagId = x4inode.getAttribute("id");
                                                    } else {
                                                        var x4Gnid = "sq_" + ECRandomId();
                                                        x4ItemTagId = x4Gnid;
                                                        x4inode.setAttribute("id", x4ItemTagId);
                                                    }
                                                    var x4Timelength = parseInt(x4Getlength, 10);
                                                    var x4GetName = x4inode.getAttribute("name");
                                                    x4Citem += 1;
                                                    if (ColumnId == ReadAllArrayValue[6] || ReadAllArray == true) {
                                                        if (ReadAllArray == true) { ColumnId = ReadAllArrayValue[6]; }
                                                        CurrentValue = x1Timelength + x2Timelength + x3Timelength + x4Timelength;
                                                        var x4CreateMapPath = ColumnTxt + ColumnId + '/' + ItemTxt + x4Citem;
                                                        if (ReadAllArray == false) {
                                                            Callback(x4CreateMapPath, x4Timelength, x4GetName, x4Cc, x4inode, CurrentValue, x4SqDuration);
                                                        } else {
                                                            TACc += 1;
                                                            if (TACc == 1) {
                                                                GetStringArray += x4Timelength + ";" + x4CreateMapPath + ";" + CurrentValue + ";" + x4ItemTagId + ";" + x4SqDuration + ";" + x4TrackCheck;
                                                            } else {
                                                                GetStringArray += "," + x4Timelength + ";" + x4CreateMapPath + ";" + CurrentValue + ";" + x4ItemTagId + ";" + x4SqDuration + ";" + x4TrackCheck;
                                                            }
                                                            //***SFSQFSSFQQFQF77575
                                                        }
                                                    }
                                                    /*🔻◉◉◉◉◉◉◉◉◉◉( Sequence columns 5 )◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉ 🔻*/
                                                    if (ColumnId > ReadAllArrayValue[7] || ReadAllArray == true) {
                                                        ECForeachReverseDocument(IsReverse, [x4inode], ["Sequence"], function (x5inode, x5Value, x5Cc) {
                                                            var x5TrackCheck = ConstructAnimatedSequenceTrackCheck(x5inode, Element, ReadAllArray);
                                                            if (x5TrackCheck == true) {
                                                                var x5Getlength = x5inode.getAttribute("length");
                                                                var x5SqDuration = "auto";
                                                                if (x5inode.getAttribute("duration") != null) {
                                                                    x5SqDuration = x5inode.getAttribute("duration");
                                                                }
                                                                var x5ItemTagId = "";
                                                                if (x5inode.getAttribute("id") != null) {
                                                                    x5ItemTagId = x5inode.getAttribute("id");
                                                                } else {
                                                                    var x5Gnid = "sq_" + ECRandomId();
                                                                    x5ItemTagId = x5Gnid;
                                                                    x5inode.setAttribute("id", x5ItemTagId);
                                                                }
                                                                var x5Timelength = parseInt(x5Getlength, 10);
                                                                var x5GetName = x5inode.getAttribute("name");
                                                                x5Citem += 1;
                                                                if (ColumnId == ReadAllArrayValue[8] || ReadAllArray == true) {
                                                                    if (ReadAllArray == true) { ColumnId = ReadAllArrayValue[8]; }
                                                                    CurrentValue = x1Timelength + x2Timelength + x3Timelength + x4Timelength + x5Timelength;
                                                                    var x5CreateMapPath = ColumnTxt + ColumnId + '/' + ItemTxt + x5Citem;
                                                                    if (ReadAllArray == false) {
                                                                        Callback(x5CreateMapPath, x5Timelength, x5GetName, x5Cc, x5inode, CurrentValue, x5SqDuration);
                                                                    } else {
                                                                        TACc += 1;
                                                                        if (TACc == 1) {
                                                                            GetStringArray += x5Timelength + ";" + x5CreateMapPath + ";" + CurrentValue + ";" + x5ItemTagId + ";" + x5SqDuration + ";" + x5TrackCheck;
                                                                        } else {
                                                                            GetStringArray += "," + x5Timelength + ";" + x5CreateMapPath + ";" + CurrentValue + ";" + x5ItemTagId + ";" + x5SqDuration + ";" + x5TrackCheck;
                                                                        }
                                                                        //***SFSQFSSFQQFQF77575
                                                                    }
                                                                }
                                                                /*🔻◉◉◉◉◉◉◉◉◉◉( Sequence columns 6 )◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉ 🔻*/
                                                                if (ColumnId > ReadAllArrayValue[9] || ReadAllArray == true) {
                                                                    ECForeachReverseDocument(IsReverse, [x5inode], ["Sequence"], function (x6inode, x6Value, x6Cc) {
                                                                        var x6TrackCheck = ConstructAnimatedSequenceTrackCheck(x6inode, Element, ReadAllArray);
                                                                        if (x6TrackCheck == true) {
                                                                            var x6ItemTagId = "";
                                                                            if (x6inode.getAttribute("id") != null) {
                                                                                x6ItemTagId = x6inode.getAttribute("id");
                                                                            } else {
                                                                                var x6Gnid = "sq_" + ECRandomId();
                                                                                x6ItemTagId = x6Gnid;
                                                                                x6inode.setAttribute("id", x6ItemTagId);
                                                                            }
                                                                            var x6Getlength = x6inode.getAttribute("length");
                                                                            var x6SqDuration = "auto";
                                                                            if (x6inode.getAttribute("duration") != null) {
                                                                                x6SqDuration = x6inode.getAttribute("duration");
                                                                            }
                                                                            var x6Timelength = parseInt(x6Getlength, 10);
                                                                            var x6GetName = x6inode.getAttribute("name");
                                                                            x6Citem += 1;
                                                                            if (ColumnId == ReadAllArrayValue[10] || ReadAllArray == true) {
                                                                                if (ReadAllArray == true) { ColumnId = ReadAllArrayValue[10]; }
                                                                                CurrentValue = x1Timelength + x2Timelength + x3Timelength + x4Timelength + x5Timelength + x6Timelength;
                                                                                var x6CreateMapPath = ColumnTxt + ColumnId + '/' + ItemTxt + x6Citem;
                                                                                if (ReadAllArray == false) {
                                                                                    Callback(x6CreateMapPath, x6Timelength, x6GetName, x6Cc, x6inode, CurrentValue, x6SqDuration);
                                                                                } else {
                                                                                    TACc += 1;
                                                                                    if (TACc == 1) {
                                                                                        GetStringArray += x6Timelength + ";" + x6CreateMapPath + ";" + CurrentValue + ";" + x6ItemTagId + ";" + x6SqDuration + ";" + x6TrackCheck;
                                                                                    } else {
                                                                                        GetStringArray += "," + x6Timelength + ";" + x6CreateMapPath + ";" + CurrentValue + ";" + x6ItemTagId + ";" + x6SqDuration + ";" + x6TrackCheck;
                                                                                    }
                                                                                    //***SFSQFSSFQQFQF77575
                                                                                }
                                                                            }
                                                                            /*🔻◉◉◉◉◉◉◉◉◉◉( Sequence columns 7 )◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉ 🔻*/
                                                                            if (ColumnId > ReadAllArrayValue[11] || ReadAllArray == true) {
                                                                                ECForeachReverseDocument(IsReverse, [x6inode], ["Sequence"], function (x7inode, x7Value, x7Cc) {
                                                                                    var x7TrackCheck = ConstructAnimatedSequenceTrackCheck(x7inode, Element, ReadAllArray);
                                                                                    if (x7TrackCheck == true) {
                                                                                        var x7Getlength = x7inode.getAttribute("length");
                                                                                        var x7SqDuration = "auto";
                                                                                        if (x7inode.getAttribute("duration") != null) {
                                                                                            x7SqDuration = x7inode.getAttribute("duration");
                                                                                        }
                                                                                        var x7ItemTagId = "";
                                                                                        if (x7inode.getAttribute("id") != null) {
                                                                                            x7ItemTagId = x7inode.getAttribute("id");
                                                                                        } else {
                                                                                            var x7Gnid = "sq_" + ECRandomId();
                                                                                            x7ItemTagId = x7Gnid;
                                                                                            x7inode.setAttribute("id", x7ItemTagId);
                                                                                        }
                                                                                        var x7Timelength = parseInt(x7Getlength, 10);
                                                                                        var x7GetName = x7inode.getAttribute("name");
                                                                                        x7Citem += 1;
                                                                                        if (ColumnId == ReadAllArrayValue[12] || ReadAllArray == true) {
                                                                                            if (ReadAllArray == true) { ColumnId = ReadAllArrayValue[12]; }
                                                                                            CurrentValue = x1Timelength + x2Timelength + x3Timelength + x4Timelength + x5Timelength + x6Timelength + x7Timelength;
                                                                                            var x7CreateMapPath = ColumnTxt + ColumnId + '/' + ItemTxt + x7Citem;
                                                                                            if (ReadAllArray == false) {
                                                                                                Callback(x7CreateMapPath, x7Timelength, x7GetName, x7Cc, x7inode, CurrentValue, x7SqDuration);
                                                                                            } else {
                                                                                                TACc += 1;
                                                                                                if (TACc == 1) {
                                                                                                    GetStringArray += x7Timelength + ";" + x7CreateMapPath + ";" + CurrentValue + ";" + x7ItemTagId + ";" + x7SqDuration + ";" + x7TrackCheck;
                                                                                                } else {
                                                                                                    GetStringArray += "," + x7Timelength + ";" + x7CreateMapPath + ";" + CurrentValue + ";" + x7ItemTagId + ";" + x7SqDuration + ";" + x7TrackCheck;
                                                                                                }
                                                                                                //***SFSQFSSFQQFQF77575
                                                                                            }
                                                                                        }
                                                                                        /*🔻◉◉◉◉◉◉◉◉◉◉( Sequence columns 8 )◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉ 🔻*/
                                                                                        if (ColumnId > ReadAllArrayValue[13] || ReadAllArray == true) {
                                                                                            ECForeachReverseDocument(IsReverse, [x7inode], ["Sequence"], function (x8inode, x8Value, x8Cc) {
                                                                                                var x8TrackCheck = ConstructAnimatedSequenceTrackCheck(x8inode, Element, ReadAllArray);
                                                                                                if (x8TrackCheck == true) {
                                                                                                    var x8ItemTagId = "";
                                                                                                    if (x8inode.getAttribute("id") != null) {
                                                                                                        x8ItemTagId = x8inode.getAttribute("id");
                                                                                                    } else {
                                                                                                        var x8Gnid = "sq_" + ECRandomId();
                                                                                                        x8ItemTagId = x8Gnid;
                                                                                                        x8inode.setAttribute("id", x8ItemTagId);
                                                                                                    }
                                                                                                    var x8Getlength = x8inode.getAttribute("length");
                                                                                                    var x8SqDuration = "auto";
                                                                                                    if (x8inode.getAttribute("duration") != null) {
                                                                                                        x8SqDuration = x8inode.getAttribute("duration");
                                                                                                    }
                                                                                                    var x8Timelength = parseInt(x8Getlength, 10);
                                                                                                    var x8GetName = x8inode.getAttribute("name");
                                                                                                    x8Citem += 1;
                                                                                                    if (ColumnId == ReadAllArrayValue[14] || ReadAllArray == true) {
                                                                                                        if (ReadAllArray == true) { ColumnId = ReadAllArrayValue[14]; }
                                                                                                        CurrentValue = x1Timelength + x2Timelength + x3Timelength + x4Timelength + x5Timelength + x6Timelength + x7Timelength + x8Timelength;
                                                                                                        var x8CreateMapPath = ColumnTxt + ColumnId + '/' + ItemTxt + x8Citem;
                                                                                                        if (ReadAllArray == false) {
                                                                                                            Callback(x8CreateMapPath, x8Timelength, x8GetName, x8Cc, x8inode, CurrentValue, x8SqDuration);
                                                                                                        } else {
                                                                                                            TACc += 1;
                                                                                                            if (TACc == 1) {
                                                                                                                GetStringArray += x8Timelength + ";" + x8CreateMapPath + ";" + CurrentValue + ";" + x8ItemTagId + ";" + x8SqDuration + ";" + x8TrackCheck;
                                                                                                            } else {
                                                                                                                GetStringArray += "," + x8Timelength + ";" + x8CreateMapPath + ";" + CurrentValue + ";" + x8ItemTagId + ";" + x8SqDuration + ";" + x8TrackCheck;
                                                                                                            }
                                                                                                            //***SFSQFSSFQQFQF77575
                                                                                                        }
                                                                                                    }
                                                                                                    /*🔻◉◉◉◉◉◉◉◉◉◉( Sequence columns 9 )◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉ 🔻*/
                                                                                                    if (ColumnId > ReadAllArrayValue[15] || ReadAllArray == true) {
                                                                                                        ECForeachReverseDocument(IsReverse, [x8inode], ["Sequence"], function (x9inode, x9Value, x9Cc) {
                                                                                                            var x9TrackCheck = ConstructAnimatedSequenceTrackCheck(x9inode, Element, ReadAllArray);
                                                                                                            if (x9TrackCheck == true) {
                                                                                                                var x9Getlength = x9inode.getAttribute("length");
                                                                                                                var x9SqDuration = "auto";
                                                                                                                if (x9inode.getAttribute("duration") != null) {
                                                                                                                    x9SqDuration = x9inode.getAttribute("duration");
                                                                                                                }
                                                                                                                var x9ItemTagId = "";
                                                                                                                if (x9inode.getAttribute("id") != null) {
                                                                                                                    x9ItemTagId = x9inode.getAttribute("id");
                                                                                                                } else {
                                                                                                                    var x9Gnid = "sq_" + ECRandomId();
                                                                                                                    x9ItemTagId = x9Gnid;
                                                                                                                    x9inode.setAttribute("id", x9ItemTagId);
                                                                                                                }
                                                                                                                var x9Timelength = parseInt(x9Getlength, 10);
                                                                                                                var x9GetName = x9inode.getAttribute("name");
                                                                                                                x9Citem += 1;
                                                                                                                if (ColumnId == ReadAllArrayValue[16] || ReadAllArray == true) {
                                                                                                                    if (ReadAllArray == true) { ColumnId = ReadAllArrayValue[16]; }
                                                                                                                    CurrentValue = x1Timelength + x2Timelength + x3Timelength + x4Timelength + x5Timelength + x6Timelength + x7Timelength + x8Timelength + x9Timelength;
                                                                                                                    var x9CreateMapPath = ColumnTxt + ColumnId + '/' + ItemTxt + x9Citem;
                                                                                                                    if (ReadAllArray == false) {
                                                                                                                        Callback(x9CreateMapPath, x9Timelength, x9GetName, x9Cc, x9inode, CurrentValue, x9SqDuration);
                                                                                                                    } else {
                                                                                                                        TACc += 1;
                                                                                                                        if (TACc == 1) {
                                                                                                                            GetStringArray += x9Timelength + ";" + x9CreateMapPath + ";" + CurrentValue + ";" + x9ItemTagId + ";" + x9SqDuration + ";" + x9TrackCheck;
                                                                                                                        } else {
                                                                                                                            GetStringArray += "," + x9Timelength + ";" + x9CreateMapPath + ";" + CurrentValue + ";" + x9ItemTagId + ";" + x9SqDuration + ";" + x9TrackCheck;
                                                                                                                        }
                                                                                                                        //***SFSQFSSFQQFQF77575
                                                                                                                    }
                                                                                                                }
                                                                                                                /*🔻◉◉◉◉◉◉◉◉◉◉( Sequence columns 10 )◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉ 🔻*/
                                                                                                                if (ColumnId > ReadAllArrayValue[17] || ReadAllArray == true) {
                                                                                                                    ECForeachReverseDocument(IsReverse, [x9inode], ["Sequence"], function (x10inode, x10Value, x10Cc) {
                                                                                                                        var x10TrackCheck = ConstructAnimatedSequenceTrackCheck(x10inode, Element, ReadAllArray);
                                                                                                                        if (x10TrackCheck == true) {
                                                                                                                            var x10Getlength = x10inode.getAttribute("length");
                                                                                                                            var x10SqDuration = "auto";
                                                                                                                            if (x10inode.getAttribute("duration") != null) {
                                                                                                                                x10SqDuration = x10inode.getAttribute("duration");
                                                                                                                            }
                                                                                                                            var x10ItemTagId = "";
                                                                                                                            if (x10inode.getAttribute("id") != null) {
                                                                                                                                x10ItemTagId = x10inode.getAttribute("id");
                                                                                                                            } else {
                                                                                                                                var x10Gnid = "sq_" + ECRandomId();
                                                                                                                                x10ItemTagId = x10Gnid;
                                                                                                                                x10inode.setAttribute("id", x10ItemTagId);
                                                                                                                            }
                                                                                                                            var x10Timelength = parseInt(x10Getlength, 10);
                                                                                                                            var x10GetName = x10inode.getAttribute("name");
                                                                                                                            x10Citem += 1;
                                                                                                                            if (ColumnId == ReadAllArrayValue[18] || ReadAllArray == true) {
                                                                                                                                if (ReadAllArray == true) { ColumnId = ReadAllArrayValue[18]; }
                                                                                                                                CurrentValue = x1Timelength + x2Timelength + x3Timelength + x4Timelength + x5Timelength + x6Timelength + x7Timelength + x8Timelength + x9Timelength + x10Timelength;
                                                                                                                                var x10CreateMapPath = ColumnTxt + ColumnId + '/' + ItemTxt + x10Citem;
                                                                                                                                if (ReadAllArray == false) {
                                                                                                                                    Callback(x10CreateMapPath, x10Timelength, x10GetName, x10Cc, x10inode, CurrentValue, x10SqDuration);
                                                                                                                                } else {
                                                                                                                                    TACc += 1;
                                                                                                                                    if (TACc == 1) {
                                                                                                                                        GetStringArray += x10Timelength + ";" + x10CreateMapPath + ";" + CurrentValue + ";" + x10ItemTagId + ";" + x10SqDuration + ";" + x10TrackCheck;
                                                                                                                                    } else {
                                                                                                                                        GetStringArray += "," + x10Timelength + ";" + x10CreateMapPath + ";" + CurrentValue + ";" + x10ItemTagId + ";" + x10SqDuration + ";" + x10TrackCheck;
                                                                                                                                    }
                                                                                                                                    //***SFSQFSSFQQFQF77575
                                                                                                                                }
                                                                                                                            }
                                                                                                                            /*🔻◉◉◉◉◉◉◉◉◉◉( Sequence columns 11 )◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉ 🔻*/
                                                                                                                            if (ColumnId > ReadAllArrayValue[19] || ReadAllArray == true) {
                                                                                                                                ECForeachReverseDocument(IsReverse, [x10inode], ["Sequence"], function (x11inode, x11Value, x11Cc) {
                                                                                                                                    var x11TrackCheck = ConstructAnimatedSequenceTrackCheck(x11inode, Element, ReadAllArray);
                                                                                                                                    if (x11TrackCheck == true) {
                                                                                                                                        var x11Getlength = x11inode.getAttribute("length");
                                                                                                                                        var x11SqDuration = "auto";
                                                                                                                                        if (x11inode.getAttribute("duration") != null) {
                                                                                                                                            x11SqDuration = x11inode.getAttribute("duration");
                                                                                                                                        }
                                                                                                                                        var x11ItemTagId = "";
                                                                                                                                        if (x11inode.getAttribute("id") != null) {
                                                                                                                                            x11ItemTagId = x11inode.getAttribute("id");
                                                                                                                                        } else {
                                                                                                                                            var x11Gnid = "sq_" + ECRandomId();
                                                                                                                                            x11ItemTagId = x11Gnid;
                                                                                                                                            x11inode.setAttribute("id", x11ItemTagId);
                                                                                                                                        }
                                                                                                                                        var x11Timelength = parseInt(x11Getlength, 11);
                                                                                                                                        var x11GetName = x11inode.getAttribute("name");
                                                                                                                                        x11Citem += 1;
                                                                                                                                        if (ColumnId == ReadAllArrayValue[20] || ReadAllArray == true) {
                                                                                                                                            if (ReadAllArray == true) { ColumnId = ReadAllArrayValue[20]; }
                                                                                                                                            CurrentValue = x1Timelength + x2Timelength + x3Timelength + x4Timelength + x5Timelength + x6Timelength + x7Timelength + x8Timelength + x9Timelength + x10Timelength + x11Timelength;
                                                                                                                                            var x11CreateMapPath = ColumnTxt + ColumnId + '/' + ItemTxt + x11Citem;
                                                                                                                                            if (ReadAllArray == false) {
                                                                                                                                                Callback(x11CreateMapPath, x11Timelength, x11GetName, x11Cc, x11inode, CurrentValue, x11SqDuration);
                                                                                                                                            } else {
                                                                                                                                                TACc += 1;
                                                                                                                                                if (TACc == 1) {
                                                                                                                                                    GetStringArray += x11Timelength + ";" + x11CreateMapPath + ";" + CurrentValue + ";" + x11ItemTagId + ";" + x11SqDuration + ";" + x11TrackCheck;
                                                                                                                                                } else {
                                                                                                                                                    GetStringArray += "," + x11Timelength + ";" + x11CreateMapPath + ";" + CurrentValue + ";" + x11ItemTagId + ";" + x11SqDuration + ";" + x11TrackCheck;
                                                                                                                                                }
                                                                                                                                                //***SFSQFSSFQQFQF77575
                                                                                                                                            }
                                                                                                                                        }

                                                                                                                                        /*🔻◉◉◉◉◉◉◉◉◉◉( Sequence columns 12 )◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉ 🔻*/
                                                                                                                                        if (ColumnId > ReadAllArrayValue[21] || ReadAllArray == true) {
                                                                                                                                            ECForeachReverseDocument(IsReverse, [x11inode], ["Sequence"], function (x12inode, x12Value, x12Cc) {
                                                                                                                                                var x12TrackCheck = ConstructAnimatedSequenceTrackCheck(x12inode, Element, ReadAllArray);
                                                                                                                                                if (x12TrackCheck == true) {
                                                                                                                                                    var x12Getlength = x12inode.getAttribute("length");
                                                                                                                                                    var x12SqDuration = "auto";
                                                                                                                                                    if (x12inode.getAttribute("duration") != null) {
                                                                                                                                                        x12SqDuration = x12inode.getAttribute("duration");
                                                                                                                                                    }
                                                                                                                                                    var x12ItemTagId = "";
                                                                                                                                                    if (x12inode.getAttribute("id") != null) {
                                                                                                                                                        x12ItemTagId = x12inode.getAttribute("id");
                                                                                                                                                    } else {
                                                                                                                                                        var x12Gnid = "sq_" + ECRandomId();
                                                                                                                                                        x12ItemTagId = x12Gnid;
                                                                                                                                                        x12inode.setAttribute("id", x12ItemTagId);
                                                                                                                                                    }
                                                                                                                                                    var x12Timelength = parseInt(x12Getlength, 12);
                                                                                                                                                    var x12GetName = x12inode.getAttribute("name");
                                                                                                                                                    x12Citem += 1;
                                                                                                                                                    if (ColumnId == ReadAllArrayValue[22] || ReadAllArray == true) {
                                                                                                                                                        if (ReadAllArray == true) { ColumnId = ReadAllArrayValue[22]; }
                                                                                                                                                        CurrentValue = x1Timelength + x2Timelength + x3Timelength + x4Timelength + x5Timelength + x6Timelength + x7Timelength + x8Timelength + x9Timelength + x10Timelength + x11Timelength + x12Timelength;
                                                                                                                                                        var x12CreateMapPath = ColumnTxt + ColumnId + '/' + ItemTxt + x12Citem;
                                                                                                                                                        if (ReadAllArray == false) {
                                                                                                                                                            Callback(x12CreateMapPath, x12Timelength, x12GetName, x12Cc, x12inode, CurrentValue, x12SqDuration);
                                                                                                                                                        } else {
                                                                                                                                                            TACc += 1;
                                                                                                                                                            if (TACc == 1) {
                                                                                                                                                                GetStringArray += x12Timelength + ";" + x12CreateMapPath + ";" + CurrentValue + ";" + x12ItemTagId + ";" + x12SqDuration + ";" + x12TrackCheck;
                                                                                                                                                            } else {
                                                                                                                                                                GetStringArray += "," + x12Timelength + ";" + x12CreateMapPath + ";" + CurrentValue + ";" + x12ItemTagId + ";" + x12SqDuration + ";" + x12TrackCheck;
                                                                                                                                                            }
                                                                                                                                                            //***SFSQFSSFQQFQF77575
                                                                                                                                                        }
                                                                                                                                                    }

                                                                                                                                                    /*🔻◉◉◉◉◉◉◉◉◉◉( Sequence columns 13 )◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉◉ 🔻*/
                                                                                                                                                    if (ColumnId > ReadAllArrayValue[23] || ReadAllArray == true) {
                                                                                                                                                        ECForeachReverseDocument(IsReverse, [x12inode], ["Sequence"], function (x13inode, x13Value, x13Cc) {
                                                                                                                                                            var x13TrackCheck = ConstructAnimatedSequenceTrackCheck(x13inode, Element, ReadAllArray);
                                                                                                                                                            if (x13TrackCheck == true) {
                                                                                                                                                                var x13Getlength = x13inode.getAttribute("length");
                                                                                                                                                                var x13SqDuration = "auto";
                                                                                                                                                                if (x13inode.getAttribute("duration") != null) {
                                                                                                                                                                    x13SqDuration = x13inode.getAttribute("duration");
                                                                                                                                                                }
                                                                                                                                                                var x13ItemTagId = "";
                                                                                                                                                                if (x13inode.getAttribute("id") != null) {
                                                                                                                                                                    x13ItemTagId = x13inode.getAttribute("id");
                                                                                                                                                                } else {
                                                                                                                                                                    var x13Gnid = "sq_" + ECRandomId();
                                                                                                                                                                    x13ItemTagId = x13Gnid;
                                                                                                                                                                    x13inode.setAttribute("id", x13ItemTagId);
                                                                                                                                                                }
                                                                                                                                                                var x13Timelength = parseInt(x13Getlength, 13);
                                                                                                                                                                var x13GetName = x13inode.getAttribute("name");

                                                                                                                                                                x13Citem += 1;
                                                                                                                                                                if (ColumnId == ReadAllArrayValue[24] || ReadAllArray == true) {
                                                                                                                                                                    if (ReadAllArray == true) { ColumnId = ReadAllArrayValue[24]; }
                                                                                                                                                                    CurrentValue = x1Timelength + x2Timelength + x3Timelength + x4Timelength + x5Timelength + x6Timelength + x7Timelength + x8Timelength + x9Timelength + x10Timelength + x12Timelength + x13Timelength;
                                                                                                                                                                    var x13CreateMapPath = ColumnTxt + ColumnId + '/' + ItemTxt + x13Citem;
                                                                                                                                                                    if (ReadAllArray == false) {
                                                                                                                                                                        Callback(x13CreateMapPath, x13Timelength, x13GetName, x13Cc, x13inode, CurrentValue, x13SqDuration);
                                                                                                                                                                    } else {
                                                                                                                                                                        TACc += 1;
                                                                                                                                                                        if (TACc == 1) {
                                                                                                                                                                            GetStringArray += x13Timelength + ";" + x13CreateMapPath + ";" + CurrentValue + ";" + x13ItemTagId + ";" + x13SqDuration + ";" + x13TrackCheck;
                                                                                                                                                                        } else {
                                                                                                                                                                            GetStringArray += "," + x13Timelength + ";" + x13CreateMapPath + ";" + CurrentValue + ";" + x13ItemTagId + ";" + x13SqDuration + ";" + x13TrackCheck;
                                                                                                                                                                        }
                                                                                                                                                                        //***SFSQFSSFQQFQF77575
                                                                                                                                                                    }
                                                                                                                                                                }

                                                                                                                                                                /*➰➰➰➰ NEXT ITEM HERE ( 13 = 14 >> 12 = 13 >>  ➰➰➰➰➰➰*/
                                                                                                                                                            }


                                                                                                                                                        });

                                                                                                                                                    }
                                                                                                                                                    /*🔺➰➰➰➰➰( Sequence columns 13 )➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰ 🔺*/
                                                                                                                                                }


                                                                                                                                            });
                                                                                                                                        }
                                                                                                                                        /*🔺➰➰➰➰➰( Sequence columns 12 )➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰ 🔺*/
                                                                                                                                    }
                                                                                                                                });
                                                                                                                            }
                                                                                                                            /*🔺➰➰➰➰➰( Sequence columns 11 )➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰ 🔺*/
                                                                                                                        }
                                                                                                                    });
                                                                                                                }
                                                                                                                /*🔺➰➰➰➰➰( Sequence columns 10 )➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰ 🔺*/
                                                                                                            }
                                                                                                        });
                                                                                                    }
                                                                                                    /*🔺➰➰➰➰➰( Sequence columns 9 )➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰ 🔺*/
                                                                                                }
                                                                                            });
                                                                                        }
                                                                                        /*🔺➰➰➰➰➰( Sequence columns 8 )➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰ 🔺*/
                                                                                    }
                                                                                });
                                                                            }
                                                                            /*🔺➰➰➰➰➰( Sequence columns 7 )➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰ 🔺*/
                                                                        }
                                                                    });
                                                                }
                                                                /*🔺➰➰➰➰➰( Sequence columns 6 )➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰ 🔺*/
                                                            }
                                                        });
                                                    }
                                                    /*🔺➰➰➰➰➰( Sequence columns 5 )➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰ 🔺*/
                                                }
                                            });
                                        }
                                        /*🔺➰➰➰➰➰( Sequence columns 4 )➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰ 🔺*/
                                    }
                                });
                            }
                            /*🔺➰➰➰➰➰( Sequence columns 3 )➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰ 🔺*/
                        }
                    });
                }
                /*🔺➰➰➰➰➰( Sequence columns 2 )➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰➰ 🔺*/
            }

        });

        if (ReadAllArray == true) {
            Callback(GetStringArray);
        }

    } catch (e) { }
}
//var xHoldeConstructAnimatedLines = "";
//var cCHoldeConstructAnimatedLines = 0;
function ConstructAnimatedLines(Duration, Element, RootElement, Cci, Cct, OutputType, FloatRange, xFilters, KeyEffect, CallBack) {
    try {
        //#C7sfsfsSW01
        //#GBMHN741101
        var CallBackSet = false;
        var ValueStr = "0";
        if (RootElement.getAttribute("value") != null && RootElement.getAttribute("value") != "") {
            ValueStr = RootElement.getAttribute("value");
        }



        var inTimeValue = parseInt(ValueStr, 10);
        ECForeachDocument([Element], ["Sequence"], function (inode, Value, Cc) {

            var Getlength = inode.getAttribute("length");
            var Timelength = parseInt(Getlength, 10);
            var GetName = inode.getAttribute("name");

            var Getlength = inode.getAttribute("tracks");

            var GetAsId = inode.getAttribute("id");
            var ArrayIsAdd = false;
            if (GetName != null) {
                var CssBack = ["", "", "", "", ""];
                ECForeachAnimatedDataBaseBySequence(GetName, function (GetUnRenderTag, GetAnimatedTag, GetFromTag, GetToTag, TargetId, UseMotion) {
                    CssBack = ConstructAnimatedTagToCssLevel(Duration, GetName, Cct, Timelength, OutputType, xFilters, FloatRange, KeyEffect);
                }, KeyEffect);
                CallBackSet = true;
                CallBack(CssBack[0], Timelength, inode, CssBack[1], CssBack[2]);
            }
        });

        if (CallBackSet == false) {



        } else {

        }

        //  document.getElementById("GGHSSGSGSG").innerHTML = " CallBack Set -  false = ( " + TTConstructAnimatedLines + " ) true = ( " + STConstructAnimatedLines + " )  ";

    } catch (e) {

    }
}
var ConstructAnimatedDisableElementCssValue = "visibility:hidden;z-index:0;opacity:0;";
var ConstructAnimatedHiddenElementCssValue = "visibility:hidden;z-index:0;";
var ConstructAnimatedVisibleElementCssValue = "visibility:inherit;z-index:inherit;";
var ConstructAnimatedEnableElementCssValue = "visibility:inherit;z-index:inherit;";
function ConstructAnimatedImportTag(Element, Name, Cc) {
    //**XX56075
    try {


        var TypeStr = "";
        if (Element.getAttribute("type") != null && Element.getAttribute("type") != "") {
            TypeStr = Element.getAttribute("type");
        }
        var xIdStr = "";
        if (Element.getAttribute("xId") != null && Element.getAttribute("xId") != "") {
            xIdStr = Element.getAttribute("xId");
        }
        var AppendStr = "false";
        if (Element.getAttribute("append") != null && Element.getAttribute("append") != "") {
            AppendStr = Element.getAttribute("append");
        }
        var IsAppend = ECConvertToBoolean(AppendStr);
        if (TypeStr.toLowerCase() == "text/css") {
            try {
                var BaseIdx = "imp_" + ECRandomId();
                if (xIdStr.trim() != "") {
                    BaseIdx = xIdStr;
                }
                var GetAsStyleTag = ECCreateXmlData("Tls_", BaseIdx, "style", "head", ["['type','text/css']"], false);
                if (IsAppend == true) {
                    GetAsStyleTag.innerHTML += Element.innerHTML;

                } else {
                    GetAsStyleTag.innerHTML = Element.innerHTML;
                }
                //  GetAsStyleTag.innerHTML = BaseIdx;
                //  alert(xIdStr + " | " + Element.innerHTML);


            } catch (e) { }
        }


        // 


        // alert(TypeStr);

    } catch (e) { }
}
function ConstructAnimatedTagToCssLevel(Duration, GetName, Cct, Timelength, OutputType, xFilters, FloatRange, KeyEffect) {

    var outers = "";
    try {
        var CssIdKeys = "";
        var CssMetaData = "";
        var CssMetaCommand = "run";



        var DrnCc = 0;

        ECForeachAnimatedDataBaseBySequence(GetName, function (GetUnRenderTag, GetAnimatedTag, GetFromTag, GetToTag, TargetId, UseMotion) {
            var ReadCss = "";

            var HiddenAnimated = false;
            var VisibleAnimated = false;

            var ClearAnimated = false;

            var EnableElement = false;
            var ReturnElement = false;



            //#C70S1101
            var IsAddCssData = true;
            if (OutputType.toLowerCase() == "remove.static".toLowerCase()) {
                //if (xFilters != "*")
                //{
                //    try
                //    {
                //       //  document.getElementById("GGHSSGSGSG").innerHTML = xFilters;// + " T X-false";
                //        var CssTargetArray = xFilters.split(",");  
                //        for (var Car = 0; Car < CssTargetArray.length; Car++)
                //        {
                //            var Tidx = CssTargetArray[Car];
                //            if (Tidx.trim() != "")
                //            {
                //                if (Tidx.toLowerCase() == TargetId.toLowerCase())
                //                {
                //                      IsAddCssData = false;
                //                }
                //            }
                //        }
                //    } catch (e) { }
                //}
            }

            if (IsAddCssData == true) {
                var DisableElement = false;
                var ExecuteCss = true;

                ECForeachByTargetElement(GetAnimatedTag, ["location", "Points", "opacity", "Rotation", "Size", "BgArgb", "Skew", "Scale", "Typewriter", "clear", "disable", "enable", "return", "hidden", "visible"], function (Ancinode, AncValue, AncCc) {

                    /*╱╱[ Disable  Element ] ╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱*/
                    if (AncValue.toLowerCase() == "disable".toLowerCase()) {
                        ///   alert(GetName + " >< " + TargetId);
                        // document.getElementById("GGHSSGSGSG").innerHTML +=   GetName + " / " + TargetId + " | ";
                        DisableElement = true;
                        ExecuteCss = false;
                        // ReadCss = ConstructAnimatedDisableElementCssValue;

                    }
                    /*╱╱[ Clear  Animated ] ╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱*/
                    if (AncValue.toLowerCase() == "clear".toLowerCase()) {
                        ClearAnimated = true;
                    }
                    /*╱╱[ Hidden  Animated ] ╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱*/
                    if (AncValue.toLowerCase() == "Hidden".toLowerCase()) {
                        HiddenAnimated = true;
                    }

                    /*╱╱[ Enable  Element ] ╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱*/
                    if (AncValue.toLowerCase() == "Enable".toLowerCase()) {
                        EnableElement = true;
                        ReadCss += ConstructAnimatedEnableElementCssValue;
                    }
                    /*╱╱[ Return  Element ] ╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱*/
                    if (AncValue.toLowerCase() == "Return".toLowerCase()) {
                        ReturnElement = true;

                    }
                    /*╱╱[ Visible  Element ] ╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱*/
                    if (AncValue.toLowerCase() == "Visible".toLowerCase()) {
                        VisibleAnimated = true;

                    }
                    if (ExecuteCss == true) {

                        /*╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱*/
                        if (AncValue.toLowerCase() == "location".toLowerCase() ||
                            AncValue.toLowerCase() == "Points".toLowerCase() ||
                            AncValue.toLowerCase() == "Skew".toLowerCase() ||
                            AncValue.toLowerCase() == "Scale".toLowerCase()) {
                            try {

                                var UseCssLeft = false;
                                var UseCssTop = false;

                                var XFV = 0;
                                var YFV = 0;

                                var GetFromValue = Ancinode.getAttribute("from");
                                ECForeachCssProperty(GetFromValue, function (xKey, xValue) {
                                    if (xKey.toLowerCase() == "x") {
                                        XFV = parseInt(xValue, 10);
                                    }
                                    if (xKey.toLowerCase() == "y") {
                                        YFV = parseInt(xValue, 10);
                                    }
                                });

                                var XTV = 0;
                                var YTV = 0;

                                var GetToValue = Ancinode.getAttribute("to");
                                ECForeachCssProperty(GetToValue, function (xKey, xValue) {
                                    if (xKey.toLowerCase() == "x") {
                                        XTV = parseInt(xValue, 10);
                                        UseCssLeft = true;
                                    }
                                    if (xKey.toLowerCase() == "y") {
                                        YTV = parseInt(xValue, 10);
                                        UseCssTop = true;
                                    }
                                });

                                var XFFV = XTV - XFV;
                                var YFFV = YTV - YFV;

                                var XMLV = ConvertTOTimerlengthPercentage(Cct, Timelength, XFFV) + XFV;
                                var XYLV = ConvertTOTimerlengthPercentage(Cct, Timelength, YFFV) + YFV;

                                /*╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱*/
                                if (AncValue.toLowerCase() == "location".toLowerCase()) {
                                    if (UseCssLeft == true) { ReadCss += " margin-left:" + parseFloat(XMLV).toFixed(FloatRange) + "px;"; }
                                    if (UseCssTop == true) { ReadCss += " margin-top:" + parseFloat(XYLV).toFixed(FloatRange) + "px;"; }
                                }
                                /*╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱*/
                                if (AncValue.toLowerCase() == "Points".toLowerCase()) {
                                    if (UseCssLeft == true) { ReadCss += " left:" + parseFloat(XMLV).toFixed(FloatRange) + "px;"; }
                                    if (UseCssTop == true) { ReadCss += " top:" + parseFloat(XYLV).toFixed(FloatRange) + "px;"; }
                                }
                                /*╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱*/
                                if (AncValue.toLowerCase() == "Skew".toLowerCase()) {
                                    if (UseCssLeft == true) { ReadCss += " transform: skewX(" + XMLV + "deg);"; }
                                    if (UseCssTop == true) { ReadCss += " transform: skewY(" + XYLV + "deg);"; }

                                }
                                /*╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱*/
                                if (AncValue.toLowerCase() == "Scale".toLowerCase()) {
                                    if (UseCssLeft == true) { ReadCss += " transform: scaleX(" + XMLV + ");"; }
                                    if (UseCssTop == true) { ReadCss += " transform: scaleY(" + XYLV + ");"; }
                                }
                            } catch (e) {

                            }
                        }
                        /*╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱*/
                        if (AncValue.toLowerCase() == "opacity".toLowerCase()) {
                            try {
                                var UseCssOpacity = false;
                                var OFV = 0;
                                var GetFromValue = Ancinode.getAttribute("from");
                                ECForeachCssProperty(GetFromValue, function (xKey, xValue) {
                                    if (xKey.toLowerCase() == "value".toLowerCase()) {
                                        OFV = parseInt(xValue, 10);
                                    }

                                });
                                var OTV = 0;
                                var GetToValue = Ancinode.getAttribute("to");
                                ECForeachCssProperty(GetToValue, function (xKey, xValue) {
                                    if (xKey.toLowerCase() == "value") {
                                        OTV = parseInt(xValue, 10);
                                        UseCssOpacity = true;
                                    }

                                });
                                var OFTV = OTV - OFV;
                                var OLV = ConvertTOTimerlengthPercentage(Cct, Timelength, OFTV) + OFV;
                                var OpacityValue = OLV / 100;
                                if (UseCssOpacity == true) {
                                    ReadCss += " Opacity:" + parseFloat(OpacityValue).toFixed(FloatRange) + ";";
                                }

                            } catch (e) { }
                        }
                        /*╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱*/
                        if (AncValue.toLowerCase() == "Rotation".toLowerCase()) {
                            try {

                                var UseCssRotation = false;
                                var OFV = 0;
                                var GetFromValue = Ancinode.getAttribute("from");
                                ECForeachCssProperty(GetFromValue, function (xKey, xValue) {
                                    if (xKey.toLowerCase() == "size".toLowerCase()) {
                                        OFV = parseInt(xValue, 10);
                                    }

                                });
                                var OTV = 0;
                                var GetToValue = Ancinode.getAttribute("to");
                                ECForeachCssProperty(GetToValue, function (xKey, xValue) {
                                    if (xKey.toLowerCase() == "size") {
                                        OTV = parseInt(xValue, 10);
                                        UseCssRotation = true;
                                    }

                                });
                                var OFTV = OTV - OFV;
                                var OLV = ConvertTOTimerlengthPercentage(Cct, Timelength, OFTV) + OFV;
                                if (UseCssRotation == true) {
                                    ReadCss += " transform: rotate(" + OLV + "deg) ;";

                                }

                            } catch (e) { }
                        }
                        /*╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱*/
                        if (AncValue.toLowerCase() == "Size".toLowerCase()) {

                            try {
                                var UseCssWidth = false;
                                var UseCssHeight = false;

                                var XFV = 0;
                                var YFV = 0;

                                var GetFromValue = Ancinode.getAttribute("from");
                                ECForeachCssProperty(GetFromValue, function (xKey, xValue) {
                                    if (xKey.toLowerCase() == "width") {
                                        XFV = parseInt(xValue, 10);
                                    }
                                    if (xKey.toLowerCase() == "height") {
                                        YFV = parseInt(xValue, 10);
                                    }
                                });



                                var XTV = 0;
                                var YTV = 0;

                                var GetToValue = Ancinode.getAttribute("to");
                                ECForeachCssProperty(GetToValue, function (xKey, xValue) {
                                    if (xKey.toLowerCase() == "width") {
                                        XTV = parseInt(xValue, 10);
                                        UseCssWidth = true;
                                    }
                                    if (xKey.toLowerCase() == "height") {
                                        YTV = parseInt(xValue, 10);
                                        UseCssHeight = true;
                                    }
                                });

                                var XFFV = XTV - XFV;
                                var YFFV = YTV - YFV;

                                var XMLV = ConvertTOTimerlengthPercentage(Cct, Timelength, XFFV) + XFV;
                                var XYLV = ConvertTOTimerlengthPercentage(Cct, Timelength, YFFV) + YFV;

                                var CCF = "";

                                if (UseCssWidth == true) { ReadCss += " width:" + XMLV + "px;"; CCF += " width:" + XMLV + "px;"; }
                                if (UseCssHeight == true) { ReadCss += " height:" + XYLV + "px;"; CCF += " height:" + XYLV + "px;"; }

                                if (GetName.toLowerCase() == "3E-Animated".toLowerCase()) {
                                    // Components
                                    //  document.getElementById("GGHSSGSGSG").innerHTML = "<p>" + TargetId + " , " +  CCF + "<p>";
                                }


                            } catch (e) { }
                        }
                        /*╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱*/
                        if (AncValue.toLowerCase() == "BgArgb".toLowerCase()) {
                            try {

                                var UseCssA = false;
                                var UseCssR = false;
                                var UseCssG = false;
                                var UseCssB = false;

                                var AFV = 0;
                                var RFV = 0;
                                var GFV = 0;
                                var BFV = 0;

                                var GetFromValue = Ancinode.getAttribute("from");
                                ECForeachCssProperty(GetFromValue, function (xKey, xValue) {
                                    if (xKey.toLowerCase() == "a") {
                                        AFV = parseInt(xValue, 10);
                                    }
                                    if (xKey.toLowerCase() == "r") {
                                        RFV = parseInt(xValue, 10);
                                    }
                                    if (xKey.toLowerCase() == "g") {
                                        GFV = parseInt(xValue, 10);
                                    }
                                    if (xKey.toLowerCase() == "b") {
                                        BFV = parseInt(xValue, 10);
                                    }
                                });

                                var ATV = 0;
                                var RTV = 0;
                                var GTV = 0;
                                var BTV = 0;

                                var GetToValue = Ancinode.getAttribute("to");
                                ECForeachCssProperty(GetToValue, function (xKey, xValue) {
                                    if (xKey.toLowerCase() == "a") {
                                        ATV = parseInt(xValue, 10);
                                        UseCssA = true;
                                    }
                                    if (xKey.toLowerCase() == "r") {
                                        RTV = parseInt(xValue, 10);
                                        UseCssR = true;
                                    }
                                    if (xKey.toLowerCase() == "g") {
                                        GTV = parseInt(xValue, 10);
                                        UseCssG = true;
                                    }
                                    if (xKey.toLowerCase() == "b") {
                                        BTV = parseInt(xValue, 10);
                                        UseCssB = true;
                                    }
                                });

                                var AFFV = ATV - AFV;
                                var RFFV = RTV - RFV;
                                var GFFV = GTV - GFV;
                                var BFFV = BTV - BFV;

                                var AMLV = ConvertTOTimerlengthPercentage(Cct, Timelength, AFFV) + AFV;
                                var RMLV = ConvertTOTimerlengthPercentage(Cct, Timelength, RFFV) + RFV;
                                var GMLV = ConvertTOTimerlengthPercentage(Cct, Timelength, GFFV) + GFV;
                                var BMLV = ConvertTOTimerlengthPercentage(Cct, Timelength, BFFV) + BFV;


                                if (UseCssA == true && UseCssR == true &&
                                    UseCssG == true && UseCssB == true) { ReadCss += " background-color:rgba(" + RMLV + "," + GMLV + "," + BMLV + "," + AMLV + ");"; }

                            } catch (e) { }



                        }
                    }

                });

                //*************************************
                if (ExecuteCss == true) {
                    var GetOption = ECStandardDataPosition(ECConvertRootElementToBase(TargetId));
                    var Visualport = GetOption[2];
                    var ElementType = GetOption[5];
                    if (Visualport == true) {
                        /*⬛⬛[ grid ]⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛*/
                        if (ElementType.toLowerCase() == ECInitializingRegisterTags[0].toLowerCase()) {
                            ReadCss += "position:absolute; ";
                        }
                        /*⬛⬛[ TextView ]⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛*/
                        if (ElementType.toLowerCase() == ECInitializingRegisterTags[1].toLowerCase()) {
                            ReadCss += "position:absolute; ";
                        }
                        /*⬛⬛[ imageBox ]⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛*/
                        if (ElementType.toLowerCase() == ECInitializingRegisterTags[2].toLowerCase()) {
                            ReadCss += "position:absolute; ";
                        }
                    }
                }

                if (OutputType.toLowerCase() == "live".toLowerCase()) {
                    CssIdKeys += "#" + TargetId;
                    CssMetaData += " #" + TargetId + "{" + ReadCss + "} ";
                }
                if (OutputType.toLowerCase() == "static".toLowerCase() || OutputType.toLowerCase() == "remove.static".toLowerCase()) {
                    var DurationItem = "";
                    var DurationInUse = false;
                    try {
                        if (Duration != null) {
                            if (Duration.trim() != "") {
                                var SplitDrn = Duration.split(",");
                                DrnCc += 1;
                                var LDrnCc = DrnCc - 1;

                                for (var xNr = 0; xNr < SplitDrn.length; xNr++) {
                                    var iDrn = SplitDrn[xNr];
                                    if (LDrnCc == xNr) {
                                        DurationItem = iDrn;
                                        DurationInUse = true;
                                    }
                                }

                            }

                        }


                    } catch (e) {

                    }
                    if (DurationInUse == false) {
                        DurationItem = Duration;
                    }

                    var SetAnimatedInline = ECAnimatedCss(DurationItem);

                    if (HiddenAnimated == true) {
                        SetAnimatedInline = ConstructAnimatedHiddenElementCssValue;

                    }
                    if (DisableElement == true) {
                        SetAnimatedInline = "";
                        ReadCss = ConstructAnimatedDisableElementCssValue;
                    }
                    if (EnableElement == true) {

                    }
                    if (VisibleAnimated == true) {
                        ReadCss += ConstructAnimatedVisibleElementCssValue;
                    }
                    if (UseMotion == false) {
                        SetAnimatedInline = "";

                    }
                    CssIdKeys += "#" + TargetId;
                    CssMetaData += " #" + TargetId + "{" + ReadCss + ' ' + SetAnimatedInline + "} ";
                    //if (GetName.toLowerCase() == "3E-Animated".toLowerCase())
                    //{
                    //  //  document.getElementById("GGHSSGSGSG").innerHTML += "<p>" + CssMetaData + "<p>";
                    //}

                }
                if (OutputType.toLowerCase() == "target".toLowerCase()) {
                    // CssMetaData += "# " + GetName;
                }
                if (DisableElement == true) {
                    // CssMetaData = "";
                    CssMetaCommand = "clear";
                }
            }
        }, KeyEffect);
        //  85sf!ffa
        //9779
        outers = [CssMetaData, CssIdKeys, CssMetaCommand];

    } catch (e) {

    }
    return outers;
}
/*⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛*/
/*◘◘◘◘◘◘◘◘◘ References ▲ ◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘*/
/*╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱*/
/*██████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████*/
/*◘◘◘◘◘◘◘◘◘ Standard library ▼ ◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘*/
/*╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱*/
/*↓↓↓↓↓ • Short commands • ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓*/
function ECGetElementByName(ElementName) {
    var outers = null;
    try {
        ECForeachElement("Tag", ECInitializingRegisterConfigTags, function (item, Value, Cc) {
            if (item.getAttribute("name") != null) {
                var getAsName = item.getAttribute("name");
                if (getAsName.toLowerCase() == ElementName.toLowerCase()) {
                    outers = item;
                }
            }

        });
        ECForeachElement("Tag", ECInitializingRegisterTags, function (item, Value, Cc) {
            if (item.getAttribute("name") != null) {
                var getAsName = item.getAttribute("name");
                if (getAsName.toLowerCase() == ElementName.toLowerCase()) {
                    outers = item;
                }
            }
        });
    } catch (e) { }
    return outers;
}
function ECForeachElement(Target, Values, CallBack) {
    try {

        for (var iv = 0; iv < Values.length; ++iv) {
            var Value = Values[iv];
            var elements = null;
            var Cc = 0;
            if (Target.toLowerCase() == "Class".toLowerCase()) {
                elements = document.getElementsByClassName(Value);
            }
            if (Target.toLowerCase() == "Tag".toLowerCase()) {
                elements = document.getElementsByTagName(Value);
            }
            if (Target.toLowerCase() == "id".toLowerCase()) {
                elements = document.getElementById(Value);
            }
            for (var i = 0; i < elements.length; ++i) {
                var item = elements[i];
                Cc += 1;
                CallBack(item, Value, Cc);
            }
        }
    } catch (e) {

    }
}
function ECForeachDocument(Elements, Filters, CallBack) {
    try {
        var Cc = 0;
        for (var iv = 0; iv < Elements.length; ++iv) {
            var Value = Elements[iv];
            for (var r = 0; r < Value.childNodes.length; r++) {
                var inode = Value.childNodes[r];
                for (var ifv = 0; ifv < Filters.length; ++ifv) {
                    var Filter = Filters[ifv];
                    var IsFiltered = false;
                    if (Filter.toLowerCase() == "*") {
                        IsFiltered = true;
                    }
                    if (inode.nodeType == Node.ELEMENT_NODE && inode.nodeName.toLowerCase() == Filter.toLowerCase()) {
                        IsFiltered = true;
                    }
                    if (IsFiltered == true) {
                        Cc += 1;
                        CallBack(inode, inode.nodeName, Cc);
                    }
                }

            }


        }
    } catch (e) {

    }
}
function ECForeachReverseDocument(IsReverse, Elements, Filters, CallBack) {
    try {
        if (IsReverse == true) {
            var Rcc = 1;
            for (var iv = 0; iv < Elements.length; ++iv) {
                var Value = Elements[iv];
                for (var r = Value.childNodes.length; r >= 0; r--) {
                    var inode = Value.childNodes[r];
                    if (inode != null) {
                        for (var ifv = 0; ifv < Filters.length; ++ifv) {
                            var Filter = Filters[ifv];
                            var IsFiltered = false;
                            if (Filter.toLowerCase() == "*") {
                                IsFiltered = true;
                            }
                            if (inode.nodeType == Node.ELEMENT_NODE && inode.nodeName.toLowerCase() == Filter.toLowerCase()) {
                                IsFiltered = true;
                            }
                            if (IsFiltered == true) {
                                Rcc += 1;
                            }
                        }
                    }
                }
            }

            for (var iv = 0; iv < Elements.length; ++iv) {
                var Value = Elements[iv];
                for (var r = Value.childNodes.length; r >= 0; r--) {
                    var inode = Value.childNodes[r];
                    if (inode != null) {
                        for (var ifv = 0; ifv < Filters.length; ++ifv) {
                            var Filter = Filters[ifv];
                            var IsFiltered = false;
                            if (Filter.toLowerCase() == "*") {
                                IsFiltered = true;
                            }
                            if (inode.nodeType == Node.ELEMENT_NODE && inode.nodeName.toLowerCase() == Filter.toLowerCase()) {
                                IsFiltered = true;
                            }
                            if (IsFiltered == true) {
                                Rcc -= 1;
                                CallBack(inode, inode.nodeName, Rcc);
                            }
                        }
                    }
                }
            }
        }
        if (IsReverse == false) {
            ECForeachDocument(Elements, Filters, function (R_inode, R_NodeName, R_Cc) {
                CallBack(R_inode, R_NodeName, R_Cc);
            });
        }
    } catch (e) {

    }
}
function ECForeachDocumentCount(Elements, Filters) {
    var outers = 0;
    try {


        var Cc = 0;
        for (var iv = 0; iv < Elements.length; ++iv) {
            var Value = Elements[iv];
            for (var r = 0; r < Value.childNodes.length; r++) {
                var inode = Value.childNodes[r];
                for (var ifv = 0; ifv < Filters.length; ++ifv) {
                    var Filter = Filters[ifv];
                    var IsFiltered = false;
                    if (Filter.toLowerCase() == "*") {
                        IsFiltered = true;
                        Cc += 1;
                    }
                    if (inode.nodeType == Node.ELEMENT_NODE && inode.nodeName.toLowerCase() == Filter.toLowerCase()) {
                        IsFiltered = true;
                        Cc += 1;
                    }

                }

            }
        }
        outers = Cc;
    } catch (e) {

    }
    return outers;
}
function ECForeachAttributes(Element, Callback) {
    try {
        for (var cvi = 0, atts = Element.attributes, ncv = atts.length, arr = []; cvi < ncv; cvi++) {
            var GetName = atts[cvi].nodeName.toLowerCase();
            var GetValue = Element.getAttribute(GetName);
            Callback(GetName, GetValue);
        }
    } catch (e) { }
}
function ECForeachComArray(Value, Callback) {
    try {
        if (Value.trim() != "") {
            var Cc = 0;
            var comTexts = Value.split(",");
            for (var r = 0; r < comTexts.length; r++) {
                var comText = comTexts[r];
                if (comText.trim() != "") {
                    Cc += 1;
                    Callback(comText, Cc);
                }
            }

        }

    } catch (e) { }
}
function ECForeachSlashrray(Value, Callback) {
    try {
        if (Value.trim() != "") {
            var Cc = 0;
            var comTexts = Value.split("/");
            for (var r = 0; r < comTexts.length; r++) {
                var comText = comTexts[r];
                if (comText.trim() != "") {
                    Cc += 1;
                    Callback(comText, Cc);
                }
            }

        }

    } catch (e) { }
}
function ECForeachByTargetElement(Element, TargetTagNames, CallBack) {
    try {
        var TElement = Element.querySelectorAll("*");
        var Cc = 0;
        for (var r = 0; r < TElement.length; r++) {
            var inode = TElement[r];
            for (var iv = 0; iv < TargetTagNames.length; ++iv) {
                var Value = TargetTagNames[iv];
                if (Value.toLowerCase() == inode.nodeName.toLowerCase()) {
                    Cc += 1;
                    CallBack(inode, Value, Cc);
                }
            }
        }
    } catch (e) {

    }
}
function ECComponentSyncRead(Element, TargetId, ElementType) {
    try {
        Element.setAttribute("ec-key", TargetId);
        Element.setAttribute("ec-render", "true");
        var RenderElement = document.getElementById(TargetId);
        var IsMotion = true;
        if (Element.getAttribute("motion") != null) {
            IsMotion = ECConvertToBoolean(Element.getAttribute("motion"));
        }
        var DurationStr = "0.5s";
        if (Element.getAttribute("duration") != null) {
            DurationStr = Element.getAttribute("duration");
        }

        if (Element.getAttribute("style") != null) {

            RenderElement.setAttribute("style", Element.getAttribute("style"));
        }
        if (Element.getAttribute("class") != null) {
            var ClassValue = Element.getAttribute("class");
            RenderElement.setAttribute("class", RenderElement.getAttribute("class") + " " + ClassValue);
            Element.removeAttribute("class");
            Element.setAttribute("c-class", ClassValue);
        }
        Element.setAttribute("ec-VisualPort", "false");
        Element.setAttribute("ec-motion", IsMotion);
        Element.setAttribute("ec-duration", DurationStr);
        RenderElement.setAttribute("ec-type", ElementType);
    } catch (e) { }

}
function ECComponentReadAnimated(Element, TargetId) {
    try {
        // KeyNode, KeyFilter, KeyCc
        ECForeachDocument([Element], ["Animations"], function (AnimationsNode, AnimationsFilter, AnimationsCc) {
            ECForeachDocument([AnimationsNode], ["Effects"], function (EffectsNode, EffectsFilter, EffectsCc) {

                var EffectsKey = "*";
                if (EffectsNode.getAttribute("key") != null && EffectsNode.getAttribute("key") != "") {
                    EffectsKey = EffectsNode.getAttribute("key");
                }
                try {
                    ECForeachDocument([EffectsNode], ["Animated"], function (AnimatedNode, AnimatedFilter, AnimatedCc) {
                        if (AnimatedNode.getAttribute("Sequence") != null && AnimatedNode.getAttribute("Sequence") != "") {
                            var GetSyncKeyArray = AnimatedNode.getAttribute("Sequence");
                            var IsMotion = true;
                            if (AnimatedNode.getAttribute("motion") != null && AnimatedNode.getAttribute("motion") != "") {
                                IsMotion = ECConvertToBoolean(AnimatedNode.getAttribute("motion"));
                            }
                            ECForeachSlashrray(GetSyncKeyArray, function (GetSyncKey, sCc) {
                                var DbContent = AnimatedNode.innerHTML;

                                var GetOption = ECStandardDataPosition(Element);
                                var Visualport = GetOption[2];
                                var TagUpdateName = "";
                                if (Visualport == false) {
                                    TagUpdateName = "animated";
                                }
                                if (Visualport == true) {
                                    TagUpdateName = "UnRender";
                                }
                                ECAddAnimatedBoard(ECregisterDataKeys[1], EffectsKey, TargetId, GetSyncKey, IsMotion, DbContent, TagUpdateName);
                            });
                        }
                    });

                } catch (e) { }


            });
        });
        //ECForeachDocument([Element], ["Animated"], function (inode, Filter, Cc)
        //{

        //    if (inode.getAttribute("Sequence") != "" && inode.getAttribute("Sequence") != null)
        //    {

        //        //TCV100


        //    }

        //});

    } catch (e) { }
}
function ECAddComponentStyle(StyleKey, Element, TargetId, Trigger, Css) {
    try {
        var IsRender = false;
        if (Element.getAttribute("ec-render") != null) {
            IsRender = ECConvertToBoolean(Element.getAttribute("ec-render"));
        }
        if (IsRender == true) {
            var AddCss = Css;
            var IsMotion = false;
            if (Element.getAttribute("motion") != null) {
                IsMotion = ECConvertToBoolean(Element.getAttribute("motion"));
            }
            var DurationStr = "0.5s";
            if (Element.getAttribute("duration") != null) {
                DurationStr = Element.getAttribute("duration");
            }
            if (IsMotion == true) {
                AddCss += ECAnimatedCss(DurationStr);
            }
            ECReadMotionControlStyle(StyleKey).innerHTML += "#" + TargetId + Trigger + "{ " + AddCss + " }";
        }


    } catch (e) { }
}
function ECCreateStyleProperty(PropertyName, PropertyValue) {
    var outers = "";
    try {
        /*▦▦▦🌟[ ***  Property Type Setter *** ]🌟▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦*/
        var Attributes = "";
        var Value = PropertyValue;
        var _PropertyName = PropertyName;
        try {
            Attributes += ' ptn="' + PropertyName + '" ';
            Attributes += ' dfv="' + PropertyValue + '" ';
            if (PropertyName.toLowerCase().trim() == "background".toLowerCase()) {

            }
            if (_PropertyName.toLowerCase().trim() == "background-image".toLowerCase()) {

            }
            if (_PropertyName.toLowerCase().trim() == "background-position".toLowerCase()) {

            }
            if (_PropertyName.toLowerCase().trim() == "background-size".toLowerCase()) {

            }
            if (_PropertyName.toLowerCase().trim() == "border-left".toLowerCase() ||
                _PropertyName.toLowerCase().trim() == "border-top".toLowerCase() ||
                _PropertyName.toLowerCase().trim() == "border-right".toLowerCase() ||
                _PropertyName.toLowerCase().trim() == "border-bottom".toLowerCase()) {

            }
            if (_PropertyName.toLowerCase().trim() == "border-radius".toLowerCase()) {

            }
            if (_PropertyName.toLowerCase().trim() == "box-shadow".toLowerCase()) {

            }
            if (_PropertyName.toLowerCase().trim() == "text-shadow".toLowerCase()) {

            }
            if (_PropertyName.toLowerCase().trim() == "margin".toLowerCase() ||
                _PropertyName.toLowerCase().trim() == "padding".toLowerCase()) {

            }
            if (_PropertyName.toLowerCase().trim() == "OBJ".toLowerCase()) {

            }
            _PropertyName = PropertyName.replace(/-/g, ".");
        } catch (e) { }
        outers = ' <Property ' + Attributes + ' >' + Value + '</Property> ';
        /*▦▦▦🌟[ ***  Property Type Setter *** ]🌟▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦▦*/

    } catch (e) { }
    return outers;
}
function ECCreateAnimatedStyleProperty(Time) {
    var outers = "";
    try {
        outers += ECCreateStyleProperty("-moz-transition", "all " + Time + " ease-out");
        outers += ECCreateStyleProperty("-o-transition", "all " + Time + " ease-out");
        outers += ECCreateStyleProperty("-webkit-transition", "all " + Time + " ease-out");
        outers += ECCreateStyleProperty("-ms-transition", "all " + Time + " ease-out");
        outers += ECCreateStyleProperty("transition", "all " + Time + " ease-out");

    } catch (e) { }
    return outers;
}
function ECAddComponentClassStyle(StyleKey, Element, TargetId, TriggerList, CssList) {
    try {
        var _StyleKey = "XmlStl" + StyleKey;
        var ComponentClassStyleIdx = ECregisterDataKeys[3];
        var ComponentClassStyleElement = null;
        var AddNew = true;
        var CElements = document.getElementsByTagName("span");
        for (var i = 0; i < CElements.length; ++i) {
            var Citem = CElements[i];
            if (Citem.getAttribute("id") != null) {
                var getIdx = Citem.getAttribute("id");
                if (getIdx.toLowerCase() == ComponentClassStyleIdx.toLowerCase()) {
                    AddNew = false;
                    ComponentClassStyleElement = Citem;
                }
            }

        }
        if (AddNew == true) {
            try {

                var ClassStyleElement = document.createElement("span");
                ClassStyleElement.setAttribute("style", "position:fixed;visibility:hidden;opacity:0;");
                ClassStyleElement.setAttribute("id", ComponentClassStyleIdx);
                document.body.appendChild(ClassStyleElement);
                ComponentClassStyleElement = ClassStyleElement;

            } catch (e) {

            }
        }

        try {
            if (ComponentClassStyleElement != null) {

                var AddGroupStyle = true;
                for (var siv = 0; siv < ComponentClassStyleElement.childNodes.length; siv++) {
                    var InNode = ComponentClassStyleElement.childNodes[siv];
                    if (InNode.nodeType == Node.ELEMENT_NODE && InNode.nodeName == "marker".toLowerCase()) {
                        var GetInIdx = InNode.getAttribute("id");
                        if (GetInIdx.toLowerCase() == _StyleKey.toLowerCase()) {
                            AddGroupStyle = false;

                        }
                    }
                }
                if (AddGroupStyle == true) {
                    var StyleValue = '';
                    try {

                        for (var Tir = 0; Tir < TriggerList.length; Tir++) {
                            var GetClassName = TriggerList[Tir];
                            var GetInValue = CssList[Tir];
                            StyleValue += '<resource Csn="' + GetClassName.trim() + '"    >' + GetInValue + '</resource>';
                        }
                    } catch (e) { }
                    var InnerMarker = '<marker id="' + _StyleKey + '" StyleId="' + StyleKey + '" TargetId="' + TargetId + '" >' + StyleValue + '</marker>';
                    ComponentClassStyleElement.innerHTML += InnerMarker;

                }

                ECUpdateComponentStyleByProperty(StyleKey, "*", "*", "*", true);

            } else {

            }
        } catch (e) { }




    } catch (e) { }
}
function ECUpdateComponentStyle(UniqueKey, ClassName, NewCss) {
    try {
        var StyleElement = document.getElementById("ecStl_" + UniqueKey);
        StyleElement.innerHTML = ClassName + ' { ' + NewCss + ' }';



    } catch (e) { }
}
function ECUpdateComponentStyleByProperty(_UniqueKey, ClassName, PropertyName, CssValue, CssUpdate) {
    try {


        var UniqueKey = "XmlStl" + _UniqueKey;
        var getStyleMarker = document.getElementById(UniqueKey);
        var getStyleIdx = getStyleMarker.getAttribute("StyleId");
        var StlElc = ECCreateXmlData("", getStyleIdx, "style", "head", ["['type','text/css']"], false);

        if (ClassName == '*') {
            /*➽➽➽➽➽➽➽➽➽➽➽➽➽🌟🌟🌟 ( =* ) All style target update 🌟🌟🌟*/
            try {


                if (CssUpdate == true) {
                    var CssdataValue = ECConverSXMLToCssStyleData(UniqueKey);
                    StlElc.innerHTML = CssdataValue;
                }


            } catch (e) { }
        } else {

            if (ClassName == '?') {
                /*➽➽➽➽➽➽➽➽➽➽➽➽➽🌟🌟🌟 ( =? ) Reset style target  🌟🌟🌟*/


            } else {

                if (ClassName == '?*') {
                    /*➽➽➽➽➽➽➽➽➽➽➽➽➽🌟🌟🌟 ( =? ) Reset All style target  🌟🌟🌟*/



                } else {

                    try {

                        for (var r = 0; r < getStyleMarker.childNodes.length; r++) {
                            var inode = getStyleMarker.childNodes[r];
                            if (inode.nodeType == Node.ELEMENT_NODE && inode.nodeName.toLowerCase() == "resource".toLowerCase()) {
                                var CSName = inode.getAttribute("csn");
                                if (CSName.toLowerCase().trim() == ClassName.toLowerCase().trim()) {
                                    for (var PnAi = 0; PnAi < PropertyName.length; PnAi++) {
                                        var GetAsPropertyName = PropertyName[PnAi];
                                        var FindProperty = false;
                                        for (var pr = 0; pr < inode.childNodes.length; pr++) {
                                            var Pinode = inode.childNodes[pr];
                                            if (Pinode.nodeType == Node.ELEMENT_NODE && Pinode.nodeName.toLowerCase() == "property".toLowerCase()) {
                                                var PTName = Pinode.getAttribute("ptn");
                                                if (PTName.toLowerCase().trim() == GetAsPropertyName.toLowerCase().trim()) {
                                                    Pinode.innerHTML = CssValue[PnAi];
                                                    FindProperty = true;
                                                }

                                            }
                                        }
                                        if (FindProperty == false) {
                                            inode.innerHTML += ECCreateStyleProperty(GetAsPropertyName, CssValue[PnAi]);
                                        }
                                    }
                                }
                            }
                        }
                        if (CssUpdate == true) {
                            var CssdataValue = ECConverSXMLToCssStyleData(UniqueKey);
                            var OldHash = parseFloat(ExHashFnv32a(StlElc.innerHTML, false, 0));
                            var NewHash = parseFloat(ExHashFnv32a(CssdataValue, false, 0));
                            if (OldHash != NewHash) {
                                StlElc.innerHTML = CssdataValue;
                            }

                        }

                    } catch (e) { }
                }
            }

        }

    } catch (e) { }
}
function ECConverSXMLToCssStyleData(UniqueKey) {
    var outers = "";
    try {
        var getStyleMarker = document.getElementById(UniqueKey);
        var CssdataValue = '';

        for (var r = 0; r < getStyleMarker.childNodes.length; r++) {
            var inode = getStyleMarker.childNodes[r];
            if (inode.nodeType == Node.ELEMENT_NODE && inode.nodeName.toLowerCase() == "resource".toLowerCase()) {
                var ClassName = inode.getAttribute("csn");
                var propertyData = '';
                for (var pr = 0; pr < inode.childNodes.length; pr++) {
                    var Pinode = inode.childNodes[pr];
                    if (Pinode.nodeType == Node.ELEMENT_NODE && Pinode.nodeName.toLowerCase() == "property".toLowerCase()) {
                        var PropertyName = Pinode.getAttribute("ptn");
                        var PropertyValue = Pinode.innerHTML;
                        propertyData += PropertyName + ':' + PropertyValue + '; ';
                    }
                }
                CssdataValue += '' + ClassName + ' { ' + propertyData + ' } ';
            }
        }
        outers = CssdataValue;
    } catch (e) {

    }
    return outers;
}
function ECAddAnimatedBoard(HolderId, EfKey, TargetId, SyncKey, UseMotion, DbContent, xType) {
    try {


        var TiKey = 'AntBoard_' + TargetId;
        var HolderElc = ECReadDataAnimated(HolderId);
        var FindSpan = false;
        ECForeachDocument([HolderElc], ["span"], function (inode, Filter, Cc) {
            var getNodeKey = inode.getAttribute("id");
            if (getNodeKey.toLowerCase() == TiKey.toLowerCase()) {
                FindSpan = true;
                var FindSync = false;
                ECForeachDocument([inode], ["sync"], function (SyncNode, SyncFilter, SyncCc) {
                    var getSyncNodeKey = SyncNode.getAttribute("key");
                    var getSyncNodeEfKey = SyncNode.getAttribute("EfKey");
                    if (getSyncNodeKey.toLowerCase() == SyncKey.toLowerCase() && getSyncNodeEfKey.toLowerCase() == EfKey.toLowerCase()) {
                        FindSync = true;
                        SyncNode.innerHTML = DbContent;
                    }
                });
                if (FindSync == false) {

                    inode.innerHTML += '<sync  EfKey="' + EfKey + '" key="' + SyncKey + '" motion="' + UseMotion + '" > <' + xType + '> ' + DbContent + '</' + xType + '> </sync>';
                }
            }
        });
        if (FindSpan == false) {

            HolderElc.innerHTML += '<span key="' + TargetId + '" id="' + TiKey + '" > <sync  EfKey="' + EfKey + '" key="' + SyncKey + '"  motion="' + UseMotion + '"  > <' + xType + '>  ' + DbContent + '</' + xType + '> </sync> </span>';
        }
    } catch (e) { }

}
function ECForeachAnimatedDataBaseBySequence(SequenceName, CallBack, KeyMatch) {
    try {
        //document.getElementById("GGHSSGSGSG").innerHTML += " / " + KeyMatch;


        var HolderElc = ECReadDataAnimated(ECregisterDataKeys[1]);
        //var IsFindKeyMatch = false;
        //ECForeachDocument([HolderElc], ["span"], function (inode, Filter, Cc)
        //{
        //    var getSpKey = inode.getAttribute("key");
        //    var GetTragetElement = ECConvertIdToElement(getSpKey);
        //    if (GetTragetElement != null)
        //    {

        //        ECForeachDocument([inode], ["sync"], function (syncinode, syncFilter, syncCc)
        //        {
        //            var GetSyncKey = syncinode.getAttribute("key");
        //            if (GetSyncKey.toLowerCase() == SequenceName.toLowerCase())
        //            {
        //                var GetEfKey = syncinode.getAttribute("EfKey");
        //                if (GetEfKey.trim() == "*")
        //                {
        //                    IsFindKeyMatch = true;
        //                } else
        //                {
        //                    if (GetEfKey.toLowerCase() == KeyMatch.toLowerCase())
        //                    {
        //                        document.getElementById("GGHSSGSGSG").innerHTML += KeyMatch + " / ";
        //                        IsFindKeyMatch = true;
        //                    }
        //                }
        //            }
        //        });
        //    }
        //});


        ECForeachDocument([HolderElc], ["span"], function (inode, Filter, Cc) {
            var getSpKey = inode.getAttribute("key");

            var GetTragetElement = ECConvertIdToElement(getSpKey);
            if (GetTragetElement != null) {
                var GetOption = ECStandardDataPosition(ECConvertRootElementToBase(getSpKey));
                var Visualport = GetOption[2];
                ECForeachDocument([inode], ["sync"], function (syncinode, syncFilter, syncCc) {
                    var GetSyncKey = syncinode.getAttribute("key");


                    if (GetSyncKey.toLowerCase() == SequenceName.toLowerCase()) {
                        var GetEfKey = syncinode.getAttribute("EfKey");
                        // d 85sf!ffa
                        var IsKeyMatch = false;
                        if (GetEfKey.trim() == "*") {
                            IsKeyMatch = true;
                        } else {


                            if (GetEfKey.toLowerCase() == KeyMatch.toLowerCase()) {
                                // document.getElementById("GGHSSGSGSG").innerHTML += GetEfKey + " / " + KeyMatch + "  |   " ;
                                IsKeyMatch = true;
                            }


                        }
                        //if (IsFindKeyMatch == false)
                        //{
                        //    IsKeyMatch = true;
                        //}

                        if (IsKeyMatch == true) {
                            var IsMotion = true;
                            if (syncinode.getAttribute("motion") != null && syncinode.getAttribute("motion") != "") {
                                IsMotion = ECConvertToBoolean(syncinode.getAttribute("motion"));
                            }
                            var GetUnRenderTag = null;
                            var GetAnimatedTag = null;
                            var GetFromTag = null;
                            var GetToTag = null;
                            ECForeachDocument([syncinode], "*", function (syncInnerItem, syncInnerFilter, syncInnerCc) {
                                if (syncInnerFilter.toLowerCase() == "unrender".toLowerCase()) { GetUnRenderTag = syncInnerItem; }
                                if (syncInnerFilter.toLowerCase() == "Animated".toLowerCase()) { GetAnimatedTag = syncInnerItem; }
                                if (syncInnerFilter.toLowerCase() == "From".toLowerCase()) { GetFromTag = syncInnerItem; }
                                if (syncInnerFilter.toLowerCase() == "To".toLowerCase()) { GetToTag = syncInnerItem; }

                            });
                            CallBack(GetUnRenderTag, GetAnimatedTag, GetFromTag, GetToTag, getSpKey, IsMotion);
                        }


                    }
                });
            }

        });

    } catch (e) { }
}
function ECReadCssIdAnimatedDataBaseBySequence(SequenceName, CallBack) {
    try {
        var HolderElc = ECReadDataAnimated(ECregisterDataKeys[1]);
        ECForeachDocument([HolderElc], ["span"], function (inode, Filter, Cc) {
            var getSpKey = inode.getAttribute("key");
            var GetTragetElement = ECConvertIdToElement(getSpKey);
            if (GetTragetElement != null) {
                var GetOption = ECStandardDataPosition(ECConvertRootElementToBase(getSpKey));
                var Visualport = GetOption[2];
                ECForeachDocument([inode], ["sync"], function (syncinode, syncFilter, syncCc) {
                    var GetSyncKey = syncinode.getAttribute("key");
                    if (GetSyncKey.toLowerCase() == SequenceName.toLowerCase()) {

                        CallBack(getSpKey);

                    }
                });
            }

        });

    } catch (e) { }
}
function ECForeachAnimatedDataBaseByTargetKey(TargetKey, CallBack) {
    try {
        var HolderElc = ECReadDataAnimated(ECregisterDataKeys[1]);
        ECForeachDocument([HolderElc], ["span"], function (inode, Filter, Cc) {
            var getSpKey = inode.getAttribute("key");
            var GetTragetElement = ECConvertIdToElement(getSpKey);
            if (GetTragetElement != null) {
                if (getSpKey.toLowerCase() == TargetKey.toLowerCase()) {

                    ECForeachDocument([inode], ["sync"], function (syncinode, syncFilter, syncCc) {
                        var GetSyncKey = syncinode.getAttribute("key");

                        var GetUnRenderTag = null;
                        var GetAnimatedTag = null;
                        var GetFromTag = null;
                        var GetToTag = null;

                        ECForeachDocument([syncinode], "*", function (syncInnerItem, syncInnerFilter, syncInnerCc) {
                            if (syncInnerFilter.toLowerCase() == "unrender".toLowerCase()) { GetUnRenderTag = syncInnerItem; }
                            if (syncInnerFilter.toLowerCase() == "Animated".toLowerCase()) { GetAnimatedTag = syncInnerItem; }
                            if (syncInnerFilter.toLowerCase() == "From".toLowerCase()) { GetFromTag = syncInnerItem; }
                            if (syncInnerFilter.toLowerCase() == "To".toLowerCase()) { GetToTag = syncInnerItem; }
                        });
                        CallBack(syncinode, GetUnRenderTag, GetAnimatedTag, GetFromTag, GetToTag, getSpKey, GetSyncKey);

                    });
                }

            }

        });

    } catch (e) { }
}
function ECForeachCssProperty(Value, CallBack) {
    try {
        var TrimVal = Value.replace(/ /g, '');
        var ExtractValue = TrimVal.split(";");
        for (var r = 0; r < ExtractValue.length; r++) {
            var ExeVal = ExtractValue[r];
            if (ExeVal.trim() != "") {
                var ExeKeys = ExeVal.split(":");
                if (ExeKeys[0].trim() != "" && ExeKeys[1].trim() != "") {
                    CallBack(ExeKeys[0].toLowerCase(), ExeKeys[1]);
                }
            }

        }
    } catch (e) { }
}
function ECSyncAnimatedUnRead(InnerElement, WidthPercentage, HeightPercentage) {
    try {








        var GetKey = InnerElement.getAttribute("ec-key");
        ECForeachAnimatedDataBaseByTargetKey(GetKey, function (Holder, UnRenderTag, AnimatedTag, FromTag, ToTag, SpKey, SequenceName) {
            //  alert(UnRenderTag.innerHTML);
            var NodeHolder = '';
            ECForeachDocument([UnRenderTag], ["*"], function (inode, NodeName, Cc) {
                // LOCATION POINTS OPACITY ROTATION SIZE BGARGB SCALE SKEW
                var AddUnReadTag = true;
                if (NodeName.toLowerCase() == "#text".toLowerCase())
                { AddUnReadTag = false; }
                if (NodeName.toLowerCase() == "LOCATION".toLowerCase()) {
                    AddUnReadTag = false;
                    try {
                        var XFV = 0;
                        var YFV = 0;

                        var GetFromValue = inode.getAttribute("from");
                        ECForeachCssProperty(GetFromValue, function (xKey, xValue) {
                            if (xKey.toLowerCase() == "x") {
                                XFV = parseInt(xValue, 10);
                            }
                            if (xKey.toLowerCase() == "y") {
                                YFV = parseInt(xValue, 10);
                            }
                        });

                        var XTV = 0;
                        var YTV = 0;

                        var GetToValue = inode.getAttribute("to");
                        ECForeachCssProperty(GetToValue, function (xKey, xValue) {
                            if (xKey.toLowerCase() == "x") {
                                XTV = parseInt(xValue, 10);

                            }
                            if (xKey.toLowerCase() == "y") {
                                YTV = parseInt(xValue, 10);

                            }
                        });


                        var FXEPercentage = XFV * WidthPercentage / 100;
                        var FYEPercentage = YFV * HeightPercentage / 100;

                        var TXEPercentage = XTV * WidthPercentage / 100;
                        var TYEPercentage = YTV * HeightPercentage / 100;


                        NodeHolder += '<' + inode.nodeName + ' from="x:' + FXEPercentage + ';y:' + FYEPercentage + ';"  to="x:' + TXEPercentage + ';y:' + TYEPercentage + ';"   ></' + inode.nodeName + '>';
                    } catch (e) { }
                }
                if (NodeName.toLowerCase() == "SIZE".toLowerCase()) {
                    AddUnReadTag = false;

                    try {
                        var XFV = 0;
                        var YFV = 0;

                        var GetFromValue = inode.getAttribute("from");
                        ECForeachCssProperty(GetFromValue, function (xKey, xValue) {
                            if (xKey.toLowerCase() == "width") {
                                XFV = parseInt(xValue, 10);
                            }
                            if (xKey.toLowerCase() == "height") {
                                YFV = parseInt(xValue, 10);
                            }
                        });

                        var XTV = 0;
                        var YTV = 0;

                        var GetToValue = inode.getAttribute("to");
                        ECForeachCssProperty(GetToValue, function (xKey, xValue) {
                            if (xKey.toLowerCase() == "width") {
                                XTV = parseInt(xValue, 10);

                            }
                            if (xKey.toLowerCase() == "height") {
                                YTV = parseInt(xValue, 10);

                            }
                        });

                        var FWEPercentage = XFV * WidthPercentage / 100;
                        var FHEPercentage = YFV * HeightPercentage / 100;

                        var TWEPercentage = XTV * WidthPercentage / 100;
                        var THEPercentage = YTV * HeightPercentage / 100;

                        NodeHolder += '<' + inode.nodeName + ' from="width:' + FWEPercentage + ';height:' + FHEPercentage + ';"  to="width:' + TWEPercentage + ';height:' + THEPercentage + ';"   ></' + inode.nodeName + '>';
                    } catch (e) {

                    }

                }
                if (AddUnReadTag == true) {
                    var Attributes = '';
                    ECForeachAttributes(inode, function (Name, Value) {
                        Attributes += ' ' + Name + '="' + Value + '" ';
                    });

                    NodeHolder += '<' + inode.nodeName + ' ' + Attributes + ' ></' + inode.nodeName + '>';
                }
            });
            var AddUpdateTag = true;
            ECForeachDocument([Holder], ["*"], function (inode, NodeName, Cc) {
                if (NodeName.toLowerCase() == "animated".toLowerCase()) {
                    AddUpdateTag = false;
                    inode.innerHTML = NodeHolder;
                }
            });
            if (AddUpdateTag == true) {
                Holder.innerHTML += '<animated>' + NodeHolder + '</animated>';
            }

        });



    } catch (e) { }
}
function ECComponentStyleReader(Element, EffectTarget, PropertyName, DefaultValue) {
    var outers = "";
    try {
        var FindValue = false;
        for (var r = 0; r < Element.childNodes.length; r++) {
            var inode = Element.childNodes[r];
            if (inode.nodeType == Node.ELEMENT_NODE && inode.nodeName.toLowerCase() == "styles".toLowerCase()) {
                for (var Er = 0; Er < inode.childNodes.length; Er++) {
                    var EffectNode = inode.childNodes[Er];
                    if (EffectNode.nodeType == Node.ELEMENT_NODE && EffectNode.nodeName.toLowerCase() == "Effects".toLowerCase()) {
                        var targetName = EffectNode.getAttribute("target");
                        if (EffectTarget.toLowerCase() == targetName.toLowerCase()) {
                            for (var SNr = 0; SNr < EffectNode.childNodes.length; SNr++) {
                                var SNode = EffectNode.childNodes[SNr];
                                if (SNode.nodeType == Node.ELEMENT_NODE && SNode.nodeName.toLowerCase() == PropertyName.toLowerCase()) {
                                    var getAsValue = SNode.innerHTML;
                                    outers = getAsValue;
                                    FindValue = true;
                                    if (getAsValue.trim() != "") {

                                    }

                                }
                            }
                        }
                    }
                }

            }
        }
        if (FindValue == false) {
            outers = DefaultValue;
        }


    } catch (e) { }
    return outers;
}
function ECComponentClassStyleReader(Element, EffectTarget, CallBack) {

    try {

        for (var r = 0; r < Element.childNodes.length; r++) {
            var inode = Element.childNodes[r];
            if (inode.nodeType == Node.ELEMENT_NODE && inode.nodeName.toLowerCase() == "styles".toLowerCase()) {
                for (var Er = 0; Er < inode.childNodes.length; Er++) {
                    var EffectNode = inode.childNodes[Er];
                    if (EffectNode.nodeType == Node.ELEMENT_NODE && EffectNode.nodeName.toLowerCase() == "Class".toLowerCase()) {
                        var targetName = EffectNode.getAttribute("name");
                        if (EffectTarget.toLowerCase() == targetName.toLowerCase()) {
                            if (EffectNode.getAttribute("style") != null) {
                                var StylesValue = EffectNode.getAttribute("style");
                                if (StylesValue.trim() != "") {
                                    try {
                                        var ExeVal = StylesValue.split(";");
                                        for (var Exr = 0; Exr < ExeVal.length; Exr++) {
                                            var EXi = ExeVal[Exr];
                                            if (EXi.trim() != "") {
                                                var ExePVal = EXi.split(":");
                                                CallBack(ExePVal[0], ExePVal[1]);
                                            }
                                        }

                                    } catch (e) { }
                                }
                            }

                        }
                    }
                }

            }
        }


    } catch (e) { }

}
/*↑↑↑↑↑ • Short commands • ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑*/
/*↓↓↓↓↓ • Generating • ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓*/
/* ▧⬛▧ Add xml data Tags ⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧ 🔻 */
/*🔧🔧🔧  ECCreateXmlData("Extension_", "RootId", "span|style|script|link|....", "body|head",  null| ["['type','text/css']","['rel','stylesheet'],..."]  , false|true) */
function ECCreateXmlData(Extension, RootId, NodeType, InnerTag, AddAttributeArray, VisualStyle) {
    var outers = null;
    try {

        //#MHN977874
        var LandingElement = null;
        if (InnerTag.trim() != "") {
            if (InnerTag.toLowerCase() == "body".toLowerCase()) {
                LandingElement = document.getElementsByTagName("body")[0];
            }
            if (InnerTag.toLowerCase() == "head".toLowerCase()) {
                LandingElement = document.getElementsByTagName("head")[0];
            }
        }
        if (LandingElement != null) {
            var IsFind = false;
            var AndIdx = Extension + RootId;

            for (var r = 0; r < LandingElement.childNodes.length; r++) {
                var inode = LandingElement.childNodes[r];
                if (inode.nodeType == Node.ELEMENT_NODE && inode.nodeName.toLowerCase() == NodeType.toLowerCase()) {
                    if (inode.getAttribute("id") != null) {
                        var xIdx = inode.getAttribute("id");
                        if (xIdx == AndIdx) {
                            IsFind = true;
                            outers = inode;
                        }

                    }
                }
            }
            if (IsFind == false) {
                var CreateStartBoard = document.createElement(NodeType);
                if (VisualStyle == false) {
                    CreateStartBoard.setAttribute("style", "position:fixed;visibility:hidden;opacity:0;");
                }
                CreateStartBoard.setAttribute("id", AndIdx);
                if (AddAttributeArray != null) {
                    try {
                        for (var ar = 0; ar < AddAttributeArray.length; ar++) {
                            var ArrayStr = AddAttributeArray[ar];
                            if (ArrayStr.trim() != "") {
                                try {
                                    var ConvertToItemArray = eval(ArrayStr);
                                    if (ConvertToItemArray.length == 2) {
                                        var ArrayKeyStr = ConvertToItemArray[0];
                                        var ArrayValueStr = ConvertToItemArray[1];

                                        CreateStartBoard.setAttribute(ArrayKeyStr, ArrayValueStr);
                                    }
                                } catch (e) {

                                }
                            }

                        }

                    } catch (e) {

                    }
                }
                LandingElement.appendChild(CreateStartBoard);
                outers = CreateStartBoard;
            }
        } else {
            alert("Inner Tag Is none !");
        }

    } catch (e) {

    }
    return outers;
}
/* ▧⬛▧ Add xml data Item ⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧⬛▧ 🔻 */
/*🔧🔧🔧  ECAddXmlDataItem(Document, "Str key", "ID", "span|p|div|...", null| ["['type','text']","['count','0'],..."], "HtmlContent", false|true, null | [Document,Document,...])  */
function ECAddXmlDataItem(XmlDataElement, NodeName, NodeKeyId, NodeType, AddAttributeArray, HtmlContent, EncodeContent, InnerTagArry) {
    var outers = null;
    try {

        //#MHN977874
        var CreateItemTag = document.createElement(NodeType);
        if (EncodeContent == false) {
            CreateItemTag.innerHTML = HtmlContent;
        }
        if (EncodeContent == true) {
            CreateItemTag.innerHTML = encodeURIComponent(HtmlContent);
        }
        if (NodeKeyId != "") {
            CreateItemTag.setAttribute("id", NodeKeyId);
        } else {
            var RndKeyId = "xNode_" + ECRandomId();
            CreateItemTag.setAttribute("id", RndKeyId);
        }
        if (NodeName != "") {
            CreateItemTag.setAttribute("xName", NodeName);
        } else {
            CreateItemTag.setAttribute("xName", ECRandomId());
        }
        if (AddAttributeArray != null) {
            try {
                for (var ar = 0; ar < AddAttributeArray.length; ar++) {
                    var ArrayStr = AddAttributeArray[ar];
                    if (ArrayStr.trim() != "") {
                        try {
                            var ConvertToItemArray = eval(ArrayStr);
                            if (ConvertToItemArray.length == 2) {
                                var ArrayKeyStr = ConvertToItemArray[0];
                                var ArrayValueStr = ConvertToItemArray[1];

                                CreateItemTag.setAttribute(ArrayKeyStr, ArrayValueStr);
                            }
                        } catch (e) {

                        }
                    }

                }

            } catch (e) {

            }
        }
        try {
            if (InnerTagArry != null) {
                for (var atr = 0; atr < InnerTagArry.length; atr++) {
                    var ChildElement = InnerTagArry[atr];
                    CreateItemTag.appendChild(ChildElement);
                }
            }

        } catch (e) { }
        XmlDataElement.appendChild(CreateItemTag);
        outers = CreateItemTag;


    } catch (e) {

    }
    return outers;
}
/* CDI */
function ECRandomId() {
    var text = "";
    try {
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        for (var i = 0; i < 12; i++) text += possible.charAt(Math.floor(Math.random() * possible.length));
    } catch (e) {

    }
    return text;
}
function ECAnimatedCss(Time) {
    var outers = "";
    try {
        outers = ' -moz-transition: all ' + Time + ' ease-out;-o-transition: all ' + Time + ' ease-out;-webkit-transition: all ' + Time + ' ease-out;-ms-transition: all ' + Time + ' ease-out;transition: all ' + Time + ' ease-out;';
    } catch (e) {

    }
    return outers;
}
function ECReadDataAnimated(DatabaseId) {
    var outers = null;
    try {
        outers = ECCreateXmlData("ecAndb_", DatabaseId, "span", "body", null, false);

    } catch (e) {

    }
    return outers;
}
function ECReadDataTypewriter(BaseId) {
    var outers = null;
    try {
        outers = ECCreateXmlData("ecTpdb_", BaseId, "span", "body", null, false);
    } catch (e) {

    }
    return outers;
}
function ECReadMotionControlStyle(ElementId) {
    var outers = null;
    try {
        outers = ECCreateXmlData("ecStl_", ElementId, "style", "head", ["['type','text/css']"], false);
    } catch (e) {

    }
    return outers;
}
function ExHashFnv32a(str, asString, seed) {
    try {
        var i, l,
       hval = (seed === undefined) ? 0x811c9dc5 : seed;
        for (i = 0, l = str.length; i < l; i++) {
            hval ^= str.charCodeAt(i);
            hval += (hval << 1) + (hval << 4) + (hval << 7) + (hval << 8) + (hval << 24);
        }
        if (asString) {
            return ("0000000" + (hval >>> 0).toString(16)).substr(-8);
        }
        return hval >>> 0;
    } catch (e) { }
}
function ECcheckByHashData(SelectIdKey, StringData) {
    var outers = false;
    try {
        //#jklHHmnwty

        var HashDb = ECReadDataAnimated(SelectIdKey);
        var ThisHashNumber = 0;
        try {
            ThisHashNumber = parseFloat(ExHashFnv32a(StringData, false, 0));
        } catch (e) { }
        var HashStr = HashDb.innerHTML.trim();
        var HashArray = HashStr.split(",");
        if (HashStr != "") {
            for (var Hr = 0; Hr < HashArray.length; Hr++) {
                var getHashNumber = parseFloat(HashArray[Hr]);
                if (getHashNumber == ThisHashNumber) {
                    outers = true;
                }
            }
        }
        if (outers == false) {
            if (HashStr.trim() == "") {
                HashDb.innerHTML = ThisHashNumber;
            } else {
                HashDb.innerHTML += "," + ThisHashNumber;
            }
        }

    } catch (e) { alert(e.message); }
    return outers;
}
/*↑↑↑↑↑ • Generating • ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑*/
/*↓↓↓↓↓ • Captures • ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓*/
function ECWindowHeight() {
    var windowHeight = 0;
    if (typeof (window.innerHeight) == 'number') {

        windowHeight = window.innerHeight;
    }
    else {

        var ieStrict = document.documentElement.clientHeight;
        var ieQuirks = document.body.clientHeight;
        windowHeight = (ieStrict > 0) ? ieStrict : ieQuirks;
    }
    return windowHeight;
}
function ECWindowWidth() {
    var windowWidth = 0;
    if (typeof (window.innerWidth) == 'number') {

        windowWidth = window.innerWidth;
    }
    else {

        var ieStrict = document.documentElement.clientWidth;
        var ieQuirks = document.body.clientWidth;
        windowWidth = (ieStrict > 0) ? ieStrict : ieQuirks;
    }
    return windowWidth;
}
function ECScreenSize() {
    var Outers = [0, 0];
    try {
        Outers = [parseInt(window.screen.availWidth, 10), parseInt(window.screen.availHeight, 10)];

    } catch (e) { }
    return Outers;
}
function ECElementRenderSize(Element) {
    var outers = [0, 0];
    try {
        var comStyle = window.getComputedStyle(Element, null);
        var width = parseInt(comStyle.getPropertyValue("width"), 10);
        var height = parseInt(comStyle.getPropertyValue("height"), 10);
        var left = parseInt(comStyle.getPropertyValue("margin-left"), 10);
        var top = parseInt(comStyle.getPropertyValue("margin-top"), 10);
        outers = [width, height, left, top];

    } catch (e) { }
    return outers;
}
function ECEventClient() {
    var _x = 0;
    var _y = 0;
    try {
        _x = event.clientX;
        _y = event.clientY;

    } catch (e) {

    }
    return { top: _y, left: _x };
}
function ECEventElement(xElement) {
    var _x = 0;
    var _y = 0;
    var _w = 0;
    var _h = 0;
    try {
        var TElement = ECElementRenderSize(xElement);
        _w = TElement[0];
        _h = TElement[1];

    } catch (e) { }
    try {
        while (xElement && !isNaN(xElement.offsetLeft) && !isNaN(xElement.offsetTop)) {
            _x += xElement.offsetLeft - xElement.scrollLeft;
            _y += xElement.offsetTop - xElement.scrollTop;
            xElement = xElement.offsetParent;
        }

    } catch (e) {

    }
    return { top: _y, left: _x, Width: _w, Height: _h };
}
/*↑↑↑↑↑ • Captures • ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑*/
/*↓↓↓↓↓ • Convertors • ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓*/
function ECConvertToTimeStream(BaseElement, Tick, ArrayValue, CallBack) {
    //##XSGW970
    //###GGFSF10
    try {
        // 110;1/1;110;sq_Dzl0grnyO6gz
        var ArrayValueSplit = ArrayValue.split(",");
        for (var r = 0; r < ArrayValueSplit.length; r++) {
            var GetPart = ArrayValueSplit[r];
            if (GetPart.trim() != "") {

                var PartValueSplit = GetPart.split(";");
                if (PartValueSplit.length != 0) {
                    var CurrentValue = parseInt(PartValueSplit[2], 10);
                    if (CurrentValue == Tick) {
                        //**56075000
                        var Timelength = parseInt(PartValueSplit[0], 10);
                        var Column = parseInt(PartValueSplit[1].split("/")[0], 10);
                        var ItemId = PartValueSplit[1].split("/")[1];


                        var getXmlIdx = PartValueSplit[3];
                        var getXmlDuration = PartValueSplit[4];
                        var getXmlTrack = ECConvertToBoolean(PartValueSplit[5]);

                        //var SetCallBack = false;
                        //if (getXmlIdx.trim() != "")
                        //{
                        //    var NodeElcx = document.getElementById(getXmlIdx);
                        //    SetCallBack = ConstructAnimatedGPUTimeStreamTrack(BaseElement, NodeElcx);

                        //    document.getElementById("GGHSSGSGSG").innerHTML += " " + " - " + SetCallBack + " / "  + Tick;

                        //}
                        //if (SetCallBack == true)
                        //{

                        //}

                        CallBack(r, Timelength, Tick, Column, ItemId, CurrentValue, getXmlIdx, getXmlDuration, getXmlTrack, GetPart);


                    }

                }
            }
        }
    } catch (e) { }
}
function ECConvertToBoolean(StrValue) {
    var outers = null;
    try {
        if (StrValue.toLowerCase() != "") {

            if (StrValue.toLowerCase() == "true".toLowerCase()) {

                outers = true;
            }
            if (StrValue.toLowerCase() == "false".toLowerCase()) {
                outers = false;
            }
            if (StrValue.toLowerCase() == "x:null".toLowerCase() ||
                StrValue.toLowerCase() == "x:{null}".toLowerCase()) {
                outers = null;
            }
        }

    } catch (e) { }
    return outers;
}
function ECConvertToCssValue(Value) {
    var outers = "";
    try {

        if (Value.trim() != "") {
            var GetFirstCharacter = Value[0];
            var CommandFind = false;
            if (GetFirstCharacter == "(") {
                try {
                    var PureValue = Value.replace(/ /g, '');
                    var ExtractItem = PureValue.split(/[ \(,\)]+/);
                    var InCode = ExtractItem[1];
                    var ConvertCECode = InCode.replace(/page.width/g, ECWindowWidth()).replace(/page.height/g, ECWindowHeight());
                    var EvalInCode = eval(ConvertCECode);

                    var CodeEval = " PureValue.replace(/\\(" + InCode + "\\)/g,'" + EvalInCode + "'); ";
                    var ConvertDone = eval(CodeEval);
                    outers = ConvertDone;


                } catch (e) { }
                CommandFind = true;
            }
            if (GetFirstCharacter == "{") {

            }
            if (CommandFind == false) {
                var getAsSplit = Value.split(",");
                if (getAsSplit.length == 1) {
                    outers = Value;
                }
                if (getAsSplit.length == 4) {
                    outers = getAsSplit[0] + " " + getAsSplit[1] + " " + getAsSplit[1] + " " + getAsSplit[1] + " ";
                }
                outers = outers.replace(/\%page.width\%/g, ECWindowWidth()).replace(/\%page.height\%/g, ECWindowHeight()).replace(/\%screen.width\%/g, ECScreenSize()[0]).replace(/\%screen.height\%/g, ECScreenSize()[1]);
            }
        }
    } catch (e) { }
    return outers;
}
function ECParseAnimatedCodeToCss(AnimatedCode, AnimatedType, Method) {
    var outers = "";
    try {
        //  ["LOCATION", "OPACITY", "BACKGROUND", "BORDER", "ROTATION", "SHADOW", "SIZE"];
        if (AnimatedType.toLowerCase() == ECregisterAnimatedTags[0].toLowerCase()) {
            /*╱╱╱ LOCATION ╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱*/
            ECForeachCssProperty(AnimatedCode, function (xName, xValue) {
                if (Method == 'NEV') {
                    if (xName == 'x') {
                        outers += 'margin-left:' + xValue + 'px; ';
                    }
                    if (xName == 'y') {
                        outers += 'margin-top:' + xValue + 'px; ';
                    }
                }
            });
        }
        if (AnimatedType.toLowerCase() == ECregisterAnimatedTags[1].toLowerCase()) {
            /*╱╱╱ OPACITY ╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱*/
            ECForeachCssProperty(AnimatedCode, function (xName, xValue) {
                if (Method == 'NEV') {
                    if (xName == 'value') {
                        var ToFlt = parseFloat(xValue) / 100;
                        outers += ' opacity:' + ToFlt + ';';
                    }
                }
            });
        }
        if (AnimatedType.toLowerCase() == ECregisterAnimatedTags[2].toLowerCase()) {
            /*╱╱╱ BACKGROUND ╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱*/
            ECForeachCssProperty(AnimatedCode, function (xName, xValue) {
                if (Method == 'NEV') {
                    if (xName == 'color') {
                        outers += 'background-color:' + xValue + '; ';
                    }
                }
            });
        }
        if (AnimatedType.toLowerCase() == ECregisterAnimatedTags[3].toLowerCase()) {
            /*╱╱╱ BORDER ╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱*/
            var Collect = '';
            ECForeachCssProperty(AnimatedCode, function (xName, xValue) {
                if (Method == 'NEV') {
                    if (xName == 'size') {
                        Collect += ' ' + xValue + 'px ';
                    }
                    if (xName == 'color') {
                        Collect += ' ' + xValue + ' ';
                    }
                    if (xName == 'style') {
                        Collect += ' ' + xValue + ' ';
                    }


                }
            });
            if (Collect.trim() != '') {
                outers += 'border:' + Collect + '; ';
            }
        }
        if (AnimatedType.toLowerCase() == ECregisterAnimatedTags[4].toLowerCase()) {
            /*╱╱╱ ROTATION ╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱*/
            ECForeachCssProperty(AnimatedCode, function (xName, xValue) {
                if (Method == 'NEV') {
                    if (xName == 'size') {
                        outers += 'transform:rotate(' + xValue + 'deg); ';
                    }
                }
            });
        }
        if (AnimatedType.toLowerCase() == ECregisterAnimatedTags[5].toLowerCase()) {
            /*╱╱╱ SHADOW ╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱*/
            var ACollect = '';
            var BCollect = '';
            var CCollect = '';
            var DCollect = '';
            ECForeachCssProperty(AnimatedCode, function (xName, xValue) {
                if (Method == 'NEV') {

                    if (xName == 'type') {
                        if (xValue.toLowerCase() == 'out') {
                            ACollect = '';
                        }
                        if (xValue.toLowerCase() == 'in') {
                            ACollect = 'inset ';
                        }
                    }
                    if (xName == 'x') {
                        BCollect += ' ' + xValue + 'px ';
                    }
                    if (xName == 'y') {
                        CCollect += ' ' + xValue + 'px ';
                    }
                    if (xName == 'color') {
                        DCollect += ' ' + xValue + ' ';
                    }
                }
            });
            if (DCollect.trim() != '') {
                outers += 'box-shadow:' + ACollect + BCollect + CCollect + DCollect + '; ';
            }
        }
        if (AnimatedType.toLowerCase() == ECregisterAnimatedTags[6].toLowerCase()) {
            /*╱╱╱ SIZE ╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱*/
            if (xName == 'width') {
                outers += 'width:' + xValue + 'px; ';
            }
            if (xName == 'height') {
                outers += 'height:' + xValue + 'px; ';
            }
        }


    } catch (e) { }
    return outers;

}
function ECConvertIdToElement(Idx) {
    var outers = null;
    try {
        outers = document.getElementById(Idx);
    } catch (e) { }
    return outers;
}
function ECConvertRootElementToBase(Idx) {
    var outers = null;
    try {
        var getType = document.getElementById(Idx).getAttribute("ec-type");
        ECForeachElement("tag", [getType], function (item, Value, Cc) {
            var getECkey = item.getAttribute("ec-key");
            if (Idx.toLowerCase() == getECkey.toLowerCase()) {
                outers = item;
            }

        });

    } catch (e) { }
    return outers;
}
function ECGetElementByEcKey(TagName, EcKey) {
    var outers = null;
    try {

        ECForeachElement("tag", [TagName], function (item, Value, Cc) {
            var getECkey = item.getAttribute("ec-key");
            if (EcKey.toLowerCase() == getECkey.toLowerCase()) {
                outers = item;
            }

        });

    } catch (e) { }
    return outers;
}
function ConvertTOTimerPercentage(Cct, Duration, Value) {
    var outers = 0;
    try {
        var TimerPercentage = Cct * 100 / Duration;
        outers = Value / 100 * TimerPercentage;
    } catch (e) {

    }
    return outers;
}
function ConvertTOTimerlengthPercentage(Cct, Timelength, Value) {
    var outers = 0;
    try {
        var TimerPercentage = Cct * 100 / Timelength;
        if (TimerPercentage > 100) {
            TimerPercentage = 100;
        }
        outers = Value / 100 * TimerPercentage;
    } catch (e) {

    }
    return outers;
}
/*↑↑↑↑↑ • Convertors • ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑*/
/*██████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████████*/
/*◘◘◘◘◘◘◘◘◘ Standard library ▲ ◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘*/
/*╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱*/
/*╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱*/
/*◘◘◘◘◘◘◘◘◘ Decorator [ NOT COMPELETED ] ▼ ◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘*/
/*⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛*/
/*╋╋ [ NOT COMPELETED ]╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋*/
function ECDecorator(IsInstall) {
    try {

        var StlHolder = ECReadMotionControlStyle("DecoratorStyles");
        if (IsInstall == true) {
            var KeyNames = '';
            ECForeachElement('Tag', ['decorator'], function (item, Value, Cc) {
                ECForeachDocument([item], ['register'], function (inode, NodeName, inCc) {
                    var target = '';
                    var value = '';
                    ECForeachAttributes(inode, function (GetName, GetValue) {
                        if (GetName.toLowerCase() == 'target') { target = GetValue; }
                        if (GetName.toLowerCase() == 'value') { value = GetValue; }
                    });
                    if (target.trim() != "") {
                        if (target.toLowerCase() == "className".toLowerCase()) {
                            ECForeachElement('Class', [value], function (FndItem, FndValue, FndCc) {
                                var NewCss = 'decStyle_' + ECRandomId();
                                var OldCalss = FndItem.getAttribute("class");
                                KeyNames += 'cn:' + NewCss + ';';
                                FndItem.setAttribute("class", NewCss + ' ' + OldCalss);

                            });

                        }
                    }
                });
            });
            StlHolder.setAttribute("keys", KeyNames);
        }
        if (IsInstall == false) {
            ECDecoratorRender(StlHolder);
        }

    } catch (e) { }
}
function ECDecoratorRender(StyleElement) {
    try {

        var StyleKeys = StyleElement.getAttribute("keys");
        var UpdateInnerCss = '';
        if (StyleKeys.trim() != '') {

            ECForeachCssProperty(StyleKeys, function (xKey, xValue) {

                var SelectedElement = null;
                if (xKey == 'cn') { SelectedElement = document.getElementsByClassName(xValue)[0]; }
                if (xKey == 'id') { SelectedElement = document.getElementById(xValue); }
                if (SelectedElement != null) {
                    try {
                        var resizeValue = '';
                        var resizeFontValue = '';
                        ECForeachAttributes(SelectedElement, function (GetName, GetValue) {
                            if (GetName.toLowerCase() == 'resize') { resizeValue = GetValue; }
                            if (GetName.toLowerCase() == 'resize.font') { resizeFontValue = GetValue; }
                        });
                        if (resizeValue.trim() != '') {
                            if (resizeValue.trim() != '') {
                                try {
                                    var GetAsType = 'scale';
                                    var GetAsWidth = '0';
                                    var GetAsHeight = '0';
                                    var GetAsEffect = '*';
                                    var GetAsReducer = '0';
                                    ECForeachCssProperty(resizeValue, function (xrKey, xrValue) {
                                        if (xrKey == 'type') { GetAsType = xrValue; }
                                        if (xrKey == 'width') { GetAsWidth = xrValue; }
                                        if (xrKey == 'height') { GetAsHeight = xrValue; }
                                        if (xrKey == 'effect') { GetAsEffect = xrValue; }
                                        if (xrKey == 'reducer') { GetAsReducer = xrValue; }

                                    });

                                    try {
                                        var WReducer = 0;
                                        var HReducer = 0;
                                        var MLReducer = 0;
                                        var MTReducer = 0;
                                        var MRReducer = 0;
                                        var MBReducer = 0;
                                        if (GetAsReducer.trim() != '') {
                                            try {
                                                var exeRc = GetAsReducer.split(',');
                                                var xccr = 0;
                                                for (var vrdc = 0; vrdc < exeRc.length; vrdc++) {
                                                    var Rval = exeRc[vrdc];
                                                    xccr += 1;
                                                    if (xccr == 1) { WReducer = parseInt(Rval, 10); }
                                                    if (xccr == 2) { HReducer = parseInt(Rval, 10); }
                                                    if (xccr == 3) { MLReducer = parseInt(Rval, 10); }
                                                    if (xccr == 4) { MTReducer = parseInt(Rval, 10); }
                                                    if (xccr == 5) { MRReducer = parseInt(Rval, 10); }
                                                    if (xccr == 6) { MBReducer = parseInt(Rval, 10); }
                                                }
                                            } catch (e) { }
                                        }
                                        var ElcWidth = parseInt(GetAsWidth, 10);
                                        var ElcHeight = parseInt(GetAsHeight, 10);
                                        var RenderW = ECWindowWidth();
                                        var RenderH = ECWindowHeight();
                                        var WPercentage = RenderW * 100 / ElcWidth;
                                        var HPercentage = RenderH * 100 / ElcHeight;
                                        var WidthPercentage = parseInt(WPercentage, 10);
                                        var HeightPercentage = parseInt(HPercentage, 10);
                                        var WEPercentage = 0;
                                        var HEPercentage = 0;
                                        if (GetAsType.toLowerCase() == 'scale') {
                                            WEPercentage = ElcWidth * WidthPercentage / 100;
                                            HEPercentage = ElcHeight * WidthPercentage / 100;
                                        }
                                        if (GetAsType.toLowerCase() == 'fill') {
                                            WEPercentage = ElcWidth * WidthPercentage / 100;
                                            HEPercentage = ElcHeight * HeightPercentage / 100;
                                        }
                                        var WER = WEPercentage - WReducer;
                                        var HER = HEPercentage - HReducer;
                                        if (GetAsEffect == '*') {
                                            UpdateInnerCss += '.' + xValue + '{ ' + ' width:' + WER + 'px;' + ' height:' + HER + 'px;' + ' }';
                                        }
                                        if (GetAsEffect == 'min') {
                                            if (RenderW < ElcWidth) {
                                                UpdateInnerCss += '.' + xValue + '{ ' + ' width:' + WER + 'px;' + ' height:' + HER + 'px;' + ' }';
                                            }
                                        }
                                    } catch (e) { }

                                } catch (e) { }

                            }
                        }
                        if (resizeFontValue.trim() != '') {

                            try {
                                var GetAsType = 'scale';
                                var GetAsSize = '0';
                                var GetAsSenseWidth = '0';
                                var GetAsEffect = '*';
                                var GetAsPercentage = '0';
                                var GetAslesSsize = '5';
                                ECForeachCssProperty(resizeFontValue, function (xrKey, xrValue) {
                                    if (xrKey == 'type') { GetAsType = xrValue; }
                                    if (xrKey == 'size') { GetAsSize = xrValue; }
                                    if (xrKey == 'effect') { GetAsEffect = xrValue; }
                                    if (xrKey == 'sense.width') { GetAsSenseWidth = xrValue; }
                                    if (xrKey == 'percentage') { GetAsPercentage = xrValue; }
                                    if (xrKey == 'lesssize') { GetAslesSsize = xrValue; }

                                });

                                try {
                                    var RenderW = ECWindowWidth();
                                    var RenderH = ECWindowHeight();
                                    if (GetAsEffect == '*') {

                                    }
                                    if (GetAsSenseWidth.trim() != '0') {
                                        var Size = parseInt(GetAsSize, 10);
                                        var SenseWidth = parseInt(GetAsSenseWidth, 10);

                                        if (GetAsEffect == 'min') {
                                            var PercentageValue = parseInt(GetAsPercentage, 10);
                                            var lesSsizeValue = parseInt(GetAslesSsize, 10);
                                            var FontSize = 0;
                                            if (RenderW < SenseWidth) {

                                                var _PercentageToSize = RenderW * 100 / SenseWidth;
                                                var PercentageToSize = _PercentageToSize + PercentageValue;
                                                var SizePercentage = Size / PercentageToSize * 100;
                                                var InToSize = SizePercentage - Size;
                                                var FinalSize = Size - InToSize;
                                                var ToInt = parseInt(FinalSize, 10);
                                                FontSize = lesSsizeValue;
                                                if (ToInt > lesSsizeValue) {
                                                    FontSize = ToInt;
                                                }

                                            } else {
                                                FontSize = Size;
                                            }

                                            UpdateInnerCss += '.' + xValue + '{ ' + ' font-size:' + FontSize + 'px;  }';
                                        }
                                    }

                                } catch (e) { }

                            } catch (e) { }
                        }

                    } catch (e) { }
                }
            });

            StyleElement.innerHTML = UpdateInnerCss;
        }

    } catch (e) { }
}
function ECKeyEffects(IsInstall, CallEvent) {
    try {
        ECForeachElement('Tag', ['KeyEffects'], function (item, Value, Cc) {
            ECForeachDocument([item], ['Screen'], function (inode, NodeName, inCc) {
                var UseEvent = false;
                var GetEvent = "*";
                if (inode.getAttribute("event") != null && inode.getAttribute("event") != "") {
                    GetEvent = inode.getAttribute("event");
                }
                ECForeachComArray(GetEvent, function (cItem, Icc) {
                    if (CallEvent.toLowerCase() == cItem.toLowerCase()) {
                        UseEvent = true;
                    }
                });
                if (UseEvent == true) {
                    /*╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱*/
                    /*╔══════════ 💻 IF ( ? ? ? ) { ? ? ? } ═══════════════════════════════════════════════════════════════════════════════════════════════════════════════════════╗ */
                    ECForeachDocument([inode], ['if'], function (IFnode, IFNodeName, IFCc) {
                        var iftypeStr = IFnode.getAttribute("type");
                        var ifValue = ECConvertToCssValue(IFnode.getAttribute("value"));
                        var ifCommandStr = IFnode.getAttribute("command");
                        var ifMatch = ECConvertToCssValue(IFnode.getAttribute("match"));
                        /*▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧ INT & INT32 ▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧▣▧ */
                        if (iftypeStr.toLowerCase() == "int".toLowerCase() || iftypeStr.toLowerCase() == "int32".toLowerCase()) {
                            try {
                                var InpValue = parseInt(ifValue, 10);
                                var OutValue = parseInt(ifMatch, 10);
                                var UseAsRunInner = false;
                                var UseAsElseInner = false;
                                if (ifCommandStr.toLowerCase() == ">".toLowerCase()) {
                                    if (InpValue > OutValue) {
                                        UseAsRunInner = true;
                                    } else {
                                        UseAsElseInner = true;
                                    }
                                }
                                if (ifCommandStr.toLowerCase() == "<".toLowerCase()) {
                                    if (InpValue < OutValue) {
                                        UseAsRunInner = true;
                                    } else {
                                        UseAsElseInner = true;
                                    }
                                }
                                var UseAttribute = [null, false];
                                if (UseAsRunInner == true) {
                                    ECForeachDocument([IFnode], ['run'], function (RUNnode, RUNNodeName, RUNCc) {
                                        UseAttribute = [RUNnode, true];
                                    });
                                }
                                if (UseAsElseInner == true) {
                                    ECForeachDocument([IFnode], ['else'], function (RUNnode, RUNNodeName, RUNCc) {
                                        UseAttribute = [RUNnode, true];
                                    });
                                }

                                if (UseAttribute[1] == true) {
                                    /*☳☵☳☵☳☵ 🌟🌟 Attribute 🌟🌟 ☳☵☳☵☳☵☳☵☳☵☳☵☳☵☳☵☳☵☳☵☳☵☳☵☳☵☳☵☳☵☳☵☳☵☳☵☳☵☳☵☳☵☳☵☳☵☳☵☳☵☳☵  */
                                    ECForeachDocument([UseAttribute[0]], ['Attribute'], function (ATTERnode, ATTERNodeName, ATTERCc) {
                                        var AtterNames = ATTERnode.getAttribute("Names");
                                        var AtterType = ATTERnode.getAttribute("type");


                                        var AtterKey = ATTERnode.getAttribute("key");
                                        var AtterValue = ATTERnode.getAttribute("value");// ECConvertToCssValue(ATTERnode.getAttribute("value"));



                                        /*┏┳┳┳ 🔩 <Load Element> ┳┳┳┳┳┳┳┳┳┳┳┳┳┳┳┳┳┳┳┳┳┳┳┳┳┳┳┳┳┳┳┳┳┳┳┳┳┳┳┳┳┳┳┳┳┳┳┳┳┳┳┳┳┳┳┳┳┳┳┓*/
                                        ECForeachComArray(AtterNames, function (AtterName, NameItem) {
                                            var LoadElement = ECGetElementByName(AtterName);
                                            if (LoadElement != null) {
                                                if (AtterType.toLowerCase() == "set".toLowerCase()) {
                                                    var GetOldAtterValue = LoadElement.getAttribute(AtterKey);
                                                    if (GetOldAtterValue.toLowerCase() != AtterValue.toLowerCase()) {
                                                        LoadElement.setAttribute(AtterKey, AtterValue);

                                                    }
                                                }
                                            }

                                        });


                                        /*┗┻┻┻ 🔩 </Load Element> ┻┻┻┻┻┻┻┻┻┻┻┻┻┻┻┻┻┻┻┻┻┻┻┻┻┻┻┻┻┻┻┻┻┻┻┻┻┻┻┻┻┻┻┻┻┻┻┻┻┻┻┻┻┻┻┻┻┻┛*/



                                    });
                                }





                            } catch (e) { }
                        }


                        //  document.getElementById("GGHSSGSGSG").innerHTML = iftypeStr + " | " + ifValue + " | " + ifCommandStr + " | " + ifMatch;

                    });
                    /*╚══════════ 💻 IF ( ? ? ? ) { ? ? ? } ═══════════════════════════════════════════════════════════════════════════════════════════════════════════════════════╝ */
                    /*╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱*/

                }

            });
        });


    } catch (e) { }
}
/*╋╋ [ NOT COMPELETED ]╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋╋*/
/*⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛*/
/*◘◘◘◘◘◘◘◘◘ Decorator [ NOT COMPELETED ] ▲ ◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘*/
/*╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱*/
/*╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱*/
/*◘◘◘◘◘◘◘◘◘ Configuration ▼ ◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘*/
/*⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛*/
function ECPlayTimeLine(Streaming, GetAsObj, Duration, Speed, SetNewValue) {
    try {
        if (Streaming == "gpu") {
            try {

                if (SetNewValue != "*") {
                    GetAsObj.setAttribute("value", SetNewValue);
                }
                var getElementRenderId = GetAsObj.getAttribute("id");
                var ValueStr = "0";
                if (GetAsObj.getAttribute("value") != null && GetAsObj.getAttribute("value") != "") {
                    ValueStr = GetAsObj.getAttribute("value");
                }
                var KeyEffectStr = "*";
                if (GetAsObj.getAttribute("Execute") != null && GetAsObj.getAttribute("Execute") != "") {
                    KeyEffectStr = GetAsObj.getAttribute("Execute");
                }


                var Value = parseInt(ValueStr, 10);
                if (Value < ConstructAnimatedGPUTimeTick) {
                    // # 660
                    ConstructAnimatedGPUTimerCreateArray(GetAsObj, Value, "normal");
                }
                GetAsObj.setAttribute("status", "play");


                ConstructAnimatedGPUTimerTick(GetAsObj, getElementRenderId, Duration, Speed, Value, true, KeyEffectStr,false);

            } catch (e) {

            }
        }


    } catch (e) { }
}
function ECSetTracksTimeLine(GetAsObj, SetNewValue) {
    try {
        //var ValueStr = "0";
        //if (GetAsObj.getAttribute("value") != null && GetAsObj.getAttribute("value") != "")
        //{
        //    ValueStr = GetAsObj.getAttribute("value");
        //}
        //var Value = parseInt(ValueStr, 10);
        //ConstructAnimatedGPUTimerCreateArray(GetAsObj, Value, "normal");

        GetAsObj.setAttribute("tracks", SetNewValue);

    } catch (e) {

    }
}
var Constructor =
{
    Reload: function () {
        ECInitializing();
        ECComponentsInitializing();
    },
    Reevent: function () {
        ECResizeInitializing();
    },
    get Library() {
        var outers =
        {
            get Enum() {
                var outers = {
                    get ExportEncode() {
                        return { XML: 'XML', XEML: 'XEML', JSON: 'JSON', Base64: 'Encrypt', MI6Encrypt: 'MI6Encrypt' };
                        
                    }
                }
                return outers;
            }
        }
        return outers;
    },
    Sync: function (ReadElement) {
        var outers =
        {
            get BoardView() {
                var outers =
                {
                    ExportData: function (ExportType, CallBack) {
                        // CallBack("EXP :: " + ReadElement.RootId + " || " + ReadElement.Type);
                        try {
                            if (ReadElement.Type == "boardview") {
                                try {
                                    alert("No Install : NO.1035 !");

                                    if (ExportType == "XML") {
                                        //  alert(ExportType);
                                    }

                                } catch (e) { }
                            }

                        } catch (e) { }


                    }
                   , ImportData: function () {

                   }
                    , get ReadSelected() {
                        var xElement = null;
                        var xId = "";
                        var xTitle = "";
                        var xIconSrc = "";
                        try {
                            var MasterClassKey = "ecbv" + ReadElement.RootId.replace(/_/g, '');
                            MasterClassKey = MasterClassKey.toLowerCase();
                            var CLElements = document.getElementsByClassName(MasterClassKey);
                            for (var xci = 0; xci < CLElements.length; ++xci) {
                                var ClassItem = CLElements[xci];
                                var isSelected = ECConvertToBoolean(ClassItem.getAttribute("isSelected"));
                                if (isSelected == true) {
                                    xId = ClassItem.getAttribute("id");
                                    xElement = ClassItem;
                                }
                            }
                        } catch (e) {

                        }
                        return { Element: xElement, Id: xId, Title: xTitle, IconSrc: xIconSrc };
                    }
                    , RemoveSelected: function () {
                        try {
                            if (this.ReadSelected.Element != null) {
                                this.ReadSelected.Element.parentElement.removeChild(this.ReadSelected.Element);
                            }
                        } catch (e) { }
                    }
                    , InsertBoard: function (BoardItem) {
                        try {
                            var Nrid = "ContextMenuItem_" + ECRandomId();
                            var HtmlBoard = ECBoardViewCreateHtmlBoard(Nrid, ReadElement.RootId, BoardItem.Text, BoardItem.Icon, "icon", "", "VRD", BoardItem.AddOns);
                            ECBoardViewAddItemBoard(ReadElement.RootId, ECBoardViewEmptyItemBoardIndex(ReadElement.RootId, false), HtmlBoard);

                        } catch (e) { }
                    }
                }
                return outers;
            }
        }
        return outers;
    },
    GetComponentById: function (ObjectId) {
        var outers =
        {
            get Type() {
                
            },
            get RenderId() {
                 
            },
            get ReadElement() {
                var outers = null;
                try {

                    if (ObjectId.trim() != "") {
                        var GetAsElement = document.getElementById(ObjectId);
                        var getECK = GetAsElement.getAttribute("ec-key");
                        outers = { RootId: getECK, Type: GetAsElement.nodeName.toLowerCase() }
                    }


                } catch (e) { }
                return outers;
            }
        }
        return outers;
    },
    get Components() {
        var outers =
        {
            get BoardView() {
                var outers =
                {
                    TileIcon: function (TextTitle, IconSrc, AddonsData) {
                        return { Text: TextTitle, Icon: IconSrc, AddOns: AddonsData }
                    }
                }
                return outers;
            }
        }
        return outers;
    },
    GetTimelineByName: function (ObjectName) {
        var outers =
        {
            //#plkmnsf710
            /* Timeline Options >>->>->>->>->>->>->>->>->>->>->>->>->>->>->>->>->>->>->>->>->>->>->>->>->>->>->>->>->>->>->>->>->>->>->>->>- ▼ */
            /* Timeline Options >>->>->>->>->>->>->>->>->>->>->>->>->>->>->>->>->>->>->>->>->>->>->>->>->>->>->>->>->>->>->>->>->>->>->>->>- ▼ */
            set Value(value) {
                try {
                    var GetAsObj = ECGetElementByName(ObjectName);
                    if (GetAsObj != null) {
                        var _value = value;// + 1;
                        GetAsObj.setAttribute("value", value);
                    }

                } catch (e) { }
            },
            set Tracks(value) {
                try {
                    var GetAsObj = ECGetElementByName(ObjectName);
                    if (GetAsObj != null) {
                        GetAsObj.setAttribute("Tracks", value);
                    }

                } catch (e) { }
            },
            Play: function () {
                try {
                    var GetAsObj = ECGetElementByName(ObjectName);
                    if (GetAsObj != null) {
                        var StreamingStr = "cpu";
                        if (GetAsObj.getAttribute("streaming") != null && GetAsObj.getAttribute("streaming") != "") {
                            StreamingStr = GetAsObj.getAttribute("streaming");
                        }
                        var getElementRenderId = GetAsObj.getAttribute("id");
                        var DurationStr = "60";
                        if (GetAsObj.getAttribute("duration") != null && GetAsObj.getAttribute("duration") != "") {
                            DurationStr = GetAsObj.getAttribute("duration");
                        }
                        var SpeedStr = "1";
                        if (GetAsObj.getAttribute("speed") != null && GetAsObj.getAttribute("speed") != "") {
                            SpeedStr = GetAsObj.getAttribute("speed");
                        }
                        var Speed = parseInt(SpeedStr, 10);
                        var Duration = parseInt(DurationStr, 10);
                        var Streaming = "cpu"; if (StreamingStr.toLowerCase() == 'gpu') { Streaming = "gpu"; }
                        if (Streaming == "cpu") {
                            if (ECTimelineTimer != null) {
                                clearInterval(ECTimelineTimer);
                            }
                            GetAsObj.setAttribute("status", "play");
                            ECTimelineCreated = false;
                            ECTimeline(GetAsObj, null);
                        }
                        ECPlayTimeLine(Streaming, GetAsObj, Duration, Speed, "*");

                    }

                } catch (e) { }
            }
            /* Timeline Options >>->>->>->>->>->>->>->>->>->>->>->>->>->>->>->>->>->>->>->>->>->>->>->>->>->>->>->>->>->>->>->>->>->>->>->>- ▲ */
        }
        return outers;
    }
}
/*⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛⬛*/
/*◘◘◘◘◘◘◘◘◘ Configuration ▲ ◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘◘*/
/*╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱╱*/

